/*!
 * modernizr.min.js
 */
/*! modernizr 3.6.0 (Custom Build) | MIT *
 * https://modernizr.com/download/?-touchevents-domprefixes-prefixes-setclasses-testallprops-testprop-teststyles !*/
!(function (e, n, t) {
  function r(e, n) {
    return typeof e === n
  }
  function o() {
    var e, n, t, o, s, i, l
    for (var a in S)
      if (S.hasOwnProperty(a)) {
        if (
          ((e = []),
          (n = S[a]),
          n.name && (e.push(n.name.toLowerCase()), n.options && n.options.aliases && n.options.aliases.length))
        )
          for (t = 0; t < n.options.aliases.length; t++) e.push(n.options.aliases[t].toLowerCase())
        for (o = r(n.fn, 'function') ? n.fn() : n.fn, s = 0; s < e.length; s++)
          (i = e[s]),
            (l = i.split('.')),
            1 === l.length
              ? (Modernizr[l[0]] = o)
              : (!Modernizr[l[0]] ||
                  Modernizr[l[0]] instanceof Boolean ||
                  (Modernizr[l[0]] = new Boolean(Modernizr[l[0]])),
                (Modernizr[l[0]][l[1]] = o)),
            C.push((o ? '' : 'no-') + l.join('-'))
      }
  }
  function s(e) {
    var n = x.className,
      t = Modernizr._config.classPrefix || ''
    if ((b && (n = n.baseVal), Modernizr._config.enableJSClass)) {
      var r = new RegExp('(^|\\s)' + t + 'no-js(\\s|$)')
      n = n.replace(r, '$1' + t + 'js$2')
    }
    Modernizr._config.enableClasses &&
      ((n += ' ' + t + e.join(' ' + t)), b ? (x.className.baseVal = n) : (x.className = n))
  }
  function i(e, n) {
    return !!~('' + e).indexOf(n)
  }
  function l() {
    return 'function' != typeof n.createElement
      ? n.createElement(arguments[0])
      : b
      ? n.createElementNS.call(n, 'http://www.w3.org/2000/svg', arguments[0])
      : n.createElement.apply(n, arguments)
  }
  function a(e) {
    return e
      .replace(/([a-z])-([a-z])/g, function (e, n, t) {
        return n + t.toUpperCase()
      })
      .replace(/^-/, '')
  }
  function u() {
    var e = n.body
    return e || ((e = l(b ? 'svg' : 'body')), (e.fake = !0)), e
  }
  function f(e, t, r, o) {
    var s,
      i,
      a,
      f,
      c = 'modernizr',
      p = l('div'),
      d = u()
    if (parseInt(r, 10)) for (; r--; ) (a = l('div')), (a.id = o ? o[r] : c + (r + 1)), p.appendChild(a)
    return (
      (s = l('style')),
      (s.type = 'text/css'),
      (s.id = 's' + c),
      (d.fake ? d : p).appendChild(s),
      d.appendChild(p),
      s.styleSheet ? (s.styleSheet.cssText = e) : s.appendChild(n.createTextNode(e)),
      (p.id = c),
      d.fake &&
        ((d.style.background = ''),
        (d.style.overflow = 'hidden'),
        (f = x.style.overflow),
        (x.style.overflow = 'hidden'),
        x.appendChild(d)),
      (i = t(p, e)),
      d.fake ? (d.parentNode.removeChild(d), (x.style.overflow = f), x.offsetHeight) : p.parentNode.removeChild(p),
      !!i
    )
  }
  function c(e, n) {
    return function () {
      return e.apply(n, arguments)
    }
  }
  function p(e, n, t) {
    var o
    for (var s in e) if (e[s] in n) return t === !1 ? e[s] : ((o = n[e[s]]), r(o, 'function') ? c(o, t || n) : o)
    return !1
  }
  function d(e) {
    return e
      .replace(/([A-Z])/g, function (e, n) {
        return '-' + n.toLowerCase()
      })
      .replace(/^ms-/, '-ms-')
  }
  function m(n, t, r) {
    var o
    if ('getComputedStyle' in e) {
      o = getComputedStyle.call(e, n, t)
      var s = e.console
      if (null !== o) r && (o = o.getPropertyValue(r))
      else if (s) {
        var i = s.error ? 'error' : 'log'
        s[i].call(s, 'getComputedStyle returning null, its possible modernizr test results are inaccurate')
      }
    } else o = !t && n.currentStyle && n.currentStyle[r]
    return o
  }
  function h(n, r) {
    var o = n.length
    if ('CSS' in e && 'supports' in e.CSS) {
      for (; o--; ) if (e.CSS.supports(d(n[o]), r)) return !0
      return !1
    }
    if ('CSSSupportsRule' in e) {
      for (var s = []; o--; ) s.push('(' + d(n[o]) + ':' + r + ')')
      return (
        (s = s.join(' or ')),
        f('@supports (' + s + ') { #modernizr { position: absolute; } }', function (e) {
          return 'absolute' == m(e, null, 'position')
        })
      )
    }
    return t
  }
  function v(e, n, o, s) {
    function u() {
      c && (delete N.style, delete N.modElem)
    }
    if (((s = r(s, 'undefined') ? !1 : s), !r(o, 'undefined'))) {
      var f = h(e, o)
      if (!r(f, 'undefined')) return f
    }
    for (var c, p, d, m, v, y = ['modernizr', 'tspan', 'samp']; !N.style && y.length; )
      (c = !0), (N.modElem = l(y.shift())), (N.style = N.modElem.style)
    for (d = e.length, p = 0; d > p; p++)
      if (((m = e[p]), (v = N.style[m]), i(m, '-') && (m = a(m)), N.style[m] !== t)) {
        if (s || r(o, 'undefined')) return u(), 'pfx' == n ? m : !0
        try {
          N.style[m] = o
        } catch (g) {}
        if (N.style[m] != v) return u(), 'pfx' == n ? m : !0
      }
    return u(), !1
  }
  function y(e, n, t, o, s) {
    var i = e.charAt(0).toUpperCase() + e.slice(1),
      l = (e + ' ' + T.join(i + ' ') + i).split(' ')
    return r(n, 'string') || r(n, 'undefined')
      ? v(l, n, o, s)
      : ((l = (e + ' ' + P.join(i + ' ') + i).split(' ')), p(l, n, t))
  }
  function g(e, n, r) {
    return y(e, t, t, n, r)
  }
  var C = [],
    S = [],
    w = {
      _version: '3.6.0',
      _config: { classPrefix: '', enableClasses: !0, enableJSClass: !0, usePrefixes: !0 },
      _q: [],
      on: function (e, n) {
        var t = this
        setTimeout(function () {
          n(t[e])
        }, 0)
      },
      addTest: function (e, n, t) {
        S.push({ name: e, fn: n, options: t })
      },
      addAsyncTest: function (e) {
        S.push({ name: null, fn: e })
      }
    },
    Modernizr = function () {}
  ;(Modernizr.prototype = w), (Modernizr = new Modernizr())
  var _ = w._config.usePrefixes ? ' -webkit- -moz- -o- -ms- '.split(' ') : ['', '']
  w._prefixes = _
  var x = n.documentElement,
    b = 'svg' === x.nodeName.toLowerCase(),
    z = 'Moz O ms Webkit',
    P = w._config.usePrefixes ? z.toLowerCase().split(' ') : []
  w._domPrefixes = P
  var T = w._config.usePrefixes ? z.split(' ') : []
  w._cssomPrefixes = T
  var E = (w.testStyles = f)
  Modernizr.addTest('touchevents', function () {
    var t
    if ('ontouchstart' in e || (e.DocumentTouch && n instanceof DocumentTouch)) t = !0
    else {
      var r = ['@media (', _.join('touch-enabled),('), 'heartz', ')', '{#modernizr{top:9px;position:absolute}}'].join(
        ''
      )
      E(r, function (e) {
        t = 9 === e.offsetTop
      })
    }
    return t
  })
  var j = { elem: l('modernizr') }
  Modernizr._q.push(function () {
    delete j.elem
  })
  var N = { style: j.elem.style }
  Modernizr._q.unshift(function () {
    delete N.style
  })
  w.testProp = function (e, n, r) {
    return v([e], t, n, r)
  }
  ;(w.testAllProps = y), (w.testAllProps = g), o(), s(C), delete w.addTest, delete w.addAsyncTest
  for (var k = 0; k < Modernizr._q.length; k++) Modernizr._q[k]()
  e.Modernizr = Modernizr
})(window, document)


/*!
 * jquery-2.2.3.min.js
 */
/*! jQuery v2.2.3 | (c) jQuery Foundation | jquery.org/license */
!(function (a, b) {
  'object' == typeof module && 'object' == typeof module.exports
    ? (module.exports = a.document
        ? b(a, !0)
        : function (a) {
            if (!a.document) throw new Error('jQuery requires a window with a document')
            return b(a)
          })
    : b(a)
})('undefined' != typeof window ? window : this, function (a, b) {
  var c = [],
    d = a.document,
    e = c.slice,
    f = c.concat,
    g = c.push,
    h = c.indexOf,
    i = {},
    j = i.toString,
    k = i.hasOwnProperty,
    l = {},
    m = '2.2.3',
    n = function (a, b) {
      return new n.fn.init(a, b)
    },
    o = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,
    p = /^-ms-/,
    q = /-([\da-z])/gi,
    r = function (a, b) {
      return b.toUpperCase()
    }
  ;(n.fn = n.prototype =
    {
      jquery: m,
      constructor: n,
      selector: '',
      length: 0,
      toArray: function () {
        return e.call(this)
      },
      get: function (a) {
        return null != a ? (0 > a ? this[a + this.length] : this[a]) : e.call(this)
      },
      pushStack: function (a) {
        var b = n.merge(this.constructor(), a)
        return (b.prevObject = this), (b.context = this.context), b
      },
      each: function (a) {
        return n.each(this, a)
      },
      map: function (a) {
        return this.pushStack(
          n.map(this, function (b, c) {
            return a.call(b, c, b)
          })
        )
      },
      slice: function () {
        return this.pushStack(e.apply(this, arguments))
      },
      first: function () {
        return this.eq(0)
      },
      last: function () {
        return this.eq(-1)
      },
      eq: function (a) {
        var b = this.length,
          c = +a + (0 > a ? b : 0)
        return this.pushStack(c >= 0 && b > c ? [this[c]] : [])
      },
      end: function () {
        return this.prevObject || this.constructor()
      },
      push: g,
      sort: c.sort,
      splice: c.splice
    }),
    (n.extend = n.fn.extend =
      function () {
        var a,
          b,
          c,
          d,
          e,
          f,
          g = arguments[0] || {},
          h = 1,
          i = arguments.length,
          j = !1
        for (
          'boolean' == typeof g && ((j = g), (g = arguments[h] || {}), h++),
            'object' == typeof g || n.isFunction(g) || (g = {}),
            h === i && ((g = this), h--);
          i > h;
          h++
        )
          if (null != (a = arguments[h]))
            for (b in a)
              (c = g[b]),
                (d = a[b]),
                g !== d &&
                  (j && d && (n.isPlainObject(d) || (e = n.isArray(d)))
                    ? (e ? ((e = !1), (f = c && n.isArray(c) ? c : [])) : (f = c && n.isPlainObject(c) ? c : {}),
                      (g[b] = n.extend(j, f, d)))
                    : void 0 !== d && (g[b] = d))
        return g
      }),
    n.extend({
      expando: 'jQuery' + (m + Math.random()).replace(/\D/g, ''),
      isReady: !0,
      error: function (a) {
        throw new Error(a)
      },
      noop: function () {},
      isFunction: function (a) {
        return 'function' === n.type(a)
      },
      isArray: Array.isArray,
      isWindow: function (a) {
        return null != a && a === a.window
      },
      isNumeric: function (a) {
        var b = a && a.toString()
        return !n.isArray(a) && b - parseFloat(b) + 1 >= 0
      },
      isPlainObject: function (a) {
        var b
        if ('object' !== n.type(a) || a.nodeType || n.isWindow(a)) return !1
        if (a.constructor && !k.call(a, 'constructor') && !k.call(a.constructor.prototype || {}, 'isPrototypeOf'))
          return !1
        for (b in a);
        return void 0 === b || k.call(a, b)
      },
      isEmptyObject: function (a) {
        var b
        for (b in a) return !1
        return !0
      },
      type: function (a) {
        return null == a ? a + '' : 'object' == typeof a || 'function' == typeof a ? i[j.call(a)] || 'object' : typeof a
      },
      globalEval: function (a) {
        var b,
          c = eval
        ;(a = n.trim(a)),
          a &&
            (1 === a.indexOf('use strict')
              ? ((b = d.createElement('script')), (b.text = a), d.head.appendChild(b).parentNode.removeChild(b))
              : c(a))
      },
      camelCase: function (a) {
        return a.replace(p, 'ms-').replace(q, r)
      },
      nodeName: function (a, b) {
        return a.nodeName && a.nodeName.toLowerCase() === b.toLowerCase()
      },
      each: function (a, b) {
        var c,
          d = 0
        if (s(a)) {
          for (c = a.length; c > d; d++) if (b.call(a[d], d, a[d]) === !1) break
        } else for (d in a) if (b.call(a[d], d, a[d]) === !1) break
        return a
      },
      trim: function (a) {
        return null == a ? '' : (a + '').replace(o, '')
      },
      makeArray: function (a, b) {
        var c = b || []
        return null != a && (s(Object(a)) ? n.merge(c, 'string' == typeof a ? [a] : a) : g.call(c, a)), c
      },
      inArray: function (a, b, c) {
        return null == b ? -1 : h.call(b, a, c)
      },
      merge: function (a, b) {
        for (var c = +b.length, d = 0, e = a.length; c > d; d++) a[e++] = b[d]
        return (a.length = e), a
      },
      grep: function (a, b, c) {
        for (var d, e = [], f = 0, g = a.length, h = !c; g > f; f++) (d = !b(a[f], f)), d !== h && e.push(a[f])
        return e
      },
      map: function (a, b, c) {
        var d,
          e,
          g = 0,
          h = []
        if (s(a)) for (d = a.length; d > g; g++) (e = b(a[g], g, c)), null != e && h.push(e)
        else for (g in a) (e = b(a[g], g, c)), null != e && h.push(e)
        return f.apply([], h)
      },
      guid: 1,
      proxy: function (a, b) {
        var c, d, f
        return (
          'string' == typeof b && ((c = a[b]), (b = a), (a = c)),
          n.isFunction(a)
            ? ((d = e.call(arguments, 2)),
              (f = function () {
                return a.apply(b || this, d.concat(e.call(arguments)))
              }),
              (f.guid = a.guid = a.guid || n.guid++),
              f)
            : void 0
        )
      },
      now: Date.now,
      support: l
    }),
    'function' == typeof Symbol && (n.fn[Symbol.iterator] = c[Symbol.iterator]),
    n.each('Boolean Number String Function Array Date RegExp Object Error Symbol'.split(' '), function (a, b) {
      i['[object ' + b + ']'] = b.toLowerCase()
    })
  function s(a) {
    var b = !!a && 'length' in a && a.length,
      c = n.type(a)
    return 'function' === c || n.isWindow(a)
      ? !1
      : 'array' === c || 0 === b || ('number' == typeof b && b > 0 && b - 1 in a)
  }
  var t = (function (a) {
    var b,
      c,
      d,
      e,
      f,
      g,
      h,
      i,
      j,
      k,
      l,
      m,
      n,
      o,
      p,
      q,
      r,
      s,
      t,
      u = 'sizzle' + 1 * new Date(),
      v = a.document,
      w = 0,
      x = 0,
      y = ga(),
      z = ga(),
      A = ga(),
      B = function (a, b) {
        return a === b && (l = !0), 0
      },
      C = 1 << 31,
      D = {}.hasOwnProperty,
      E = [],
      F = E.pop,
      G = E.push,
      H = E.push,
      I = E.slice,
      J = function (a, b) {
        for (var c = 0, d = a.length; d > c; c++) if (a[c] === b) return c
        return -1
      },
      K =
        'checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped',
      L = '[\\x20\\t\\r\\n\\f]',
      M = '(?:\\\\.|[\\w-]|[^\\x00-\\xa0])+',
      N =
        '\\[' +
        L +
        '*(' +
        M +
        ')(?:' +
        L +
        '*([*^$|!~]?=)' +
        L +
        '*(?:\'((?:\\\\.|[^\\\\\'])*)\'|"((?:\\\\.|[^\\\\"])*)"|(' +
        M +
        '))|)' +
        L +
        '*\\]',
      O =
        ':(' +
        M +
        ')(?:\\(((\'((?:\\\\.|[^\\\\\'])*)\'|"((?:\\\\.|[^\\\\"])*)")|((?:\\\\.|[^\\\\()[\\]]|' +
        N +
        ')*)|.*)\\)|)',
      P = new RegExp(L + '+', 'g'),
      Q = new RegExp('^' + L + '+|((?:^|[^\\\\])(?:\\\\.)*)' + L + '+$', 'g'),
      R = new RegExp('^' + L + '*,' + L + '*'),
      S = new RegExp('^' + L + '*([>+~]|' + L + ')' + L + '*'),
      T = new RegExp('=' + L + '*([^\\]\'"]*?)' + L + '*\\]', 'g'),
      U = new RegExp(O),
      V = new RegExp('^' + M + '$'),
      W = {
        ID: new RegExp('^#(' + M + ')'),
        CLASS: new RegExp('^\\.(' + M + ')'),
        TAG: new RegExp('^(' + M + '|[*])'),
        ATTR: new RegExp('^' + N),
        PSEUDO: new RegExp('^' + O),
        CHILD: new RegExp(
          '^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(' +
            L +
            '*(even|odd|(([+-]|)(\\d*)n|)' +
            L +
            '*(?:([+-]|)' +
            L +
            '*(\\d+)|))' +
            L +
            '*\\)|)',
          'i'
        ),
        bool: new RegExp('^(?:' + K + ')$', 'i'),
        needsContext: new RegExp(
          '^' +
            L +
            '*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(' +
            L +
            '*((?:-\\d)?\\d*)' +
            L +
            '*\\)|)(?=[^-]|$)',
          'i'
        )
      },
      X = /^(?:input|select|textarea|button)$/i,
      Y = /^h\d$/i,
      Z = /^[^{]+\{\s*\[native \w/,
      $ = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
      _ = /[+~]/,
      aa = /'|\\/g,
      ba = new RegExp('\\\\([\\da-f]{1,6}' + L + '?|(' + L + ')|.)', 'ig'),
      ca = function (a, b, c) {
        var d = '0x' + b - 65536
        return d !== d || c
          ? b
          : 0 > d
          ? String.fromCharCode(d + 65536)
          : String.fromCharCode((d >> 10) | 55296, (1023 & d) | 56320)
      },
      da = function () {
        m()
      }
    try {
      H.apply((E = I.call(v.childNodes)), v.childNodes), E[v.childNodes.length].nodeType
    } catch (ea) {
      H = {
        apply: E.length
          ? function (a, b) {
              G.apply(a, I.call(b))
            }
          : function (a, b) {
              var c = a.length,
                d = 0
              while ((a[c++] = b[d++]));
              a.length = c - 1
            }
      }
    }
    function fa(a, b, d, e) {
      var f,
        h,
        j,
        k,
        l,
        o,
        r,
        s,
        w = b && b.ownerDocument,
        x = b ? b.nodeType : 9
      if (((d = d || []), 'string' != typeof a || !a || (1 !== x && 9 !== x && 11 !== x))) return d
      if (!e && ((b ? b.ownerDocument || b : v) !== n && m(b), (b = b || n), p)) {
        if (11 !== x && (o = $.exec(a)))
          if ((f = o[1])) {
            if (9 === x) {
              if (!(j = b.getElementById(f))) return d
              if (j.id === f) return d.push(j), d
            } else if (w && (j = w.getElementById(f)) && t(b, j) && j.id === f) return d.push(j), d
          } else {
            if (o[2]) return H.apply(d, b.getElementsByTagName(a)), d
            if ((f = o[3]) && c.getElementsByClassName && b.getElementsByClassName)
              return H.apply(d, b.getElementsByClassName(f)), d
          }
        if (c.qsa && !A[a + ' '] && (!q || !q.test(a))) {
          if (1 !== x) (w = b), (s = a)
          else if ('object' !== b.nodeName.toLowerCase()) {
            ;(k = b.getAttribute('id')) ? (k = k.replace(aa, '\\$&')) : b.setAttribute('id', (k = u)),
              (r = g(a)),
              (h = r.length),
              (l = V.test(k) ? '#' + k : "[id='" + k + "']")
            while (h--) r[h] = l + ' ' + qa(r[h])
            ;(s = r.join(',')), (w = (_.test(a) && oa(b.parentNode)) || b)
          }
          if (s)
            try {
              return H.apply(d, w.querySelectorAll(s)), d
            } catch (y) {
            } finally {
              k === u && b.removeAttribute('id')
            }
        }
      }
      return i(a.replace(Q, '$1'), b, d, e)
    }
    function ga() {
      var a = []
      function b(c, e) {
        return a.push(c + ' ') > d.cacheLength && delete b[a.shift()], (b[c + ' '] = e)
      }
      return b
    }
    function ha(a) {
      return (a[u] = !0), a
    }
    function ia(a) {
      var b = n.createElement('div')
      try {
        return !!a(b)
      } catch (c) {
        return !1
      } finally {
        b.parentNode && b.parentNode.removeChild(b), (b = null)
      }
    }
    function ja(a, b) {
      var c = a.split('|'),
        e = c.length
      while (e--) d.attrHandle[c[e]] = b
    }
    function ka(a, b) {
      var c = b && a,
        d = c && 1 === a.nodeType && 1 === b.nodeType && (~b.sourceIndex || C) - (~a.sourceIndex || C)
      if (d) return d
      if (c) while ((c = c.nextSibling)) if (c === b) return -1
      return a ? 1 : -1
    }
    function la(a) {
      return function (b) {
        var c = b.nodeName.toLowerCase()
        return 'input' === c && b.type === a
      }
    }
    function ma(a) {
      return function (b) {
        var c = b.nodeName.toLowerCase()
        return ('input' === c || 'button' === c) && b.type === a
      }
    }
    function na(a) {
      return ha(function (b) {
        return (
          (b = +b),
          ha(function (c, d) {
            var e,
              f = a([], c.length, b),
              g = f.length
            while (g--) c[(e = f[g])] && (c[e] = !(d[e] = c[e]))
          })
        )
      })
    }
    function oa(a) {
      return a && 'undefined' != typeof a.getElementsByTagName && a
    }
    ;(c = fa.support = {}),
      (f = fa.isXML =
        function (a) {
          var b = a && (a.ownerDocument || a).documentElement
          return b ? 'HTML' !== b.nodeName : !1
        }),
      (m = fa.setDocument =
        function (a) {
          var b,
            e,
            g = a ? a.ownerDocument || a : v
          return g !== n && 9 === g.nodeType && g.documentElement
            ? ((n = g),
              (o = n.documentElement),
              (p = !f(n)),
              (e = n.defaultView) &&
                e.top !== e &&
                (e.addEventListener
                  ? e.addEventListener('unload', da, !1)
                  : e.attachEvent && e.attachEvent('onunload', da)),
              (c.attributes = ia(function (a) {
                return (a.className = 'i'), !a.getAttribute('className')
              })),
              (c.getElementsByTagName = ia(function (a) {
                return a.appendChild(n.createComment('')), !a.getElementsByTagName('*').length
              })),
              (c.getElementsByClassName = Z.test(n.getElementsByClassName)),
              (c.getById = ia(function (a) {
                return (o.appendChild(a).id = u), !n.getElementsByName || !n.getElementsByName(u).length
              })),
              c.getById
                ? ((d.find.ID = function (a, b) {
                    if ('undefined' != typeof b.getElementById && p) {
                      var c = b.getElementById(a)
                      return c ? [c] : []
                    }
                  }),
                  (d.filter.ID = function (a) {
                    var b = a.replace(ba, ca)
                    return function (a) {
                      return a.getAttribute('id') === b
                    }
                  }))
                : (delete d.find.ID,
                  (d.filter.ID = function (a) {
                    var b = a.replace(ba, ca)
                    return function (a) {
                      var c = 'undefined' != typeof a.getAttributeNode && a.getAttributeNode('id')
                      return c && c.value === b
                    }
                  })),
              (d.find.TAG = c.getElementsByTagName
                ? function (a, b) {
                    return 'undefined' != typeof b.getElementsByTagName
                      ? b.getElementsByTagName(a)
                      : c.qsa
                      ? b.querySelectorAll(a)
                      : void 0
                  }
                : function (a, b) {
                    var c,
                      d = [],
                      e = 0,
                      f = b.getElementsByTagName(a)
                    if ('*' === a) {
                      while ((c = f[e++])) 1 === c.nodeType && d.push(c)
                      return d
                    }
                    return f
                  }),
              (d.find.CLASS =
                c.getElementsByClassName &&
                function (a, b) {
                  return 'undefined' != typeof b.getElementsByClassName && p ? b.getElementsByClassName(a) : void 0
                }),
              (r = []),
              (q = []),
              (c.qsa = Z.test(n.querySelectorAll)) &&
                (ia(function (a) {
                  ;(o.appendChild(a).innerHTML =
                    "<a id='" +
                    u +
                    "'></a><select id='" +
                    u +
                    "-\r\\' msallowcapture=''><option selected=''></option></select>"),
                    a.querySelectorAll("[msallowcapture^='']").length && q.push('[*^$]=' + L + '*(?:\'\'|"")'),
                    a.querySelectorAll('[selected]').length || q.push('\\[' + L + '*(?:value|' + K + ')'),
                    a.querySelectorAll('[id~=' + u + '-]').length || q.push('~='),
                    a.querySelectorAll(':checked').length || q.push(':checked'),
                    a.querySelectorAll('a#' + u + '+*').length || q.push('.#.+[+~]')
                }),
                ia(function (a) {
                  var b = n.createElement('input')
                  b.setAttribute('type', 'hidden'),
                    a.appendChild(b).setAttribute('name', 'D'),
                    a.querySelectorAll('[name=d]').length && q.push('name' + L + '*[*^$|!~]?='),
                    a.querySelectorAll(':enabled').length || q.push(':enabled', ':disabled'),
                    a.querySelectorAll('*,:x'),
                    q.push(',.*:')
                })),
              (c.matchesSelector = Z.test(
                (s =
                  o.matches ||
                  o.webkitMatchesSelector ||
                  o.mozMatchesSelector ||
                  o.oMatchesSelector ||
                  o.msMatchesSelector)
              )) &&
                ia(function (a) {
                  ;(c.disconnectedMatch = s.call(a, 'div')), s.call(a, "[s!='']:x"), r.push('!=', O)
                }),
              (q = q.length && new RegExp(q.join('|'))),
              (r = r.length && new RegExp(r.join('|'))),
              (b = Z.test(o.compareDocumentPosition)),
              (t =
                b || Z.test(o.contains)
                  ? function (a, b) {
                      var c = 9 === a.nodeType ? a.documentElement : a,
                        d = b && b.parentNode
                      return (
                        a === d ||
                        !(
                          !d ||
                          1 !== d.nodeType ||
                          !(c.contains ? c.contains(d) : a.compareDocumentPosition && 16 & a.compareDocumentPosition(d))
                        )
                      )
                    }
                  : function (a, b) {
                      if (b) while ((b = b.parentNode)) if (b === a) return !0
                      return !1
                    }),
              (B = b
                ? function (a, b) {
                    if (a === b) return (l = !0), 0
                    var d = !a.compareDocumentPosition - !b.compareDocumentPosition
                    return d
                      ? d
                      : ((d = (a.ownerDocument || a) === (b.ownerDocument || b) ? a.compareDocumentPosition(b) : 1),
                        1 & d || (!c.sortDetached && b.compareDocumentPosition(a) === d)
                          ? a === n || (a.ownerDocument === v && t(v, a))
                            ? -1
                            : b === n || (b.ownerDocument === v && t(v, b))
                            ? 1
                            : k
                            ? J(k, a) - J(k, b)
                            : 0
                          : 4 & d
                          ? -1
                          : 1)
                  }
                : function (a, b) {
                    if (a === b) return (l = !0), 0
                    var c,
                      d = 0,
                      e = a.parentNode,
                      f = b.parentNode,
                      g = [a],
                      h = [b]
                    if (!e || !f) return a === n ? -1 : b === n ? 1 : e ? -1 : f ? 1 : k ? J(k, a) - J(k, b) : 0
                    if (e === f) return ka(a, b)
                    c = a
                    while ((c = c.parentNode)) g.unshift(c)
                    c = b
                    while ((c = c.parentNode)) h.unshift(c)
                    while (g[d] === h[d]) d++
                    return d ? ka(g[d], h[d]) : g[d] === v ? -1 : h[d] === v ? 1 : 0
                  }),
              n)
            : n
        }),
      (fa.matches = function (a, b) {
        return fa(a, null, null, b)
      }),
      (fa.matchesSelector = function (a, b) {
        if (
          ((a.ownerDocument || a) !== n && m(a),
          (b = b.replace(T, "='$1']")),
          c.matchesSelector && p && !A[b + ' '] && (!r || !r.test(b)) && (!q || !q.test(b)))
        )
          try {
            var d = s.call(a, b)
            if (d || c.disconnectedMatch || (a.document && 11 !== a.document.nodeType)) return d
          } catch (e) {}
        return fa(b, n, null, [a]).length > 0
      }),
      (fa.contains = function (a, b) {
        return (a.ownerDocument || a) !== n && m(a), t(a, b)
      }),
      (fa.attr = function (a, b) {
        ;(a.ownerDocument || a) !== n && m(a)
        var e = d.attrHandle[b.toLowerCase()],
          f = e && D.call(d.attrHandle, b.toLowerCase()) ? e(a, b, !p) : void 0
        return void 0 !== f
          ? f
          : c.attributes || !p
          ? a.getAttribute(b)
          : (f = a.getAttributeNode(b)) && f.specified
          ? f.value
          : null
      }),
      (fa.error = function (a) {
        throw new Error('Syntax error, unrecognized expression: ' + a)
      }),
      (fa.uniqueSort = function (a) {
        var b,
          d = [],
          e = 0,
          f = 0
        if (((l = !c.detectDuplicates), (k = !c.sortStable && a.slice(0)), a.sort(B), l)) {
          while ((b = a[f++])) b === a[f] && (e = d.push(f))
          while (e--) a.splice(d[e], 1)
        }
        return (k = null), a
      }),
      (e = fa.getText =
        function (a) {
          var b,
            c = '',
            d = 0,
            f = a.nodeType
          if (f) {
            if (1 === f || 9 === f || 11 === f) {
              if ('string' == typeof a.textContent) return a.textContent
              for (a = a.firstChild; a; a = a.nextSibling) c += e(a)
            } else if (3 === f || 4 === f) return a.nodeValue
          } else while ((b = a[d++])) c += e(b)
          return c
        }),
      (d = fa.selectors =
        {
          cacheLength: 50,
          createPseudo: ha,
          match: W,
          attrHandle: {},
          find: {},
          relative: {
            '>': { dir: 'parentNode', first: !0 },
            ' ': { dir: 'parentNode' },
            '+': { dir: 'previousSibling', first: !0 },
            '~': { dir: 'previousSibling' }
          },
          preFilter: {
            ATTR: function (a) {
              return (
                (a[1] = a[1].replace(ba, ca)),
                (a[3] = (a[3] || a[4] || a[5] || '').replace(ba, ca)),
                '~=' === a[2] && (a[3] = ' ' + a[3] + ' '),
                a.slice(0, 4)
              )
            },
            CHILD: function (a) {
              return (
                (a[1] = a[1].toLowerCase()),
                'nth' === a[1].slice(0, 3)
                  ? (a[3] || fa.error(a[0]),
                    (a[4] = +(a[4] ? a[5] + (a[6] || 1) : 2 * ('even' === a[3] || 'odd' === a[3]))),
                    (a[5] = +(a[7] + a[8] || 'odd' === a[3])))
                  : a[3] && fa.error(a[0]),
                a
              )
            },
            PSEUDO: function (a) {
              var b,
                c = !a[6] && a[2]
              return W.CHILD.test(a[0])
                ? null
                : (a[3]
                    ? (a[2] = a[4] || a[5] || '')
                    : c &&
                      U.test(c) &&
                      (b = g(c, !0)) &&
                      (b = c.indexOf(')', c.length - b) - c.length) &&
                      ((a[0] = a[0].slice(0, b)), (a[2] = c.slice(0, b))),
                  a.slice(0, 3))
            }
          },
          filter: {
            TAG: function (a) {
              var b = a.replace(ba, ca).toLowerCase()
              return '*' === a
                ? function () {
                    return !0
                  }
                : function (a) {
                    return a.nodeName && a.nodeName.toLowerCase() === b
                  }
            },
            CLASS: function (a) {
              var b = y[a + ' ']
              return (
                b ||
                ((b = new RegExp('(^|' + L + ')' + a + '(' + L + '|$)')) &&
                  y(a, function (a) {
                    return b.test(
                      ('string' == typeof a.className && a.className) ||
                        ('undefined' != typeof a.getAttribute && a.getAttribute('class')) ||
                        ''
                    )
                  }))
              )
            },
            ATTR: function (a, b, c) {
              return function (d) {
                var e = fa.attr(d, a)
                return null == e
                  ? '!=' === b
                  : b
                  ? ((e += ''),
                    '=' === b
                      ? e === c
                      : '!=' === b
                      ? e !== c
                      : '^=' === b
                      ? c && 0 === e.indexOf(c)
                      : '*=' === b
                      ? c && e.indexOf(c) > -1
                      : '$=' === b
                      ? c && e.slice(-c.length) === c
                      : '~=' === b
                      ? (' ' + e.replace(P, ' ') + ' ').indexOf(c) > -1
                      : '|=' === b
                      ? e === c || e.slice(0, c.length + 1) === c + '-'
                      : !1)
                  : !0
              }
            },
            CHILD: function (a, b, c, d, e) {
              var f = 'nth' !== a.slice(0, 3),
                g = 'last' !== a.slice(-4),
                h = 'of-type' === b
              return 1 === d && 0 === e
                ? function (a) {
                    return !!a.parentNode
                  }
                : function (b, c, i) {
                    var j,
                      k,
                      l,
                      m,
                      n,
                      o,
                      p = f !== g ? 'nextSibling' : 'previousSibling',
                      q = b.parentNode,
                      r = h && b.nodeName.toLowerCase(),
                      s = !i && !h,
                      t = !1
                    if (q) {
                      if (f) {
                        while (p) {
                          m = b
                          while ((m = m[p])) if (h ? m.nodeName.toLowerCase() === r : 1 === m.nodeType) return !1
                          o = p = 'only' === a && !o && 'nextSibling'
                        }
                        return !0
                      }
                      if (((o = [g ? q.firstChild : q.lastChild]), g && s)) {
                        ;(m = q),
                          (l = m[u] || (m[u] = {})),
                          (k = l[m.uniqueID] || (l[m.uniqueID] = {})),
                          (j = k[a] || []),
                          (n = j[0] === w && j[1]),
                          (t = n && j[2]),
                          (m = n && q.childNodes[n])
                        while ((m = (++n && m && m[p]) || (t = n = 0) || o.pop()))
                          if (1 === m.nodeType && ++t && m === b) {
                            k[a] = [w, n, t]
                            break
                          }
                      } else if (
                        (s &&
                          ((m = b),
                          (l = m[u] || (m[u] = {})),
                          (k = l[m.uniqueID] || (l[m.uniqueID] = {})),
                          (j = k[a] || []),
                          (n = j[0] === w && j[1]),
                          (t = n)),
                        t === !1)
                      )
                        while ((m = (++n && m && m[p]) || (t = n = 0) || o.pop()))
                          if (
                            (h ? m.nodeName.toLowerCase() === r : 1 === m.nodeType) &&
                            ++t &&
                            (s &&
                              ((l = m[u] || (m[u] = {})), (k = l[m.uniqueID] || (l[m.uniqueID] = {})), (k[a] = [w, t])),
                            m === b)
                          )
                            break
                      return (t -= e), t === d || (t % d === 0 && t / d >= 0)
                    }
                  }
            },
            PSEUDO: function (a, b) {
              var c,
                e = d.pseudos[a] || d.setFilters[a.toLowerCase()] || fa.error('unsupported pseudo: ' + a)
              return e[u]
                ? e(b)
                : e.length > 1
                ? ((c = [a, a, '', b]),
                  d.setFilters.hasOwnProperty(a.toLowerCase())
                    ? ha(function (a, c) {
                        var d,
                          f = e(a, b),
                          g = f.length
                        while (g--) (d = J(a, f[g])), (a[d] = !(c[d] = f[g]))
                      })
                    : function (a) {
                        return e(a, 0, c)
                      })
                : e
            }
          },
          pseudos: {
            not: ha(function (a) {
              var b = [],
                c = [],
                d = h(a.replace(Q, '$1'))
              return d[u]
                ? ha(function (a, b, c, e) {
                    var f,
                      g = d(a, null, e, []),
                      h = a.length
                    while (h--) (f = g[h]) && (a[h] = !(b[h] = f))
                  })
                : function (a, e, f) {
                    return (b[0] = a), d(b, null, f, c), (b[0] = null), !c.pop()
                  }
            }),
            has: ha(function (a) {
              return function (b) {
                return fa(a, b).length > 0
              }
            }),
            contains: ha(function (a) {
              return (
                (a = a.replace(ba, ca)),
                function (b) {
                  return (b.textContent || b.innerText || e(b)).indexOf(a) > -1
                }
              )
            }),
            lang: ha(function (a) {
              return (
                V.test(a || '') || fa.error('unsupported lang: ' + a),
                (a = a.replace(ba, ca).toLowerCase()),
                function (b) {
                  var c
                  do
                    if ((c = p ? b.lang : b.getAttribute('xml:lang') || b.getAttribute('lang')))
                      return (c = c.toLowerCase()), c === a || 0 === c.indexOf(a + '-')
                  while ((b = b.parentNode) && 1 === b.nodeType)
                  return !1
                }
              )
            }),
            target: function (b) {
              var c = a.location && a.location.hash
              return c && c.slice(1) === b.id
            },
            root: function (a) {
              return a === o
            },
            focus: function (a) {
              return a === n.activeElement && (!n.hasFocus || n.hasFocus()) && !!(a.type || a.href || ~a.tabIndex)
            },
            enabled: function (a) {
              return a.disabled === !1
            },
            disabled: function (a) {
              return a.disabled === !0
            },
            checked: function (a) {
              var b = a.nodeName.toLowerCase()
              return ('input' === b && !!a.checked) || ('option' === b && !!a.selected)
            },
            selected: function (a) {
              return a.parentNode && a.parentNode.selectedIndex, a.selected === !0
            },
            empty: function (a) {
              for (a = a.firstChild; a; a = a.nextSibling) if (a.nodeType < 6) return !1
              return !0
            },
            parent: function (a) {
              return !d.pseudos.empty(a)
            },
            header: function (a) {
              return Y.test(a.nodeName)
            },
            input: function (a) {
              return X.test(a.nodeName)
            },
            button: function (a) {
              var b = a.nodeName.toLowerCase()
              return ('input' === b && 'button' === a.type) || 'button' === b
            },
            text: function (a) {
              var b
              return (
                'input' === a.nodeName.toLowerCase() &&
                'text' === a.type &&
                (null == (b = a.getAttribute('type')) || 'text' === b.toLowerCase())
              )
            },
            first: na(function () {
              return [0]
            }),
            last: na(function (a, b) {
              return [b - 1]
            }),
            eq: na(function (a, b, c) {
              return [0 > c ? c + b : c]
            }),
            even: na(function (a, b) {
              for (var c = 0; b > c; c += 2) a.push(c)
              return a
            }),
            odd: na(function (a, b) {
              for (var c = 1; b > c; c += 2) a.push(c)
              return a
            }),
            lt: na(function (a, b, c) {
              for (var d = 0 > c ? c + b : c; --d >= 0; ) a.push(d)
              return a
            }),
            gt: na(function (a, b, c) {
              for (var d = 0 > c ? c + b : c; ++d < b; ) a.push(d)
              return a
            })
          }
        }),
      (d.pseudos.nth = d.pseudos.eq)
    for (b in { radio: !0, checkbox: !0, file: !0, password: !0, image: !0 }) d.pseudos[b] = la(b)
    for (b in { submit: !0, reset: !0 }) d.pseudos[b] = ma(b)
    function pa() {}
    ;(pa.prototype = d.filters = d.pseudos),
      (d.setFilters = new pa()),
      (g = fa.tokenize =
        function (a, b) {
          var c,
            e,
            f,
            g,
            h,
            i,
            j,
            k = z[a + ' ']
          if (k) return b ? 0 : k.slice(0)
          ;(h = a), (i = []), (j = d.preFilter)
          while (h) {
            ;(c && !(e = R.exec(h))) || (e && (h = h.slice(e[0].length) || h), i.push((f = []))),
              (c = !1),
              (e = S.exec(h)) &&
                ((c = e.shift()), f.push({ value: c, type: e[0].replace(Q, ' ') }), (h = h.slice(c.length)))
            for (g in d.filter)
              !(e = W[g].exec(h)) ||
                (j[g] && !(e = j[g](e))) ||
                ((c = e.shift()), f.push({ value: c, type: g, matches: e }), (h = h.slice(c.length)))
            if (!c) break
          }
          return b ? h.length : h ? fa.error(a) : z(a, i).slice(0)
        })
    function qa(a) {
      for (var b = 0, c = a.length, d = ''; c > b; b++) d += a[b].value
      return d
    }
    function ra(a, b, c) {
      var d = b.dir,
        e = c && 'parentNode' === d,
        f = x++
      return b.first
        ? function (b, c, f) {
            while ((b = b[d])) if (1 === b.nodeType || e) return a(b, c, f)
          }
        : function (b, c, g) {
            var h,
              i,
              j,
              k = [w, f]
            if (g) {
              while ((b = b[d])) if ((1 === b.nodeType || e) && a(b, c, g)) return !0
            } else
              while ((b = b[d]))
                if (1 === b.nodeType || e) {
                  if (
                    ((j = b[u] || (b[u] = {})),
                    (i = j[b.uniqueID] || (j[b.uniqueID] = {})),
                    (h = i[d]) && h[0] === w && h[1] === f)
                  )
                    return (k[2] = h[2])
                  if (((i[d] = k), (k[2] = a(b, c, g)))) return !0
                }
          }
    }
    function sa(a) {
      return a.length > 1
        ? function (b, c, d) {
            var e = a.length
            while (e--) if (!a[e](b, c, d)) return !1
            return !0
          }
        : a[0]
    }
    function ta(a, b, c) {
      for (var d = 0, e = b.length; e > d; d++) fa(a, b[d], c)
      return c
    }
    function ua(a, b, c, d, e) {
      for (var f, g = [], h = 0, i = a.length, j = null != b; i > h; h++)
        (f = a[h]) && ((c && !c(f, d, e)) || (g.push(f), j && b.push(h)))
      return g
    }
    function va(a, b, c, d, e, f) {
      return (
        d && !d[u] && (d = va(d)),
        e && !e[u] && (e = va(e, f)),
        ha(function (f, g, h, i) {
          var j,
            k,
            l,
            m = [],
            n = [],
            o = g.length,
            p = f || ta(b || '*', h.nodeType ? [h] : h, []),
            q = !a || (!f && b) ? p : ua(p, m, a, h, i),
            r = c ? (e || (f ? a : o || d) ? [] : g) : q
          if ((c && c(q, r, h, i), d)) {
            ;(j = ua(r, n)), d(j, [], h, i), (k = j.length)
            while (k--) (l = j[k]) && (r[n[k]] = !(q[n[k]] = l))
          }
          if (f) {
            if (e || a) {
              if (e) {
                ;(j = []), (k = r.length)
                while (k--) (l = r[k]) && j.push((q[k] = l))
                e(null, (r = []), j, i)
              }
              k = r.length
              while (k--) (l = r[k]) && (j = e ? J(f, l) : m[k]) > -1 && (f[j] = !(g[j] = l))
            }
          } else (r = ua(r === g ? r.splice(o, r.length) : r)), e ? e(null, g, r, i) : H.apply(g, r)
        })
      )
    }
    function wa(a) {
      for (
        var b,
          c,
          e,
          f = a.length,
          g = d.relative[a[0].type],
          h = g || d.relative[' '],
          i = g ? 1 : 0,
          k = ra(
            function (a) {
              return a === b
            },
            h,
            !0
          ),
          l = ra(
            function (a) {
              return J(b, a) > -1
            },
            h,
            !0
          ),
          m = [
            function (a, c, d) {
              var e = (!g && (d || c !== j)) || ((b = c).nodeType ? k(a, c, d) : l(a, c, d))
              return (b = null), e
            }
          ];
        f > i;
        i++
      )
        if ((c = d.relative[a[i].type])) m = [ra(sa(m), c)]
        else {
          if (((c = d.filter[a[i].type].apply(null, a[i].matches)), c[u])) {
            for (e = ++i; f > e; e++) if (d.relative[a[e].type]) break
            return va(
              i > 1 && sa(m),
              i > 1 && qa(a.slice(0, i - 1).concat({ value: ' ' === a[i - 2].type ? '*' : '' })).replace(Q, '$1'),
              c,
              e > i && wa(a.slice(i, e)),
              f > e && wa((a = a.slice(e))),
              f > e && qa(a)
            )
          }
          m.push(c)
        }
      return sa(m)
    }
    function xa(a, b) {
      var c = b.length > 0,
        e = a.length > 0,
        f = function (f, g, h, i, k) {
          var l,
            o,
            q,
            r = 0,
            s = '0',
            t = f && [],
            u = [],
            v = j,
            x = f || (e && d.find.TAG('*', k)),
            y = (w += null == v ? 1 : Math.random() || 0.1),
            z = x.length
          for (k && (j = g === n || g || k); s !== z && null != (l = x[s]); s++) {
            if (e && l) {
              ;(o = 0), g || l.ownerDocument === n || (m(l), (h = !p))
              while ((q = a[o++]))
                if (q(l, g || n, h)) {
                  i.push(l)
                  break
                }
              k && (w = y)
            }
            c && ((l = !q && l) && r--, f && t.push(l))
          }
          if (((r += s), c && s !== r)) {
            o = 0
            while ((q = b[o++])) q(t, u, g, h)
            if (f) {
              if (r > 0) while (s--) t[s] || u[s] || (u[s] = F.call(i))
              u = ua(u)
            }
            H.apply(i, u), k && !f && u.length > 0 && r + b.length > 1 && fa.uniqueSort(i)
          }
          return k && ((w = y), (j = v)), t
        }
      return c ? ha(f) : f
    }
    return (
      (h = fa.compile =
        function (a, b) {
          var c,
            d = [],
            e = [],
            f = A[a + ' ']
          if (!f) {
            b || (b = g(a)), (c = b.length)
            while (c--) (f = wa(b[c])), f[u] ? d.push(f) : e.push(f)
            ;(f = A(a, xa(e, d))), (f.selector = a)
          }
          return f
        }),
      (i = fa.select =
        function (a, b, e, f) {
          var i,
            j,
            k,
            l,
            m,
            n = 'function' == typeof a && a,
            o = !f && g((a = n.selector || a))
          if (((e = e || []), 1 === o.length)) {
            if (
              ((j = o[0] = o[0].slice(0)),
              j.length > 2 && 'ID' === (k = j[0]).type && c.getById && 9 === b.nodeType && p && d.relative[j[1].type])
            ) {
              if (((b = (d.find.ID(k.matches[0].replace(ba, ca), b) || [])[0]), !b)) return e
              n && (b = b.parentNode), (a = a.slice(j.shift().value.length))
            }
            i = W.needsContext.test(a) ? 0 : j.length
            while (i--) {
              if (((k = j[i]), d.relative[(l = k.type)])) break
              if (
                (m = d.find[l]) &&
                (f = m(k.matches[0].replace(ba, ca), (_.test(j[0].type) && oa(b.parentNode)) || b))
              ) {
                if ((j.splice(i, 1), (a = f.length && qa(j)), !a)) return H.apply(e, f), e
                break
              }
            }
          }
          return (n || h(a, o))(f, b, !p, e, !b || (_.test(a) && oa(b.parentNode)) || b), e
        }),
      (c.sortStable = u.split('').sort(B).join('') === u),
      (c.detectDuplicates = !!l),
      m(),
      (c.sortDetached = ia(function (a) {
        return 1 & a.compareDocumentPosition(n.createElement('div'))
      })),
      ia(function (a) {
        return (a.innerHTML = "<a href='#'></a>"), '#' === a.firstChild.getAttribute('href')
      }) ||
        ja('type|href|height|width', function (a, b, c) {
          return c ? void 0 : a.getAttribute(b, 'type' === b.toLowerCase() ? 1 : 2)
        }),
      (c.attributes &&
        ia(function (a) {
          return (
            (a.innerHTML = '<input/>'),
            a.firstChild.setAttribute('value', ''),
            '' === a.firstChild.getAttribute('value')
          )
        })) ||
        ja('value', function (a, b, c) {
          return c || 'input' !== a.nodeName.toLowerCase() ? void 0 : a.defaultValue
        }),
      ia(function (a) {
        return null == a.getAttribute('disabled')
      }) ||
        ja(K, function (a, b, c) {
          var d
          return c
            ? void 0
            : a[b] === !0
            ? b.toLowerCase()
            : (d = a.getAttributeNode(b)) && d.specified
            ? d.value
            : null
        }),
      fa
    )
  })(a)
  ;(n.find = t),
    (n.expr = t.selectors),
    (n.expr[':'] = n.expr.pseudos),
    (n.uniqueSort = n.unique = t.uniqueSort),
    (n.text = t.getText),
    (n.isXMLDoc = t.isXML),
    (n.contains = t.contains)
  var u = function (a, b, c) {
      var d = [],
        e = void 0 !== c
      while ((a = a[b]) && 9 !== a.nodeType)
        if (1 === a.nodeType) {
          if (e && n(a).is(c)) break
          d.push(a)
        }
      return d
    },
    v = function (a, b) {
      for (var c = []; a; a = a.nextSibling) 1 === a.nodeType && a !== b && c.push(a)
      return c
    },
    w = n.expr.match.needsContext,
    x = /^<([\w-]+)\s*\/?>(?:<\/\1>|)$/,
    y = /^.[^:#\[\.,]*$/
  function z(a, b, c) {
    if (n.isFunction(b))
      return n.grep(a, function (a, d) {
        return !!b.call(a, d, a) !== c
      })
    if (b.nodeType)
      return n.grep(a, function (a) {
        return (a === b) !== c
      })
    if ('string' == typeof b) {
      if (y.test(b)) return n.filter(b, a, c)
      b = n.filter(b, a)
    }
    return n.grep(a, function (a) {
      return h.call(b, a) > -1 !== c
    })
  }
  ;(n.filter = function (a, b, c) {
    var d = b[0]
    return (
      c && (a = ':not(' + a + ')'),
      1 === b.length && 1 === d.nodeType
        ? n.find.matchesSelector(d, a)
          ? [d]
          : []
        : n.find.matches(
            a,
            n.grep(b, function (a) {
              return 1 === a.nodeType
            })
          )
    )
  }),
    n.fn.extend({
      find: function (a) {
        var b,
          c = this.length,
          d = [],
          e = this
        if ('string' != typeof a)
          return this.pushStack(
            n(a).filter(function () {
              for (b = 0; c > b; b++) if (n.contains(e[b], this)) return !0
            })
          )
        for (b = 0; c > b; b++) n.find(a, e[b], d)
        return (
          (d = this.pushStack(c > 1 ? n.unique(d) : d)), (d.selector = this.selector ? this.selector + ' ' + a : a), d
        )
      },
      filter: function (a) {
        return this.pushStack(z(this, a || [], !1))
      },
      not: function (a) {
        return this.pushStack(z(this, a || [], !0))
      },
      is: function (a) {
        return !!z(this, 'string' == typeof a && w.test(a) ? n(a) : a || [], !1).length
      }
    })
  var A,
    B = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]*))$/,
    C = (n.fn.init = function (a, b, c) {
      var e, f
      if (!a) return this
      if (((c = c || A), 'string' == typeof a)) {
        if (
          ((e = '<' === a[0] && '>' === a[a.length - 1] && a.length >= 3 ? [null, a, null] : B.exec(a)),
          !e || (!e[1] && b))
        )
          return !b || b.jquery ? (b || c).find(a) : this.constructor(b).find(a)
        if (e[1]) {
          if (
            ((b = b instanceof n ? b[0] : b),
            n.merge(this, n.parseHTML(e[1], b && b.nodeType ? b.ownerDocument || b : d, !0)),
            x.test(e[1]) && n.isPlainObject(b))
          )
            for (e in b) n.isFunction(this[e]) ? this[e](b[e]) : this.attr(e, b[e])
          return this
        }
        return (
          (f = d.getElementById(e[2])),
          f && f.parentNode && ((this.length = 1), (this[0] = f)),
          (this.context = d),
          (this.selector = a),
          this
        )
      }
      return a.nodeType
        ? ((this.context = this[0] = a), (this.length = 1), this)
        : n.isFunction(a)
        ? void 0 !== c.ready
          ? c.ready(a)
          : a(n)
        : (void 0 !== a.selector && ((this.selector = a.selector), (this.context = a.context)), n.makeArray(a, this))
    })
  ;(C.prototype = n.fn), (A = n(d))
  var D = /^(?:parents|prev(?:Until|All))/,
    E = { children: !0, contents: !0, next: !0, prev: !0 }
  n.fn.extend({
    has: function (a) {
      var b = n(a, this),
        c = b.length
      return this.filter(function () {
        for (var a = 0; c > a; a++) if (n.contains(this, b[a])) return !0
      })
    },
    closest: function (a, b) {
      for (
        var c, d = 0, e = this.length, f = [], g = w.test(a) || 'string' != typeof a ? n(a, b || this.context) : 0;
        e > d;
        d++
      )
        for (c = this[d]; c && c !== b; c = c.parentNode)
          if (c.nodeType < 11 && (g ? g.index(c) > -1 : 1 === c.nodeType && n.find.matchesSelector(c, a))) {
            f.push(c)
            break
          }
      return this.pushStack(f.length > 1 ? n.uniqueSort(f) : f)
    },
    index: function (a) {
      return a
        ? 'string' == typeof a
          ? h.call(n(a), this[0])
          : h.call(this, a.jquery ? a[0] : a)
        : this[0] && this[0].parentNode
        ? this.first().prevAll().length
        : -1
    },
    add: function (a, b) {
      return this.pushStack(n.uniqueSort(n.merge(this.get(), n(a, b))))
    },
    addBack: function (a) {
      return this.add(null == a ? this.prevObject : this.prevObject.filter(a))
    }
  })
  function F(a, b) {
    while ((a = a[b]) && 1 !== a.nodeType);
    return a
  }
  n.each(
    {
      parent: function (a) {
        var b = a.parentNode
        return b && 11 !== b.nodeType ? b : null
      },
      parents: function (a) {
        return u(a, 'parentNode')
      },
      parentsUntil: function (a, b, c) {
        return u(a, 'parentNode', c)
      },
      next: function (a) {
        return F(a, 'nextSibling')
      },
      prev: function (a) {
        return F(a, 'previousSibling')
      },
      nextAll: function (a) {
        return u(a, 'nextSibling')
      },
      prevAll: function (a) {
        return u(a, 'previousSibling')
      },
      nextUntil: function (a, b, c) {
        return u(a, 'nextSibling', c)
      },
      prevUntil: function (a, b, c) {
        return u(a, 'previousSibling', c)
      },
      siblings: function (a) {
        return v((a.parentNode || {}).firstChild, a)
      },
      children: function (a) {
        return v(a.firstChild)
      },
      contents: function (a) {
        return a.contentDocument || n.merge([], a.childNodes)
      }
    },
    function (a, b) {
      n.fn[a] = function (c, d) {
        var e = n.map(this, b, c)
        return (
          'Until' !== a.slice(-5) && (d = c),
          d && 'string' == typeof d && (e = n.filter(d, e)),
          this.length > 1 && (E[a] || n.uniqueSort(e), D.test(a) && e.reverse()),
          this.pushStack(e)
        )
      }
    }
  )
  var G = /\S+/g
  function H(a) {
    var b = {}
    return (
      n.each(a.match(G) || [], function (a, c) {
        b[c] = !0
      }),
      b
    )
  }
  ;(n.Callbacks = function (a) {
    a = 'string' == typeof a ? H(a) : n.extend({}, a)
    var b,
      c,
      d,
      e,
      f = [],
      g = [],
      h = -1,
      i = function () {
        for (e = a.once, d = b = !0; g.length; h = -1) {
          c = g.shift()
          while (++h < f.length) f[h].apply(c[0], c[1]) === !1 && a.stopOnFalse && ((h = f.length), (c = !1))
        }
        a.memory || (c = !1), (b = !1), e && (f = c ? [] : '')
      },
      j = {
        add: function () {
          return (
            f &&
              (c && !b && ((h = f.length - 1), g.push(c)),
              (function d(b) {
                n.each(b, function (b, c) {
                  n.isFunction(c)
                    ? (a.unique && j.has(c)) || f.push(c)
                    : c && c.length && 'string' !== n.type(c) && d(c)
                })
              })(arguments),
              c && !b && i()),
            this
          )
        },
        remove: function () {
          return (
            n.each(arguments, function (a, b) {
              var c
              while ((c = n.inArray(b, f, c)) > -1) f.splice(c, 1), h >= c && h--
            }),
            this
          )
        },
        has: function (a) {
          return a ? n.inArray(a, f) > -1 : f.length > 0
        },
        empty: function () {
          return f && (f = []), this
        },
        disable: function () {
          return (e = g = []), (f = c = ''), this
        },
        disabled: function () {
          return !f
        },
        lock: function () {
          return (e = g = []), c || (f = c = ''), this
        },
        locked: function () {
          return !!e
        },
        fireWith: function (a, c) {
          return e || ((c = c || []), (c = [a, c.slice ? c.slice() : c]), g.push(c), b || i()), this
        },
        fire: function () {
          return j.fireWith(this, arguments), this
        },
        fired: function () {
          return !!d
        }
      }
    return j
  }),
    n.extend({
      Deferred: function (a) {
        var b = [
            ['resolve', 'done', n.Callbacks('once memory'), 'resolved'],
            ['reject', 'fail', n.Callbacks('once memory'), 'rejected'],
            ['notify', 'progress', n.Callbacks('memory')]
          ],
          c = 'pending',
          d = {
            state: function () {
              return c
            },
            always: function () {
              return e.done(arguments).fail(arguments), this
            },
            then: function () {
              var a = arguments
              return n
                .Deferred(function (c) {
                  n.each(b, function (b, f) {
                    var g = n.isFunction(a[b]) && a[b]
                    e[f[1]](function () {
                      var a = g && g.apply(this, arguments)
                      a && n.isFunction(a.promise)
                        ? a.promise().progress(c.notify).done(c.resolve).fail(c.reject)
                        : c[f[0] + 'With'](this === d ? c.promise() : this, g ? [a] : arguments)
                    })
                  }),
                    (a = null)
                })
                .promise()
            },
            promise: function (a) {
              return null != a ? n.extend(a, d) : d
            }
          },
          e = {}
        return (
          (d.pipe = d.then),
          n.each(b, function (a, f) {
            var g = f[2],
              h = f[3]
            ;(d[f[1]] = g.add),
              h &&
                g.add(
                  function () {
                    c = h
                  },
                  b[1 ^ a][2].disable,
                  b[2][2].lock
                ),
              (e[f[0]] = function () {
                return e[f[0] + 'With'](this === e ? d : this, arguments), this
              }),
              (e[f[0] + 'With'] = g.fireWith)
          }),
          d.promise(e),
          a && a.call(e, e),
          e
        )
      },
      when: function (a) {
        var b = 0,
          c = e.call(arguments),
          d = c.length,
          f = 1 !== d || (a && n.isFunction(a.promise)) ? d : 0,
          g = 1 === f ? a : n.Deferred(),
          h = function (a, b, c) {
            return function (d) {
              ;(b[a] = this),
                (c[a] = arguments.length > 1 ? e.call(arguments) : d),
                c === i ? g.notifyWith(b, c) : --f || g.resolveWith(b, c)
            }
          },
          i,
          j,
          k
        if (d > 1)
          for (i = new Array(d), j = new Array(d), k = new Array(d); d > b; b++)
            c[b] && n.isFunction(c[b].promise)
              ? c[b].promise().progress(h(b, j, i)).done(h(b, k, c)).fail(g.reject)
              : --f
        return f || g.resolveWith(k, c), g.promise()
      }
    })
  var I
  ;(n.fn.ready = function (a) {
    return n.ready.promise().done(a), this
  }),
    n.extend({
      isReady: !1,
      readyWait: 1,
      holdReady: function (a) {
        a ? n.readyWait++ : n.ready(!0)
      },
      ready: function (a) {
        ;(a === !0 ? --n.readyWait : n.isReady) ||
          ((n.isReady = !0),
          (a !== !0 && --n.readyWait > 0) ||
            (I.resolveWith(d, [n]), n.fn.triggerHandler && (n(d).triggerHandler('ready'), n(d).off('ready'))))
      }
    })
  function J() {
    d.removeEventListener('DOMContentLoaded', J), a.removeEventListener('load', J), n.ready()
  }
  ;(n.ready.promise = function (b) {
    return (
      I ||
        ((I = n.Deferred()),
        'complete' === d.readyState || ('loading' !== d.readyState && !d.documentElement.doScroll)
          ? a.setTimeout(n.ready)
          : (d.addEventListener('DOMContentLoaded', J), a.addEventListener('load', J))),
      I.promise(b)
    )
  }),
    n.ready.promise()
  var K = function (a, b, c, d, e, f, g) {
      var h = 0,
        i = a.length,
        j = null == c
      if ('object' === n.type(c)) {
        e = !0
        for (h in c) K(a, b, h, c[h], !0, f, g)
      } else if (
        void 0 !== d &&
        ((e = !0),
        n.isFunction(d) || (g = !0),
        j &&
          (g
            ? (b.call(a, d), (b = null))
            : ((j = b),
              (b = function (a, b, c) {
                return j.call(n(a), c)
              }))),
        b)
      )
        for (; i > h; h++) b(a[h], c, g ? d : d.call(a[h], h, b(a[h], c)))
      return e ? a : j ? b.call(a) : i ? b(a[0], c) : f
    },
    L = function (a) {
      return 1 === a.nodeType || 9 === a.nodeType || !+a.nodeType
    }
  function M() {
    this.expando = n.expando + M.uid++
  }
  ;(M.uid = 1),
    (M.prototype = {
      register: function (a, b) {
        var c = b || {}
        return (
          a.nodeType
            ? (a[this.expando] = c)
            : Object.defineProperty(a, this.expando, { value: c, writable: !0, configurable: !0 }),
          a[this.expando]
        )
      },
      cache: function (a) {
        if (!L(a)) return {}
        var b = a[this.expando]
        return (
          b ||
            ((b = {}),
            L(a) &&
              (a.nodeType
                ? (a[this.expando] = b)
                : Object.defineProperty(a, this.expando, { value: b, configurable: !0 }))),
          b
        )
      },
      set: function (a, b, c) {
        var d,
          e = this.cache(a)
        if ('string' == typeof b) e[b] = c
        else for (d in b) e[d] = b[d]
        return e
      },
      get: function (a, b) {
        return void 0 === b ? this.cache(a) : a[this.expando] && a[this.expando][b]
      },
      access: function (a, b, c) {
        var d
        return void 0 === b || (b && 'string' == typeof b && void 0 === c)
          ? ((d = this.get(a, b)), void 0 !== d ? d : this.get(a, n.camelCase(b)))
          : (this.set(a, b, c), void 0 !== c ? c : b)
      },
      remove: function (a, b) {
        var c,
          d,
          e,
          f = a[this.expando]
        if (void 0 !== f) {
          if (void 0 === b) this.register(a)
          else {
            n.isArray(b)
              ? (d = b.concat(b.map(n.camelCase)))
              : ((e = n.camelCase(b)), b in f ? (d = [b, e]) : ((d = e), (d = d in f ? [d] : d.match(G) || []))),
              (c = d.length)
            while (c--) delete f[d[c]]
          }
          ;(void 0 === b || n.isEmptyObject(f)) && (a.nodeType ? (a[this.expando] = void 0) : delete a[this.expando])
        }
      },
      hasData: function (a) {
        var b = a[this.expando]
        return void 0 !== b && !n.isEmptyObject(b)
      }
    })
  var N = new M(),
    O = new M(),
    P = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
    Q = /[A-Z]/g
  function R(a, b, c) {
    var d
    if (void 0 === c && 1 === a.nodeType)
      if (((d = 'data-' + b.replace(Q, '-$&').toLowerCase()), (c = a.getAttribute(d)), 'string' == typeof c)) {
        try {
          c =
            'true' === c
              ? !0
              : 'false' === c
              ? !1
              : 'null' === c
              ? null
              : +c + '' === c
              ? +c
              : P.test(c)
              ? n.parseJSON(c)
              : c
        } catch (e) {}
        O.set(a, b, c)
      } else c = void 0
    return c
  }
  n.extend({
    hasData: function (a) {
      return O.hasData(a) || N.hasData(a)
    },
    data: function (a, b, c) {
      return O.access(a, b, c)
    },
    removeData: function (a, b) {
      O.remove(a, b)
    },
    _data: function (a, b, c) {
      return N.access(a, b, c)
    },
    _removeData: function (a, b) {
      N.remove(a, b)
    }
  }),
    n.fn.extend({
      data: function (a, b) {
        var c,
          d,
          e,
          f = this[0],
          g = f && f.attributes
        if (void 0 === a) {
          if (this.length && ((e = O.get(f)), 1 === f.nodeType && !N.get(f, 'hasDataAttrs'))) {
            c = g.length
            while (c--)
              g[c] && ((d = g[c].name), 0 === d.indexOf('data-') && ((d = n.camelCase(d.slice(5))), R(f, d, e[d])))
            N.set(f, 'hasDataAttrs', !0)
          }
          return e
        }
        return 'object' == typeof a
          ? this.each(function () {
              O.set(this, a)
            })
          : K(
              this,
              function (b) {
                var c, d
                if (f && void 0 === b) {
                  if (((c = O.get(f, a) || O.get(f, a.replace(Q, '-$&').toLowerCase())), void 0 !== c)) return c
                  if (((d = n.camelCase(a)), (c = O.get(f, d)), void 0 !== c)) return c
                  if (((c = R(f, d, void 0)), void 0 !== c)) return c
                } else
                  (d = n.camelCase(a)),
                    this.each(function () {
                      var c = O.get(this, d)
                      O.set(this, d, b), a.indexOf('-') > -1 && void 0 !== c && O.set(this, a, b)
                    })
              },
              null,
              b,
              arguments.length > 1,
              null,
              !0
            )
      },
      removeData: function (a) {
        return this.each(function () {
          O.remove(this, a)
        })
      }
    }),
    n.extend({
      queue: function (a, b, c) {
        var d
        return a
          ? ((b = (b || 'fx') + 'queue'),
            (d = N.get(a, b)),
            c && (!d || n.isArray(c) ? (d = N.access(a, b, n.makeArray(c))) : d.push(c)),
            d || [])
          : void 0
      },
      dequeue: function (a, b) {
        b = b || 'fx'
        var c = n.queue(a, b),
          d = c.length,
          e = c.shift(),
          f = n._queueHooks(a, b),
          g = function () {
            n.dequeue(a, b)
          }
        'inprogress' === e && ((e = c.shift()), d--),
          e && ('fx' === b && c.unshift('inprogress'), delete f.stop, e.call(a, g, f)),
          !d && f && f.empty.fire()
      },
      _queueHooks: function (a, b) {
        var c = b + 'queueHooks'
        return (
          N.get(a, c) ||
          N.access(a, c, {
            empty: n.Callbacks('once memory').add(function () {
              N.remove(a, [b + 'queue', c])
            })
          })
        )
      }
    }),
    n.fn.extend({
      queue: function (a, b) {
        var c = 2
        return (
          'string' != typeof a && ((b = a), (a = 'fx'), c--),
          arguments.length < c
            ? n.queue(this[0], a)
            : void 0 === b
            ? this
            : this.each(function () {
                var c = n.queue(this, a, b)
                n._queueHooks(this, a), 'fx' === a && 'inprogress' !== c[0] && n.dequeue(this, a)
              })
        )
      },
      dequeue: function (a) {
        return this.each(function () {
          n.dequeue(this, a)
        })
      },
      clearQueue: function (a) {
        return this.queue(a || 'fx', [])
      },
      promise: function (a, b) {
        var c,
          d = 1,
          e = n.Deferred(),
          f = this,
          g = this.length,
          h = function () {
            --d || e.resolveWith(f, [f])
          }
        'string' != typeof a && ((b = a), (a = void 0)), (a = a || 'fx')
        while (g--) (c = N.get(f[g], a + 'queueHooks')), c && c.empty && (d++, c.empty.add(h))
        return h(), e.promise(b)
      }
    })
  var S = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source,
    T = new RegExp('^(?:([+-])=|)(' + S + ')([a-z%]*)$', 'i'),
    U = ['Top', 'Right', 'Bottom', 'Left'],
    V = function (a, b) {
      return (a = b || a), 'none' === n.css(a, 'display') || !n.contains(a.ownerDocument, a)
    }
  function W(a, b, c, d) {
    var e,
      f = 1,
      g = 20,
      h = d
        ? function () {
            return d.cur()
          }
        : function () {
            return n.css(a, b, '')
          },
      i = h(),
      j = (c && c[3]) || (n.cssNumber[b] ? '' : 'px'),
      k = (n.cssNumber[b] || ('px' !== j && +i)) && T.exec(n.css(a, b))
    if (k && k[3] !== j) {
      ;(j = j || k[3]), (c = c || []), (k = +i || 1)
      do (f = f || '.5'), (k /= f), n.style(a, b, k + j)
      while (f !== (f = h() / i) && 1 !== f && --g)
    }
    return (
      c &&
        ((k = +k || +i || 0),
        (e = c[1] ? k + (c[1] + 1) * c[2] : +c[2]),
        d && ((d.unit = j), (d.start = k), (d.end = e))),
      e
    )
  }
  var X = /^(?:checkbox|radio)$/i,
    Y = /<([\w:-]+)/,
    Z = /^$|\/(?:java|ecma)script/i,
    $ = {
      option: [1, "<select multiple='multiple'>", '</select>'],
      thead: [1, '<table>', '</table>'],
      col: [2, '<table><colgroup>', '</colgroup></table>'],
      tr: [2, '<table><tbody>', '</tbody></table>'],
      td: [3, '<table><tbody><tr>', '</tr></tbody></table>'],
      _default: [0, '', '']
    }
  ;($.optgroup = $.option), ($.tbody = $.tfoot = $.colgroup = $.caption = $.thead), ($.th = $.td)
  function _(a, b) {
    var c =
      'undefined' != typeof a.getElementsByTagName
        ? a.getElementsByTagName(b || '*')
        : 'undefined' != typeof a.querySelectorAll
        ? a.querySelectorAll(b || '*')
        : []
    return void 0 === b || (b && n.nodeName(a, b)) ? n.merge([a], c) : c
  }
  function aa(a, b) {
    for (var c = 0, d = a.length; d > c; c++) N.set(a[c], 'globalEval', !b || N.get(b[c], 'globalEval'))
  }
  var ba = /<|&#?\w+;/
  function ca(a, b, c, d, e) {
    for (var f, g, h, i, j, k, l = b.createDocumentFragment(), m = [], o = 0, p = a.length; p > o; o++)
      if (((f = a[o]), f || 0 === f))
        if ('object' === n.type(f)) n.merge(m, f.nodeType ? [f] : f)
        else if (ba.test(f)) {
          ;(g = g || l.appendChild(b.createElement('div'))),
            (h = (Y.exec(f) || ['', ''])[1].toLowerCase()),
            (i = $[h] || $._default),
            (g.innerHTML = i[1] + n.htmlPrefilter(f) + i[2]),
            (k = i[0])
          while (k--) g = g.lastChild
          n.merge(m, g.childNodes), (g = l.firstChild), (g.textContent = '')
        } else m.push(b.createTextNode(f))
    ;(l.textContent = ''), (o = 0)
    while ((f = m[o++]))
      if (d && n.inArray(f, d) > -1) e && e.push(f)
      else if (((j = n.contains(f.ownerDocument, f)), (g = _(l.appendChild(f), 'script')), j && aa(g), c)) {
        k = 0
        while ((f = g[k++])) Z.test(f.type || '') && c.push(f)
      }
    return l
  }
  !(function () {
    var a = d.createDocumentFragment(),
      b = a.appendChild(d.createElement('div')),
      c = d.createElement('input')
    c.setAttribute('type', 'radio'),
      c.setAttribute('checked', 'checked'),
      c.setAttribute('name', 't'),
      b.appendChild(c),
      (l.checkClone = b.cloneNode(!0).cloneNode(!0).lastChild.checked),
      (b.innerHTML = '<textarea>x</textarea>'),
      (l.noCloneChecked = !!b.cloneNode(!0).lastChild.defaultValue)
  })()
  var da = /^key/,
    ea = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
    fa = /^([^.]*)(?:\.(.+)|)/
  function ga() {
    return !0
  }
  function ha() {
    return !1
  }
  function ia() {
    try {
      return d.activeElement
    } catch (a) {}
  }
  function ja(a, b, c, d, e, f) {
    var g, h
    if ('object' == typeof b) {
      'string' != typeof c && ((d = d || c), (c = void 0))
      for (h in b) ja(a, h, c, d, b[h], f)
      return a
    }
    if (
      (null == d && null == e
        ? ((e = c), (d = c = void 0))
        : null == e && ('string' == typeof c ? ((e = d), (d = void 0)) : ((e = d), (d = c), (c = void 0))),
      e === !1)
    )
      e = ha
    else if (!e) return a
    return (
      1 === f &&
        ((g = e),
        (e = function (a) {
          return n().off(a), g.apply(this, arguments)
        }),
        (e.guid = g.guid || (g.guid = n.guid++))),
      a.each(function () {
        n.event.add(this, b, e, d, c)
      })
    )
  }
  ;(n.event = {
    global: {},
    add: function (a, b, c, d, e) {
      var f,
        g,
        h,
        i,
        j,
        k,
        l,
        m,
        o,
        p,
        q,
        r = N.get(a)
      if (r) {
        c.handler && ((f = c), (c = f.handler), (e = f.selector)),
          c.guid || (c.guid = n.guid++),
          (i = r.events) || (i = r.events = {}),
          (g = r.handle) ||
            (g = r.handle =
              function (b) {
                return 'undefined' != typeof n && n.event.triggered !== b.type
                  ? n.event.dispatch.apply(a, arguments)
                  : void 0
              }),
          (b = (b || '').match(G) || ['']),
          (j = b.length)
        while (j--)
          (h = fa.exec(b[j]) || []),
            (o = q = h[1]),
            (p = (h[2] || '').split('.').sort()),
            o &&
              ((l = n.event.special[o] || {}),
              (o = (e ? l.delegateType : l.bindType) || o),
              (l = n.event.special[o] || {}),
              (k = n.extend(
                {
                  type: o,
                  origType: q,
                  data: d,
                  handler: c,
                  guid: c.guid,
                  selector: e,
                  needsContext: e && n.expr.match.needsContext.test(e),
                  namespace: p.join('.')
                },
                f
              )),
              (m = i[o]) ||
                ((m = i[o] = []),
                (m.delegateCount = 0),
                (l.setup && l.setup.call(a, d, p, g) !== !1) || (a.addEventListener && a.addEventListener(o, g))),
              l.add && (l.add.call(a, k), k.handler.guid || (k.handler.guid = c.guid)),
              e ? m.splice(m.delegateCount++, 0, k) : m.push(k),
              (n.event.global[o] = !0))
      }
    },
    remove: function (a, b, c, d, e) {
      var f,
        g,
        h,
        i,
        j,
        k,
        l,
        m,
        o,
        p,
        q,
        r = N.hasData(a) && N.get(a)
      if (r && (i = r.events)) {
        ;(b = (b || '').match(G) || ['']), (j = b.length)
        while (j--)
          if (((h = fa.exec(b[j]) || []), (o = q = h[1]), (p = (h[2] || '').split('.').sort()), o)) {
            ;(l = n.event.special[o] || {}),
              (o = (d ? l.delegateType : l.bindType) || o),
              (m = i[o] || []),
              (h = h[2] && new RegExp('(^|\\.)' + p.join('\\.(?:.*\\.|)') + '(\\.|$)')),
              (g = f = m.length)
            while (f--)
              (k = m[f]),
                (!e && q !== k.origType) ||
                  (c && c.guid !== k.guid) ||
                  (h && !h.test(k.namespace)) ||
                  (d && d !== k.selector && ('**' !== d || !k.selector)) ||
                  (m.splice(f, 1), k.selector && m.delegateCount--, l.remove && l.remove.call(a, k))
            g &&
              !m.length &&
              ((l.teardown && l.teardown.call(a, p, r.handle) !== !1) || n.removeEvent(a, o, r.handle), delete i[o])
          } else for (o in i) n.event.remove(a, o + b[j], c, d, !0)
        n.isEmptyObject(i) && N.remove(a, 'handle events')
      }
    },
    dispatch: function (a) {
      a = n.event.fix(a)
      var b,
        c,
        d,
        f,
        g,
        h = [],
        i = e.call(arguments),
        j = (N.get(this, 'events') || {})[a.type] || [],
        k = n.event.special[a.type] || {}
      if (((i[0] = a), (a.delegateTarget = this), !k.preDispatch || k.preDispatch.call(this, a) !== !1)) {
        ;(h = n.event.handlers.call(this, a, j)), (b = 0)
        while ((f = h[b++]) && !a.isPropagationStopped()) {
          ;(a.currentTarget = f.elem), (c = 0)
          while ((g = f.handlers[c++]) && !a.isImmediatePropagationStopped())
            (a.rnamespace && !a.rnamespace.test(g.namespace)) ||
              ((a.handleObj = g),
              (a.data = g.data),
              (d = ((n.event.special[g.origType] || {}).handle || g.handler).apply(f.elem, i)),
              void 0 !== d && (a.result = d) === !1 && (a.preventDefault(), a.stopPropagation()))
        }
        return k.postDispatch && k.postDispatch.call(this, a), a.result
      }
    },
    handlers: function (a, b) {
      var c,
        d,
        e,
        f,
        g = [],
        h = b.delegateCount,
        i = a.target
      if (h && i.nodeType && ('click' !== a.type || isNaN(a.button) || a.button < 1))
        for (; i !== this; i = i.parentNode || this)
          if (1 === i.nodeType && (i.disabled !== !0 || 'click' !== a.type)) {
            for (d = [], c = 0; h > c; c++)
              (f = b[c]),
                (e = f.selector + ' '),
                void 0 === d[e] &&
                  (d[e] = f.needsContext ? n(e, this).index(i) > -1 : n.find(e, this, null, [i]).length),
                d[e] && d.push(f)
            d.length && g.push({ elem: i, handlers: d })
          }
      return h < b.length && g.push({ elem: this, handlers: b.slice(h) }), g
    },
    props:
      'altKey bubbles cancelable ctrlKey currentTarget detail eventPhase metaKey relatedTarget shiftKey target timeStamp view which'.split(
        ' '
      ),
    fixHooks: {},
    keyHooks: {
      props: 'char charCode key keyCode'.split(' '),
      filter: function (a, b) {
        return null == a.which && (a.which = null != b.charCode ? b.charCode : b.keyCode), a
      }
    },
    mouseHooks: {
      props: 'button buttons clientX clientY offsetX offsetY pageX pageY screenX screenY toElement'.split(' '),
      filter: function (a, b) {
        var c,
          e,
          f,
          g = b.button
        return (
          null == a.pageX &&
            null != b.clientX &&
            ((c = a.target.ownerDocument || d),
            (e = c.documentElement),
            (f = c.body),
            (a.pageX =
              b.clientX +
              ((e && e.scrollLeft) || (f && f.scrollLeft) || 0) -
              ((e && e.clientLeft) || (f && f.clientLeft) || 0)),
            (a.pageY =
              b.clientY +
              ((e && e.scrollTop) || (f && f.scrollTop) || 0) -
              ((e && e.clientTop) || (f && f.clientTop) || 0))),
          a.which || void 0 === g || (a.which = 1 & g ? 1 : 2 & g ? 3 : 4 & g ? 2 : 0),
          a
        )
      }
    },
    fix: function (a) {
      if (a[n.expando]) return a
      var b,
        c,
        e,
        f = a.type,
        g = a,
        h = this.fixHooks[f]
      h || (this.fixHooks[f] = h = ea.test(f) ? this.mouseHooks : da.test(f) ? this.keyHooks : {}),
        (e = h.props ? this.props.concat(h.props) : this.props),
        (a = new n.Event(g)),
        (b = e.length)
      while (b--) (c = e[b]), (a[c] = g[c])
      return (
        a.target || (a.target = d),
        3 === a.target.nodeType && (a.target = a.target.parentNode),
        h.filter ? h.filter(a, g) : a
      )
    },
    special: {
      load: { noBubble: !0 },
      focus: {
        trigger: function () {
          return this !== ia() && this.focus ? (this.focus(), !1) : void 0
        },
        delegateType: 'focusin'
      },
      blur: {
        trigger: function () {
          return this === ia() && this.blur ? (this.blur(), !1) : void 0
        },
        delegateType: 'focusout'
      },
      click: {
        trigger: function () {
          return 'checkbox' === this.type && this.click && n.nodeName(this, 'input') ? (this.click(), !1) : void 0
        },
        _default: function (a) {
          return n.nodeName(a.target, 'a')
        }
      },
      beforeunload: {
        postDispatch: function (a) {
          void 0 !== a.result && a.originalEvent && (a.originalEvent.returnValue = a.result)
        }
      }
    }
  }),
    (n.removeEvent = function (a, b, c) {
      a.removeEventListener && a.removeEventListener(b, c)
    }),
    (n.Event = function (a, b) {
      return this instanceof n.Event
        ? (a && a.type
            ? ((this.originalEvent = a),
              (this.type = a.type),
              (this.isDefaultPrevented =
                a.defaultPrevented || (void 0 === a.defaultPrevented && a.returnValue === !1) ? ga : ha))
            : (this.type = a),
          b && n.extend(this, b),
          (this.timeStamp = (a && a.timeStamp) || n.now()),
          void (this[n.expando] = !0))
        : new n.Event(a, b)
    }),
    (n.Event.prototype = {
      constructor: n.Event,
      isDefaultPrevented: ha,
      isPropagationStopped: ha,
      isImmediatePropagationStopped: ha,
      preventDefault: function () {
        var a = this.originalEvent
        ;(this.isDefaultPrevented = ga), a && a.preventDefault()
      },
      stopPropagation: function () {
        var a = this.originalEvent
        ;(this.isPropagationStopped = ga), a && a.stopPropagation()
      },
      stopImmediatePropagation: function () {
        var a = this.originalEvent
        ;(this.isImmediatePropagationStopped = ga), a && a.stopImmediatePropagation(), this.stopPropagation()
      }
    }),
    n.each(
      { mouseenter: 'mouseover', mouseleave: 'mouseout', pointerenter: 'pointerover', pointerleave: 'pointerout' },
      function (a, b) {
        n.event.special[a] = {
          delegateType: b,
          bindType: b,
          handle: function (a) {
            var c,
              d = this,
              e = a.relatedTarget,
              f = a.handleObj
            return (
              (e && (e === d || n.contains(d, e))) ||
                ((a.type = f.origType), (c = f.handler.apply(this, arguments)), (a.type = b)),
              c
            )
          }
        }
      }
    ),
    n.fn.extend({
      on: function (a, b, c, d) {
        return ja(this, a, b, c, d)
      },
      one: function (a, b, c, d) {
        return ja(this, a, b, c, d, 1)
      },
      off: function (a, b, c) {
        var d, e
        if (a && a.preventDefault && a.handleObj)
          return (
            (d = a.handleObj),
            n(a.delegateTarget).off(d.namespace ? d.origType + '.' + d.namespace : d.origType, d.selector, d.handler),
            this
          )
        if ('object' == typeof a) {
          for (e in a) this.off(e, b, a[e])
          return this
        }
        return (
          (b !== !1 && 'function' != typeof b) || ((c = b), (b = void 0)),
          c === !1 && (c = ha),
          this.each(function () {
            n.event.remove(this, a, c, b)
          })
        )
      }
    })
  var ka = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:-]+)[^>]*)\/>/gi,
    la = /<script|<style|<link/i,
    ma = /checked\s*(?:[^=]|=\s*.checked.)/i,
    na = /^true\/(.*)/,
    oa = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g
  function pa(a, b) {
    return n.nodeName(a, 'table') && n.nodeName(11 !== b.nodeType ? b : b.firstChild, 'tr')
      ? a.getElementsByTagName('tbody')[0] || a.appendChild(a.ownerDocument.createElement('tbody'))
      : a
  }
  function qa(a) {
    return (a.type = (null !== a.getAttribute('type')) + '/' + a.type), a
  }
  function ra(a) {
    var b = na.exec(a.type)
    return b ? (a.type = b[1]) : a.removeAttribute('type'), a
  }
  function sa(a, b) {
    var c, d, e, f, g, h, i, j
    if (1 === b.nodeType) {
      if (N.hasData(a) && ((f = N.access(a)), (g = N.set(b, f)), (j = f.events))) {
        delete g.handle, (g.events = {})
        for (e in j) for (c = 0, d = j[e].length; d > c; c++) n.event.add(b, e, j[e][c])
      }
      O.hasData(a) && ((h = O.access(a)), (i = n.extend({}, h)), O.set(b, i))
    }
  }
  function ta(a, b) {
    var c = b.nodeName.toLowerCase()
    'input' === c && X.test(a.type)
      ? (b.checked = a.checked)
      : ('input' !== c && 'textarea' !== c) || (b.defaultValue = a.defaultValue)
  }
  function ua(a, b, c, d) {
    b = f.apply([], b)
    var e,
      g,
      h,
      i,
      j,
      k,
      m = 0,
      o = a.length,
      p = o - 1,
      q = b[0],
      r = n.isFunction(q)
    if (r || (o > 1 && 'string' == typeof q && !l.checkClone && ma.test(q)))
      return a.each(function (e) {
        var f = a.eq(e)
        r && (b[0] = q.call(this, e, f.html())), ua(f, b, c, d)
      })
    if (
      o &&
      ((e = ca(b, a[0].ownerDocument, !1, a, d)), (g = e.firstChild), 1 === e.childNodes.length && (e = g), g || d)
    ) {
      for (h = n.map(_(e, 'script'), qa), i = h.length; o > m; m++)
        (j = e), m !== p && ((j = n.clone(j, !0, !0)), i && n.merge(h, _(j, 'script'))), c.call(a[m], j, m)
      if (i)
        for (k = h[h.length - 1].ownerDocument, n.map(h, ra), m = 0; i > m; m++)
          (j = h[m]),
            Z.test(j.type || '') &&
              !N.access(j, 'globalEval') &&
              n.contains(k, j) &&
              (j.src ? n._evalUrl && n._evalUrl(j.src) : n.globalEval(j.textContent.replace(oa, '')))
    }
    return a
  }
  function va(a, b, c) {
    for (var d, e = b ? n.filter(b, a) : a, f = 0; null != (d = e[f]); f++)
      c || 1 !== d.nodeType || n.cleanData(_(d)),
        d.parentNode && (c && n.contains(d.ownerDocument, d) && aa(_(d, 'script')), d.parentNode.removeChild(d))
    return a
  }
  n.extend({
    htmlPrefilter: function (a) {
      return a.replace(ka, '<$1></$2>')
    },
    clone: function (a, b, c) {
      var d,
        e,
        f,
        g,
        h = a.cloneNode(!0),
        i = n.contains(a.ownerDocument, a)
      if (!(l.noCloneChecked || (1 !== a.nodeType && 11 !== a.nodeType) || n.isXMLDoc(a)))
        for (g = _(h), f = _(a), d = 0, e = f.length; e > d; d++) ta(f[d], g[d])
      if (b)
        if (c) for (f = f || _(a), g = g || _(h), d = 0, e = f.length; e > d; d++) sa(f[d], g[d])
        else sa(a, h)
      return (g = _(h, 'script')), g.length > 0 && aa(g, !i && _(a, 'script')), h
    },
    cleanData: function (a) {
      for (var b, c, d, e = n.event.special, f = 0; void 0 !== (c = a[f]); f++)
        if (L(c)) {
          if ((b = c[N.expando])) {
            if (b.events) for (d in b.events) e[d] ? n.event.remove(c, d) : n.removeEvent(c, d, b.handle)
            c[N.expando] = void 0
          }
          c[O.expando] && (c[O.expando] = void 0)
        }
    }
  }),
    n.fn.extend({
      domManip: ua,
      detach: function (a) {
        return va(this, a, !0)
      },
      remove: function (a) {
        return va(this, a)
      },
      text: function (a) {
        return K(
          this,
          function (a) {
            return void 0 === a
              ? n.text(this)
              : this.empty().each(function () {
                  ;(1 !== this.nodeType && 11 !== this.nodeType && 9 !== this.nodeType) || (this.textContent = a)
                })
          },
          null,
          a,
          arguments.length
        )
      },
      append: function () {
        return ua(this, arguments, function (a) {
          if (1 === this.nodeType || 11 === this.nodeType || 9 === this.nodeType) {
            var b = pa(this, a)
            b.appendChild(a)
          }
        })
      },
      prepend: function () {
        return ua(this, arguments, function (a) {
          if (1 === this.nodeType || 11 === this.nodeType || 9 === this.nodeType) {
            var b = pa(this, a)
            b.insertBefore(a, b.firstChild)
          }
        })
      },
      before: function () {
        return ua(this, arguments, function (a) {
          this.parentNode && this.parentNode.insertBefore(a, this)
        })
      },
      after: function () {
        return ua(this, arguments, function (a) {
          this.parentNode && this.parentNode.insertBefore(a, this.nextSibling)
        })
      },
      empty: function () {
        for (var a, b = 0; null != (a = this[b]); b++) 1 === a.nodeType && (n.cleanData(_(a, !1)), (a.textContent = ''))
        return this
      },
      clone: function (a, b) {
        return (
          (a = null == a ? !1 : a),
          (b = null == b ? a : b),
          this.map(function () {
            return n.clone(this, a, b)
          })
        )
      },
      html: function (a) {
        return K(
          this,
          function (a) {
            var b = this[0] || {},
              c = 0,
              d = this.length
            if (void 0 === a && 1 === b.nodeType) return b.innerHTML
            if ('string' == typeof a && !la.test(a) && !$[(Y.exec(a) || ['', ''])[1].toLowerCase()]) {
              a = n.htmlPrefilter(a)
              try {
                for (; d > c; c++) (b = this[c] || {}), 1 === b.nodeType && (n.cleanData(_(b, !1)), (b.innerHTML = a))
                b = 0
              } catch (e) {}
            }
            b && this.empty().append(a)
          },
          null,
          a,
          arguments.length
        )
      },
      replaceWith: function () {
        var a = []
        return ua(
          this,
          arguments,
          function (b) {
            var c = this.parentNode
            n.inArray(this, a) < 0 && (n.cleanData(_(this)), c && c.replaceChild(b, this))
          },
          a
        )
      }
    }),
    n.each(
      {
        appendTo: 'append',
        prependTo: 'prepend',
        insertBefore: 'before',
        insertAfter: 'after',
        replaceAll: 'replaceWith'
      },
      function (a, b) {
        n.fn[a] = function (a) {
          for (var c, d = [], e = n(a), f = e.length - 1, h = 0; f >= h; h++)
            (c = h === f ? this : this.clone(!0)), n(e[h])[b](c), g.apply(d, c.get())
          return this.pushStack(d)
        }
      }
    )
  var wa,
    xa = { HTML: 'block', BODY: 'block' }
  function ya(a, b) {
    var c = n(b.createElement(a)).appendTo(b.body),
      d = n.css(c[0], 'display')
    return c.detach(), d
  }
  function za(a) {
    var b = d,
      c = xa[a]
    return (
      c ||
        ((c = ya(a, b)),
        ('none' !== c && c) ||
          ((wa = (wa || n("<iframe frameborder='0' width='0' height='0'/>")).appendTo(b.documentElement)),
          (b = wa[0].contentDocument),
          b.write(),
          b.close(),
          (c = ya(a, b)),
          wa.detach()),
        (xa[a] = c)),
      c
    )
  }
  var Aa = /^margin/,
    Ba = new RegExp('^(' + S + ')(?!px)[a-z%]+$', 'i'),
    Ca = function (b) {
      var c = b.ownerDocument.defaultView
      return (c && c.opener) || (c = a), c.getComputedStyle(b)
    },
    Da = function (a, b, c, d) {
      var e,
        f,
        g = {}
      for (f in b) (g[f] = a.style[f]), (a.style[f] = b[f])
      e = c.apply(a, d || [])
      for (f in b) a.style[f] = g[f]
      return e
    },
    Ea = d.documentElement
  !(function () {
    var b,
      c,
      e,
      f,
      g = d.createElement('div'),
      h = d.createElement('div')
    if (h.style) {
      ;(h.style.backgroundClip = 'content-box'),
        (h.cloneNode(!0).style.backgroundClip = ''),
        (l.clearCloneStyle = 'content-box' === h.style.backgroundClip),
        (g.style.cssText = 'border:0;width:8px;height:0;top:0;left:-9999px;padding:0;margin-top:1px;position:absolute'),
        g.appendChild(h)
      function i() {
        ;(h.style.cssText =
          '-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;position:relative;display:block;margin:auto;border:1px;padding:1px;top:1%;width:50%'),
          (h.innerHTML = ''),
          Ea.appendChild(g)
        var d = a.getComputedStyle(h)
        ;(b = '1%' !== d.top),
          (f = '2px' === d.marginLeft),
          (c = '4px' === d.width),
          (h.style.marginRight = '50%'),
          (e = '4px' === d.marginRight),
          Ea.removeChild(g)
      }
      n.extend(l, {
        pixelPosition: function () {
          return i(), b
        },
        boxSizingReliable: function () {
          return null == c && i(), c
        },
        pixelMarginRight: function () {
          return null == c && i(), e
        },
        reliableMarginLeft: function () {
          return null == c && i(), f
        },
        reliableMarginRight: function () {
          var b,
            c = h.appendChild(d.createElement('div'))
          return (
            (c.style.cssText = h.style.cssText =
              '-webkit-box-sizing:content-box;box-sizing:content-box;display:block;margin:0;border:0;padding:0'),
            (c.style.marginRight = c.style.width = '0'),
            (h.style.width = '1px'),
            Ea.appendChild(g),
            (b = !parseFloat(a.getComputedStyle(c).marginRight)),
            Ea.removeChild(g),
            h.removeChild(c),
            b
          )
        }
      })
    }
  })()
  function Fa(a, b, c) {
    var d,
      e,
      f,
      g,
      h = a.style
    return (
      (c = c || Ca(a)),
      (g = c ? c.getPropertyValue(b) || c[b] : void 0),
      ('' !== g && void 0 !== g) || n.contains(a.ownerDocument, a) || (g = n.style(a, b)),
      c &&
        !l.pixelMarginRight() &&
        Ba.test(g) &&
        Aa.test(b) &&
        ((d = h.width),
        (e = h.minWidth),
        (f = h.maxWidth),
        (h.minWidth = h.maxWidth = h.width = g),
        (g = c.width),
        (h.width = d),
        (h.minWidth = e),
        (h.maxWidth = f)),
      void 0 !== g ? g + '' : g
    )
  }
  function Ga(a, b) {
    return {
      get: function () {
        return a() ? void delete this.get : (this.get = b).apply(this, arguments)
      }
    }
  }
  var Ha = /^(none|table(?!-c[ea]).+)/,
    Ia = { position: 'absolute', visibility: 'hidden', display: 'block' },
    Ja = { letterSpacing: '0', fontWeight: '400' },
    Ka = ['Webkit', 'O', 'Moz', 'ms'],
    La = d.createElement('div').style
  function Ma(a) {
    if (a in La) return a
    var b = a[0].toUpperCase() + a.slice(1),
      c = Ka.length
    while (c--) if (((a = Ka[c] + b), a in La)) return a
  }
  function Na(a, b, c) {
    var d = T.exec(b)
    return d ? Math.max(0, d[2] - (c || 0)) + (d[3] || 'px') : b
  }
  function Oa(a, b, c, d, e) {
    for (var f = c === (d ? 'border' : 'content') ? 4 : 'width' === b ? 1 : 0, g = 0; 4 > f; f += 2)
      'margin' === c && (g += n.css(a, c + U[f], !0, e)),
        d
          ? ('content' === c && (g -= n.css(a, 'padding' + U[f], !0, e)),
            'margin' !== c && (g -= n.css(a, 'border' + U[f] + 'Width', !0, e)))
          : ((g += n.css(a, 'padding' + U[f], !0, e)),
            'padding' !== c && (g += n.css(a, 'border' + U[f] + 'Width', !0, e)))
    return g
  }
  function Pa(b, c, e) {
    var f = !0,
      g = 'width' === c ? b.offsetWidth : b.offsetHeight,
      h = Ca(b),
      i = 'border-box' === n.css(b, 'boxSizing', !1, h)
    if (
      (d.msFullscreenElement &&
        a.top !== a &&
        b.getClientRects().length &&
        (g = Math.round(100 * b.getBoundingClientRect()[c])),
      0 >= g || null == g)
    ) {
      if (((g = Fa(b, c, h)), (0 > g || null == g) && (g = b.style[c]), Ba.test(g))) return g
      ;(f = i && (l.boxSizingReliable() || g === b.style[c])), (g = parseFloat(g) || 0)
    }
    return g + Oa(b, c, e || (i ? 'border' : 'content'), f, h) + 'px'
  }
  function Qa(a, b) {
    for (var c, d, e, f = [], g = 0, h = a.length; h > g; g++)
      (d = a[g]),
        d.style &&
          ((f[g] = N.get(d, 'olddisplay')),
          (c = d.style.display),
          b
            ? (f[g] || 'none' !== c || (d.style.display = ''),
              '' === d.style.display && V(d) && (f[g] = N.access(d, 'olddisplay', za(d.nodeName))))
            : ((e = V(d)), ('none' === c && e) || N.set(d, 'olddisplay', e ? c : n.css(d, 'display'))))
    for (g = 0; h > g; g++)
      (d = a[g]),
        d.style &&
          ((b && 'none' !== d.style.display && '' !== d.style.display) || (d.style.display = b ? f[g] || '' : 'none'))
    return a
  }
  n.extend({
    cssHooks: {
      opacity: {
        get: function (a, b) {
          if (b) {
            var c = Fa(a, 'opacity')
            return '' === c ? '1' : c
          }
        }
      }
    },
    cssNumber: {
      animationIterationCount: !0,
      columnCount: !0,
      fillOpacity: !0,
      flexGrow: !0,
      flexShrink: !0,
      fontWeight: !0,
      lineHeight: !0,
      opacity: !0,
      order: !0,
      orphans: !0,
      widows: !0,
      zIndex: !0,
      zoom: !0
    },
    cssProps: { float: 'cssFloat' },
    style: function (a, b, c, d) {
      if (a && 3 !== a.nodeType && 8 !== a.nodeType && a.style) {
        var e,
          f,
          g,
          h = n.camelCase(b),
          i = a.style
        return (
          (b = n.cssProps[h] || (n.cssProps[h] = Ma(h) || h)),
          (g = n.cssHooks[b] || n.cssHooks[h]),
          void 0 === c
            ? g && 'get' in g && void 0 !== (e = g.get(a, !1, d))
              ? e
              : i[b]
            : ((f = typeof c),
              'string' === f && (e = T.exec(c)) && e[1] && ((c = W(a, b, e)), (f = 'number')),
              null != c &&
                c === c &&
                ('number' === f && (c += (e && e[3]) || (n.cssNumber[h] ? '' : 'px')),
                l.clearCloneStyle || '' !== c || 0 !== b.indexOf('background') || (i[b] = 'inherit'),
                (g && 'set' in g && void 0 === (c = g.set(a, c, d))) || (i[b] = c)),
              void 0)
        )
      }
    },
    css: function (a, b, c, d) {
      var e,
        f,
        g,
        h = n.camelCase(b)
      return (
        (b = n.cssProps[h] || (n.cssProps[h] = Ma(h) || h)),
        (g = n.cssHooks[b] || n.cssHooks[h]),
        g && 'get' in g && (e = g.get(a, !0, c)),
        void 0 === e && (e = Fa(a, b, d)),
        'normal' === e && b in Ja && (e = Ja[b]),
        '' === c || c ? ((f = parseFloat(e)), c === !0 || isFinite(f) ? f || 0 : e) : e
      )
    }
  }),
    n.each(['height', 'width'], function (a, b) {
      n.cssHooks[b] = {
        get: function (a, c, d) {
          return c
            ? Ha.test(n.css(a, 'display')) && 0 === a.offsetWidth
              ? Da(a, Ia, function () {
                  return Pa(a, b, d)
                })
              : Pa(a, b, d)
            : void 0
        },
        set: function (a, c, d) {
          var e,
            f = d && Ca(a),
            g = d && Oa(a, b, d, 'border-box' === n.css(a, 'boxSizing', !1, f), f)
          return g && (e = T.exec(c)) && 'px' !== (e[3] || 'px') && ((a.style[b] = c), (c = n.css(a, b))), Na(a, c, g)
        }
      }
    }),
    (n.cssHooks.marginLeft = Ga(l.reliableMarginLeft, function (a, b) {
      return b
        ? (parseFloat(Fa(a, 'marginLeft')) ||
            a.getBoundingClientRect().left -
              Da(a, { marginLeft: 0 }, function () {
                return a.getBoundingClientRect().left
              })) + 'px'
        : void 0
    })),
    (n.cssHooks.marginRight = Ga(l.reliableMarginRight, function (a, b) {
      return b ? Da(a, { display: 'inline-block' }, Fa, [a, 'marginRight']) : void 0
    })),
    n.each({ margin: '', padding: '', border: 'Width' }, function (a, b) {
      ;(n.cssHooks[a + b] = {
        expand: function (c) {
          for (var d = 0, e = {}, f = 'string' == typeof c ? c.split(' ') : [c]; 4 > d; d++)
            e[a + U[d] + b] = f[d] || f[d - 2] || f[0]
          return e
        }
      }),
        Aa.test(a) || (n.cssHooks[a + b].set = Na)
    }),
    n.fn.extend({
      css: function (a, b) {
        return K(
          this,
          function (a, b, c) {
            var d,
              e,
              f = {},
              g = 0
            if (n.isArray(b)) {
              for (d = Ca(a), e = b.length; e > g; g++) f[b[g]] = n.css(a, b[g], !1, d)
              return f
            }
            return void 0 !== c ? n.style(a, b, c) : n.css(a, b)
          },
          a,
          b,
          arguments.length > 1
        )
      },
      show: function () {
        return Qa(this, !0)
      },
      hide: function () {
        return Qa(this)
      },
      toggle: function (a) {
        return 'boolean' == typeof a
          ? a
            ? this.show()
            : this.hide()
          : this.each(function () {
              V(this) ? n(this).show() : n(this).hide()
            })
      }
    })
  function Ra(a, b, c, d, e) {
    return new Ra.prototype.init(a, b, c, d, e)
  }
  ;(n.Tween = Ra),
    (Ra.prototype = {
      constructor: Ra,
      init: function (a, b, c, d, e, f) {
        ;(this.elem = a),
          (this.prop = c),
          (this.easing = e || n.easing._default),
          (this.options = b),
          (this.start = this.now = this.cur()),
          (this.end = d),
          (this.unit = f || (n.cssNumber[c] ? '' : 'px'))
      },
      cur: function () {
        var a = Ra.propHooks[this.prop]
        return a && a.get ? a.get(this) : Ra.propHooks._default.get(this)
      },
      run: function (a) {
        var b,
          c = Ra.propHooks[this.prop]
        return (
          this.options.duration
            ? (this.pos = b = n.easing[this.easing](a, this.options.duration * a, 0, 1, this.options.duration))
            : (this.pos = b = a),
          (this.now = (this.end - this.start) * b + this.start),
          this.options.step && this.options.step.call(this.elem, this.now, this),
          c && c.set ? c.set(this) : Ra.propHooks._default.set(this),
          this
        )
      }
    }),
    (Ra.prototype.init.prototype = Ra.prototype),
    (Ra.propHooks = {
      _default: {
        get: function (a) {
          var b
          return 1 !== a.elem.nodeType || (null != a.elem[a.prop] && null == a.elem.style[a.prop])
            ? a.elem[a.prop]
            : ((b = n.css(a.elem, a.prop, '')), b && 'auto' !== b ? b : 0)
        },
        set: function (a) {
          n.fx.step[a.prop]
            ? n.fx.step[a.prop](a)
            : 1 !== a.elem.nodeType || (null == a.elem.style[n.cssProps[a.prop]] && !n.cssHooks[a.prop])
            ? (a.elem[a.prop] = a.now)
            : n.style(a.elem, a.prop, a.now + a.unit)
        }
      }
    }),
    (Ra.propHooks.scrollTop = Ra.propHooks.scrollLeft =
      {
        set: function (a) {
          a.elem.nodeType && a.elem.parentNode && (a.elem[a.prop] = a.now)
        }
      }),
    (n.easing = {
      linear: function (a) {
        return a
      },
      swing: function (a) {
        return 0.5 - Math.cos(a * Math.PI) / 2
      },
      _default: 'swing'
    }),
    (n.fx = Ra.prototype.init),
    (n.fx.step = {})
  var Sa,
    Ta,
    Ua = /^(?:toggle|show|hide)$/,
    Va = /queueHooks$/
  function Wa() {
    return (
      a.setTimeout(function () {
        Sa = void 0
      }),
      (Sa = n.now())
    )
  }
  function Xa(a, b) {
    var c,
      d = 0,
      e = { height: a }
    for (b = b ? 1 : 0; 4 > d; d += 2 - b) (c = U[d]), (e['margin' + c] = e['padding' + c] = a)
    return b && (e.opacity = e.width = a), e
  }
  function Ya(a, b, c) {
    for (var d, e = (_a.tweeners[b] || []).concat(_a.tweeners['*']), f = 0, g = e.length; g > f; f++)
      if ((d = e[f].call(c, b, a))) return d
  }
  function Za(a, b, c) {
    var d,
      e,
      f,
      g,
      h,
      i,
      j,
      k,
      l = this,
      m = {},
      o = a.style,
      p = a.nodeType && V(a),
      q = N.get(a, 'fxshow')
    c.queue ||
      ((h = n._queueHooks(a, 'fx')),
      null == h.unqueued &&
        ((h.unqueued = 0),
        (i = h.empty.fire),
        (h.empty.fire = function () {
          h.unqueued || i()
        })),
      h.unqueued++,
      l.always(function () {
        l.always(function () {
          h.unqueued--, n.queue(a, 'fx').length || h.empty.fire()
        })
      })),
      1 === a.nodeType &&
        ('height' in b || 'width' in b) &&
        ((c.overflow = [o.overflow, o.overflowX, o.overflowY]),
        (j = n.css(a, 'display')),
        (k = 'none' === j ? N.get(a, 'olddisplay') || za(a.nodeName) : j),
        'inline' === k && 'none' === n.css(a, 'float') && (o.display = 'inline-block')),
      c.overflow &&
        ((o.overflow = 'hidden'),
        l.always(function () {
          ;(o.overflow = c.overflow[0]), (o.overflowX = c.overflow[1]), (o.overflowY = c.overflow[2])
        }))
    for (d in b)
      if (((e = b[d]), Ua.exec(e))) {
        if ((delete b[d], (f = f || 'toggle' === e), e === (p ? 'hide' : 'show'))) {
          if ('show' !== e || !q || void 0 === q[d]) continue
          p = !0
        }
        m[d] = (q && q[d]) || n.style(a, d)
      } else j = void 0
    if (n.isEmptyObject(m)) 'inline' === ('none' === j ? za(a.nodeName) : j) && (o.display = j)
    else {
      q ? 'hidden' in q && (p = q.hidden) : (q = N.access(a, 'fxshow', {})),
        f && (q.hidden = !p),
        p
          ? n(a).show()
          : l.done(function () {
              n(a).hide()
            }),
        l.done(function () {
          var b
          N.remove(a, 'fxshow')
          for (b in m) n.style(a, b, m[b])
        })
      for (d in m)
        (g = Ya(p ? q[d] : 0, d, l)),
          d in q || ((q[d] = g.start), p && ((g.end = g.start), (g.start = 'width' === d || 'height' === d ? 1 : 0)))
    }
  }
  function $a(a, b) {
    var c, d, e, f, g
    for (c in a)
      if (
        ((d = n.camelCase(c)),
        (e = b[d]),
        (f = a[c]),
        n.isArray(f) && ((e = f[1]), (f = a[c] = f[0])),
        c !== d && ((a[d] = f), delete a[c]),
        (g = n.cssHooks[d]),
        g && 'expand' in g)
      ) {
        ;(f = g.expand(f)), delete a[d]
        for (c in f) c in a || ((a[c] = f[c]), (b[c] = e))
      } else b[d] = e
  }
  function _a(a, b, c) {
    var d,
      e,
      f = 0,
      g = _a.prefilters.length,
      h = n.Deferred().always(function () {
        delete i.elem
      }),
      i = function () {
        if (e) return !1
        for (
          var b = Sa || Wa(),
            c = Math.max(0, j.startTime + j.duration - b),
            d = c / j.duration || 0,
            f = 1 - d,
            g = 0,
            i = j.tweens.length;
          i > g;
          g++
        )
          j.tweens[g].run(f)
        return h.notifyWith(a, [j, f, c]), 1 > f && i ? c : (h.resolveWith(a, [j]), !1)
      },
      j = h.promise({
        elem: a,
        props: n.extend({}, b),
        opts: n.extend(!0, { specialEasing: {}, easing: n.easing._default }, c),
        originalProperties: b,
        originalOptions: c,
        startTime: Sa || Wa(),
        duration: c.duration,
        tweens: [],
        createTween: function (b, c) {
          var d = n.Tween(a, j.opts, b, c, j.opts.specialEasing[b] || j.opts.easing)
          return j.tweens.push(d), d
        },
        stop: function (b) {
          var c = 0,
            d = b ? j.tweens.length : 0
          if (e) return this
          for (e = !0; d > c; c++) j.tweens[c].run(1)
          return b ? (h.notifyWith(a, [j, 1, 0]), h.resolveWith(a, [j, b])) : h.rejectWith(a, [j, b]), this
        }
      }),
      k = j.props
    for ($a(k, j.opts.specialEasing); g > f; f++)
      if ((d = _a.prefilters[f].call(j, a, k, j.opts)))
        return n.isFunction(d.stop) && (n._queueHooks(j.elem, j.opts.queue).stop = n.proxy(d.stop, d)), d
    return (
      n.map(k, Ya, j),
      n.isFunction(j.opts.start) && j.opts.start.call(a, j),
      n.fx.timer(n.extend(i, { elem: a, anim: j, queue: j.opts.queue })),
      j.progress(j.opts.progress).done(j.opts.done, j.opts.complete).fail(j.opts.fail).always(j.opts.always)
    )
  }
  ;(n.Animation = n.extend(_a, {
    tweeners: {
      '*': [
        function (a, b) {
          var c = this.createTween(a, b)
          return W(c.elem, a, T.exec(b), c), c
        }
      ]
    },
    tweener: function (a, b) {
      n.isFunction(a) ? ((b = a), (a = ['*'])) : (a = a.match(G))
      for (var c, d = 0, e = a.length; e > d; d++)
        (c = a[d]), (_a.tweeners[c] = _a.tweeners[c] || []), _a.tweeners[c].unshift(b)
    },
    prefilters: [Za],
    prefilter: function (a, b) {
      b ? _a.prefilters.unshift(a) : _a.prefilters.push(a)
    }
  })),
    (n.speed = function (a, b, c) {
      var d =
        a && 'object' == typeof a
          ? n.extend({}, a)
          : {
              complete: c || (!c && b) || (n.isFunction(a) && a),
              duration: a,
              easing: (c && b) || (b && !n.isFunction(b) && b)
            }
      return (
        (d.duration = n.fx.off
          ? 0
          : 'number' == typeof d.duration
          ? d.duration
          : d.duration in n.fx.speeds
          ? n.fx.speeds[d.duration]
          : n.fx.speeds._default),
        (null != d.queue && d.queue !== !0) || (d.queue = 'fx'),
        (d.old = d.complete),
        (d.complete = function () {
          n.isFunction(d.old) && d.old.call(this), d.queue && n.dequeue(this, d.queue)
        }),
        d
      )
    }),
    n.fn.extend({
      fadeTo: function (a, b, c, d) {
        return this.filter(V).css('opacity', 0).show().end().animate({ opacity: b }, a, c, d)
      },
      animate: function (a, b, c, d) {
        var e = n.isEmptyObject(a),
          f = n.speed(b, c, d),
          g = function () {
            var b = _a(this, n.extend({}, a), f)
            ;(e || N.get(this, 'finish')) && b.stop(!0)
          }
        return (g.finish = g), e || f.queue === !1 ? this.each(g) : this.queue(f.queue, g)
      },
      stop: function (a, b, c) {
        var d = function (a) {
          var b = a.stop
          delete a.stop, b(c)
        }
        return (
          'string' != typeof a && ((c = b), (b = a), (a = void 0)),
          b && a !== !1 && this.queue(a || 'fx', []),
          this.each(function () {
            var b = !0,
              e = null != a && a + 'queueHooks',
              f = n.timers,
              g = N.get(this)
            if (e) g[e] && g[e].stop && d(g[e])
            else for (e in g) g[e] && g[e].stop && Va.test(e) && d(g[e])
            for (e = f.length; e--; )
              f[e].elem !== this || (null != a && f[e].queue !== a) || (f[e].anim.stop(c), (b = !1), f.splice(e, 1))
            ;(!b && c) || n.dequeue(this, a)
          })
        )
      },
      finish: function (a) {
        return (
          a !== !1 && (a = a || 'fx'),
          this.each(function () {
            var b,
              c = N.get(this),
              d = c[a + 'queue'],
              e = c[a + 'queueHooks'],
              f = n.timers,
              g = d ? d.length : 0
            for (c.finish = !0, n.queue(this, a, []), e && e.stop && e.stop.call(this, !0), b = f.length; b--; )
              f[b].elem === this && f[b].queue === a && (f[b].anim.stop(!0), f.splice(b, 1))
            for (b = 0; g > b; b++) d[b] && d[b].finish && d[b].finish.call(this)
            delete c.finish
          })
        )
      }
    }),
    n.each(['toggle', 'show', 'hide'], function (a, b) {
      var c = n.fn[b]
      n.fn[b] = function (a, d, e) {
        return null == a || 'boolean' == typeof a ? c.apply(this, arguments) : this.animate(Xa(b, !0), a, d, e)
      }
    }),
    n.each(
      {
        slideDown: Xa('show'),
        slideUp: Xa('hide'),
        slideToggle: Xa('toggle'),
        fadeIn: { opacity: 'show' },
        fadeOut: { opacity: 'hide' },
        fadeToggle: { opacity: 'toggle' }
      },
      function (a, b) {
        n.fn[a] = function (a, c, d) {
          return this.animate(b, a, c, d)
        }
      }
    ),
    (n.timers = []),
    (n.fx.tick = function () {
      var a,
        b = 0,
        c = n.timers
      for (Sa = n.now(); b < c.length; b++) (a = c[b]), a() || c[b] !== a || c.splice(b--, 1)
      c.length || n.fx.stop(), (Sa = void 0)
    }),
    (n.fx.timer = function (a) {
      n.timers.push(a), a() ? n.fx.start() : n.timers.pop()
    }),
    (n.fx.interval = 13),
    (n.fx.start = function () {
      Ta || (Ta = a.setInterval(n.fx.tick, n.fx.interval))
    }),
    (n.fx.stop = function () {
      a.clearInterval(Ta), (Ta = null)
    }),
    (n.fx.speeds = { slow: 600, fast: 200, _default: 400 }),
    (n.fn.delay = function (b, c) {
      return (
        (b = n.fx ? n.fx.speeds[b] || b : b),
        (c = c || 'fx'),
        this.queue(c, function (c, d) {
          var e = a.setTimeout(c, b)
          d.stop = function () {
            a.clearTimeout(e)
          }
        })
      )
    }),
    (function () {
      var a = d.createElement('input'),
        b = d.createElement('select'),
        c = b.appendChild(d.createElement('option'))
      ;(a.type = 'checkbox'),
        (l.checkOn = '' !== a.value),
        (l.optSelected = c.selected),
        (b.disabled = !0),
        (l.optDisabled = !c.disabled),
        (a = d.createElement('input')),
        (a.value = 't'),
        (a.type = 'radio'),
        (l.radioValue = 't' === a.value)
    })()
  var ab,
    bb = n.expr.attrHandle
  n.fn.extend({
    attr: function (a, b) {
      return K(this, n.attr, a, b, arguments.length > 1)
    },
    removeAttr: function (a) {
      return this.each(function () {
        n.removeAttr(this, a)
      })
    }
  }),
    n.extend({
      attr: function (a, b, c) {
        var d,
          e,
          f = a.nodeType
        if (3 !== f && 8 !== f && 2 !== f)
          return 'undefined' == typeof a.getAttribute
            ? n.prop(a, b, c)
            : ((1 === f && n.isXMLDoc(a)) ||
                ((b = b.toLowerCase()), (e = n.attrHooks[b] || (n.expr.match.bool.test(b) ? ab : void 0))),
              void 0 !== c
                ? null === c
                  ? void n.removeAttr(a, b)
                  : e && 'set' in e && void 0 !== (d = e.set(a, c, b))
                  ? d
                  : (a.setAttribute(b, c + ''), c)
                : e && 'get' in e && null !== (d = e.get(a, b))
                ? d
                : ((d = n.find.attr(a, b)), null == d ? void 0 : d))
      },
      attrHooks: {
        type: {
          set: function (a, b) {
            if (!l.radioValue && 'radio' === b && n.nodeName(a, 'input')) {
              var c = a.value
              return a.setAttribute('type', b), c && (a.value = c), b
            }
          }
        }
      },
      removeAttr: function (a, b) {
        var c,
          d,
          e = 0,
          f = b && b.match(G)
        if (f && 1 === a.nodeType)
          while ((c = f[e++])) (d = n.propFix[c] || c), n.expr.match.bool.test(c) && (a[d] = !1), a.removeAttribute(c)
      }
    }),
    (ab = {
      set: function (a, b, c) {
        return b === !1 ? n.removeAttr(a, c) : a.setAttribute(c, c), c
      }
    }),
    n.each(n.expr.match.bool.source.match(/\w+/g), function (a, b) {
      var c = bb[b] || n.find.attr
      bb[b] = function (a, b, d) {
        var e, f
        return d || ((f = bb[b]), (bb[b] = e), (e = null != c(a, b, d) ? b.toLowerCase() : null), (bb[b] = f)), e
      }
    })
  var cb = /^(?:input|select|textarea|button)$/i,
    db = /^(?:a|area)$/i
  n.fn.extend({
    prop: function (a, b) {
      return K(this, n.prop, a, b, arguments.length > 1)
    },
    removeProp: function (a) {
      return this.each(function () {
        delete this[n.propFix[a] || a]
      })
    }
  }),
    n.extend({
      prop: function (a, b, c) {
        var d,
          e,
          f = a.nodeType
        if (3 !== f && 8 !== f && 2 !== f)
          return (
            (1 === f && n.isXMLDoc(a)) || ((b = n.propFix[b] || b), (e = n.propHooks[b])),
            void 0 !== c
              ? e && 'set' in e && void 0 !== (d = e.set(a, c, b))
                ? d
                : (a[b] = c)
              : e && 'get' in e && null !== (d = e.get(a, b))
              ? d
              : a[b]
          )
      },
      propHooks: {
        tabIndex: {
          get: function (a) {
            var b = n.find.attr(a, 'tabindex')
            return b ? parseInt(b, 10) : cb.test(a.nodeName) || (db.test(a.nodeName) && a.href) ? 0 : -1
          }
        }
      },
      propFix: { for: 'htmlFor', class: 'className' }
    }),
    l.optSelected ||
      (n.propHooks.selected = {
        get: function (a) {
          var b = a.parentNode
          return b && b.parentNode && b.parentNode.selectedIndex, null
        },
        set: function (a) {
          var b = a.parentNode
          b && (b.selectedIndex, b.parentNode && b.parentNode.selectedIndex)
        }
      }),
    n.each(
      [
        'tabIndex',
        'readOnly',
        'maxLength',
        'cellSpacing',
        'cellPadding',
        'rowSpan',
        'colSpan',
        'useMap',
        'frameBorder',
        'contentEditable'
      ],
      function () {
        n.propFix[this.toLowerCase()] = this
      }
    )
  var eb = /[\t\r\n\f]/g
  function fb(a) {
    return (a.getAttribute && a.getAttribute('class')) || ''
  }
  n.fn.extend({
    addClass: function (a) {
      var b,
        c,
        d,
        e,
        f,
        g,
        h,
        i = 0
      if (n.isFunction(a))
        return this.each(function (b) {
          n(this).addClass(a.call(this, b, fb(this)))
        })
      if ('string' == typeof a && a) {
        b = a.match(G) || []
        while ((c = this[i++]))
          if (((e = fb(c)), (d = 1 === c.nodeType && (' ' + e + ' ').replace(eb, ' ')))) {
            g = 0
            while ((f = b[g++])) d.indexOf(' ' + f + ' ') < 0 && (d += f + ' ')
            ;(h = n.trim(d)), e !== h && c.setAttribute('class', h)
          }
      }
      return this
    },
    removeClass: function (a) {
      var b,
        c,
        d,
        e,
        f,
        g,
        h,
        i = 0
      if (n.isFunction(a))
        return this.each(function (b) {
          n(this).removeClass(a.call(this, b, fb(this)))
        })
      if (!arguments.length) return this.attr('class', '')
      if ('string' == typeof a && a) {
        b = a.match(G) || []
        while ((c = this[i++]))
          if (((e = fb(c)), (d = 1 === c.nodeType && (' ' + e + ' ').replace(eb, ' ')))) {
            g = 0
            while ((f = b[g++])) while (d.indexOf(' ' + f + ' ') > -1) d = d.replace(' ' + f + ' ', ' ')
            ;(h = n.trim(d)), e !== h && c.setAttribute('class', h)
          }
      }
      return this
    },
    toggleClass: function (a, b) {
      var c = typeof a
      return 'boolean' == typeof b && 'string' === c
        ? b
          ? this.addClass(a)
          : this.removeClass(a)
        : n.isFunction(a)
        ? this.each(function (c) {
            n(this).toggleClass(a.call(this, c, fb(this), b), b)
          })
        : this.each(function () {
            var b, d, e, f
            if ('string' === c) {
              ;(d = 0), (e = n(this)), (f = a.match(G) || [])
              while ((b = f[d++])) e.hasClass(b) ? e.removeClass(b) : e.addClass(b)
            } else (void 0 !== a && 'boolean' !== c) || ((b = fb(this)), b && N.set(this, '__className__', b), this.setAttribute && this.setAttribute('class', b || a === !1 ? '' : N.get(this, '__className__') || ''))
          })
    },
    hasClass: function (a) {
      var b,
        c,
        d = 0
      b = ' ' + a + ' '
      while ((c = this[d++])) if (1 === c.nodeType && (' ' + fb(c) + ' ').replace(eb, ' ').indexOf(b) > -1) return !0
      return !1
    }
  })
  var gb = /\r/g,
    hb = /[\x20\t\r\n\f]+/g
  n.fn.extend({
    val: function (a) {
      var b,
        c,
        d,
        e = this[0]
      {
        if (arguments.length)
          return (
            (d = n.isFunction(a)),
            this.each(function (c) {
              var e
              1 === this.nodeType &&
                ((e = d ? a.call(this, c, n(this).val()) : a),
                null == e
                  ? (e = '')
                  : 'number' == typeof e
                  ? (e += '')
                  : n.isArray(e) &&
                    (e = n.map(e, function (a) {
                      return null == a ? '' : a + ''
                    })),
                (b = n.valHooks[this.type] || n.valHooks[this.nodeName.toLowerCase()]),
                (b && 'set' in b && void 0 !== b.set(this, e, 'value')) || (this.value = e))
            })
          )
        if (e)
          return (
            (b = n.valHooks[e.type] || n.valHooks[e.nodeName.toLowerCase()]),
            b && 'get' in b && void 0 !== (c = b.get(e, 'value'))
              ? c
              : ((c = e.value), 'string' == typeof c ? c.replace(gb, '') : null == c ? '' : c)
          )
      }
    }
  }),
    n.extend({
      valHooks: {
        option: {
          get: function (a) {
            var b = n.find.attr(a, 'value')
            return null != b ? b : n.trim(n.text(a)).replace(hb, ' ')
          }
        },
        select: {
          get: function (a) {
            for (
              var b,
                c,
                d = a.options,
                e = a.selectedIndex,
                f = 'select-one' === a.type || 0 > e,
                g = f ? null : [],
                h = f ? e + 1 : d.length,
                i = 0 > e ? h : f ? e : 0;
              h > i;
              i++
            )
              if (
                ((c = d[i]),
                (c.selected || i === e) &&
                  (l.optDisabled ? !c.disabled : null === c.getAttribute('disabled')) &&
                  (!c.parentNode.disabled || !n.nodeName(c.parentNode, 'optgroup')))
              ) {
                if (((b = n(c).val()), f)) return b
                g.push(b)
              }
            return g
          },
          set: function (a, b) {
            var c,
              d,
              e = a.options,
              f = n.makeArray(b),
              g = e.length
            while (g--) (d = e[g]), (d.selected = n.inArray(n.valHooks.option.get(d), f) > -1) && (c = !0)
            return c || (a.selectedIndex = -1), f
          }
        }
      }
    }),
    n.each(['radio', 'checkbox'], function () {
      ;(n.valHooks[this] = {
        set: function (a, b) {
          return n.isArray(b) ? (a.checked = n.inArray(n(a).val(), b) > -1) : void 0
        }
      }),
        l.checkOn ||
          (n.valHooks[this].get = function (a) {
            return null === a.getAttribute('value') ? 'on' : a.value
          })
    })
  var ib = /^(?:focusinfocus|focusoutblur)$/
  n.extend(n.event, {
    trigger: function (b, c, e, f) {
      var g,
        h,
        i,
        j,
        l,
        m,
        o,
        p = [e || d],
        q = k.call(b, 'type') ? b.type : b,
        r = k.call(b, 'namespace') ? b.namespace.split('.') : []
      if (
        ((h = i = e = e || d),
        3 !== e.nodeType &&
          8 !== e.nodeType &&
          !ib.test(q + n.event.triggered) &&
          (q.indexOf('.') > -1 && ((r = q.split('.')), (q = r.shift()), r.sort()),
          (l = q.indexOf(':') < 0 && 'on' + q),
          (b = b[n.expando] ? b : new n.Event(q, 'object' == typeof b && b)),
          (b.isTrigger = f ? 2 : 3),
          (b.namespace = r.join('.')),
          (b.rnamespace = b.namespace ? new RegExp('(^|\\.)' + r.join('\\.(?:.*\\.|)') + '(\\.|$)') : null),
          (b.result = void 0),
          b.target || (b.target = e),
          (c = null == c ? [b] : n.makeArray(c, [b])),
          (o = n.event.special[q] || {}),
          f || !o.trigger || o.trigger.apply(e, c) !== !1))
      ) {
        if (!f && !o.noBubble && !n.isWindow(e)) {
          for (j = o.delegateType || q, ib.test(j + q) || (h = h.parentNode); h; h = h.parentNode) p.push(h), (i = h)
          i === (e.ownerDocument || d) && p.push(i.defaultView || i.parentWindow || a)
        }
        g = 0
        while ((h = p[g++]) && !b.isPropagationStopped())
          (b.type = g > 1 ? j : o.bindType || q),
            (m = (N.get(h, 'events') || {})[b.type] && N.get(h, 'handle')),
            m && m.apply(h, c),
            (m = l && h[l]),
            m && m.apply && L(h) && ((b.result = m.apply(h, c)), b.result === !1 && b.preventDefault())
        return (
          (b.type = q),
          f ||
            b.isDefaultPrevented() ||
            (o._default && o._default.apply(p.pop(), c) !== !1) ||
            !L(e) ||
            (l &&
              n.isFunction(e[q]) &&
              !n.isWindow(e) &&
              ((i = e[l]),
              i && (e[l] = null),
              (n.event.triggered = q),
              e[q](),
              (n.event.triggered = void 0),
              i && (e[l] = i))),
          b.result
        )
      }
    },
    simulate: function (a, b, c) {
      var d = n.extend(new n.Event(), c, { type: a, isSimulated: !0 })
      n.event.trigger(d, null, b), d.isDefaultPrevented() && c.preventDefault()
    }
  }),
    n.fn.extend({
      trigger: function (a, b) {
        return this.each(function () {
          n.event.trigger(a, b, this)
        })
      },
      triggerHandler: function (a, b) {
        var c = this[0]
        return c ? n.event.trigger(a, b, c, !0) : void 0
      }
    }),
    n.each(
      'blur focus focusin focusout load resize scroll unload click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup error contextmenu'.split(
        ' '
      ),
      function (a, b) {
        n.fn[b] = function (a, c) {
          return arguments.length > 0 ? this.on(b, null, a, c) : this.trigger(b)
        }
      }
    ),
    n.fn.extend({
      hover: function (a, b) {
        return this.mouseenter(a).mouseleave(b || a)
      }
    }),
    (l.focusin = 'onfocusin' in a),
    l.focusin ||
      n.each({ focus: 'focusin', blur: 'focusout' }, function (a, b) {
        var c = function (a) {
          n.event.simulate(b, a.target, n.event.fix(a))
        }
        n.event.special[b] = {
          setup: function () {
            var d = this.ownerDocument || this,
              e = N.access(d, b)
            e || d.addEventListener(a, c, !0), N.access(d, b, (e || 0) + 1)
          },
          teardown: function () {
            var d = this.ownerDocument || this,
              e = N.access(d, b) - 1
            e ? N.access(d, b, e) : (d.removeEventListener(a, c, !0), N.remove(d, b))
          }
        }
      })
  var jb = a.location,
    kb = n.now(),
    lb = /\?/
  ;(n.parseJSON = function (a) {
    return JSON.parse(a + '')
  }),
    (n.parseXML = function (b) {
      var c
      if (!b || 'string' != typeof b) return null
      try {
        c = new a.DOMParser().parseFromString(b, 'text/xml')
      } catch (d) {
        c = void 0
      }
      return (c && !c.getElementsByTagName('parsererror').length) || n.error('Invalid XML: ' + b), c
    })
  var mb = /#.*$/,
    nb = /([?&])_=[^&]*/,
    ob = /^(.*?):[ \t]*([^\r\n]*)$/gm,
    pb = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
    qb = /^(?:GET|HEAD)$/,
    rb = /^\/\//,
    sb = {},
    tb = {},
    ub = '*/'.concat('*'),
    vb = d.createElement('a')
  vb.href = jb.href
  function wb(a) {
    return function (b, c) {
      'string' != typeof b && ((c = b), (b = '*'))
      var d,
        e = 0,
        f = b.toLowerCase().match(G) || []
      if (n.isFunction(c))
        while ((d = f[e++]))
          '+' === d[0] ? ((d = d.slice(1) || '*'), (a[d] = a[d] || []).unshift(c)) : (a[d] = a[d] || []).push(c)
    }
  }
  function xb(a, b, c, d) {
    var e = {},
      f = a === tb
    function g(h) {
      var i
      return (
        (e[h] = !0),
        n.each(a[h] || [], function (a, h) {
          var j = h(b, c, d)
          return 'string' != typeof j || f || e[j] ? (f ? !(i = j) : void 0) : (b.dataTypes.unshift(j), g(j), !1)
        }),
        i
      )
    }
    return g(b.dataTypes[0]) || (!e['*'] && g('*'))
  }
  function yb(a, b) {
    var c,
      d,
      e = n.ajaxSettings.flatOptions || {}
    for (c in b) void 0 !== b[c] && ((e[c] ? a : d || (d = {}))[c] = b[c])
    return d && n.extend(!0, a, d), a
  }
  function zb(a, b, c) {
    var d,
      e,
      f,
      g,
      h = a.contents,
      i = a.dataTypes
    while ('*' === i[0]) i.shift(), void 0 === d && (d = a.mimeType || b.getResponseHeader('Content-Type'))
    if (d)
      for (e in h)
        if (h[e] && h[e].test(d)) {
          i.unshift(e)
          break
        }
    if (i[0] in c) f = i[0]
    else {
      for (e in c) {
        if (!i[0] || a.converters[e + ' ' + i[0]]) {
          f = e
          break
        }
        g || (g = e)
      }
      f = f || g
    }
    return f ? (f !== i[0] && i.unshift(f), c[f]) : void 0
  }
  function Ab(a, b, c, d) {
    var e,
      f,
      g,
      h,
      i,
      j = {},
      k = a.dataTypes.slice()
    if (k[1]) for (g in a.converters) j[g.toLowerCase()] = a.converters[g]
    f = k.shift()
    while (f)
      if (
        (a.responseFields[f] && (c[a.responseFields[f]] = b),
        !i && d && a.dataFilter && (b = a.dataFilter(b, a.dataType)),
        (i = f),
        (f = k.shift()))
      )
        if ('*' === f) f = i
        else if ('*' !== i && i !== f) {
          if (((g = j[i + ' ' + f] || j['* ' + f]), !g))
            for (e in j)
              if (((h = e.split(' ')), h[1] === f && (g = j[i + ' ' + h[0]] || j['* ' + h[0]]))) {
                g === !0 ? (g = j[e]) : j[e] !== !0 && ((f = h[0]), k.unshift(h[1]))
                break
              }
          if (g !== !0)
            if (g && a['throws']) b = g(b)
            else
              try {
                b = g(b)
              } catch (l) {
                return { state: 'parsererror', error: g ? l : 'No conversion from ' + i + ' to ' + f }
              }
        }
    return { state: 'success', data: b }
  }
  n.extend({
    active: 0,
    lastModified: {},
    etag: {},
    ajaxSettings: {
      url: jb.href,
      type: 'GET',
      isLocal: pb.test(jb.protocol),
      global: !0,
      processData: !0,
      async: !0,
      contentType: 'application/x-www-form-urlencoded; charset=UTF-8',
      accepts: {
        '*': ub,
        text: 'text/plain',
        html: 'text/html',
        xml: 'application/xml, text/xml',
        json: 'application/json, text/javascript'
      },
      contents: { xml: /\bxml\b/, html: /\bhtml/, json: /\bjson\b/ },
      responseFields: { xml: 'responseXML', text: 'responseText', json: 'responseJSON' },
      converters: { '* text': String, 'text html': !0, 'text json': n.parseJSON, 'text xml': n.parseXML },
      flatOptions: { url: !0, context: !0 }
    },
    ajaxSetup: function (a, b) {
      return b ? yb(yb(a, n.ajaxSettings), b) : yb(n.ajaxSettings, a)
    },
    ajaxPrefilter: wb(sb),
    ajaxTransport: wb(tb),
    ajax: function (b, c) {
      'object' == typeof b && ((c = b), (b = void 0)), (c = c || {})
      var e,
        f,
        g,
        h,
        i,
        j,
        k,
        l,
        m = n.ajaxSetup({}, c),
        o = m.context || m,
        p = m.context && (o.nodeType || o.jquery) ? n(o) : n.event,
        q = n.Deferred(),
        r = n.Callbacks('once memory'),
        s = m.statusCode || {},
        t = {},
        u = {},
        v = 0,
        w = 'canceled',
        x = {
          readyState: 0,
          getResponseHeader: function (a) {
            var b
            if (2 === v) {
              if (!h) {
                h = {}
                while ((b = ob.exec(g))) h[b[1].toLowerCase()] = b[2]
              }
              b = h[a.toLowerCase()]
            }
            return null == b ? null : b
          },
          getAllResponseHeaders: function () {
            return 2 === v ? g : null
          },
          setRequestHeader: function (a, b) {
            var c = a.toLowerCase()
            return v || ((a = u[c] = u[c] || a), (t[a] = b)), this
          },
          overrideMimeType: function (a) {
            return v || (m.mimeType = a), this
          },
          statusCode: function (a) {
            var b
            if (a)
              if (2 > v) for (b in a) s[b] = [s[b], a[b]]
              else x.always(a[x.status])
            return this
          },
          abort: function (a) {
            var b = a || w
            return e && e.abort(b), z(0, b), this
          }
        }
      if (
        ((q.promise(x).complete = r.add),
        (x.success = x.done),
        (x.error = x.fail),
        (m.url = ((b || m.url || jb.href) + '').replace(mb, '').replace(rb, jb.protocol + '//')),
        (m.type = c.method || c.type || m.method || m.type),
        (m.dataTypes = n
          .trim(m.dataType || '*')
          .toLowerCase()
          .match(G) || ['']),
        null == m.crossDomain)
      ) {
        j = d.createElement('a')
        try {
          ;(j.href = m.url),
            (j.href = j.href),
            (m.crossDomain = vb.protocol + '//' + vb.host != j.protocol + '//' + j.host)
        } catch (y) {
          m.crossDomain = !0
        }
      }
      if (
        (m.data && m.processData && 'string' != typeof m.data && (m.data = n.param(m.data, m.traditional)),
        xb(sb, m, c, x),
        2 === v)
      )
        return x
      ;(k = n.event && m.global),
        k && 0 === n.active++ && n.event.trigger('ajaxStart'),
        (m.type = m.type.toUpperCase()),
        (m.hasContent = !qb.test(m.type)),
        (f = m.url),
        m.hasContent ||
          (m.data && ((f = m.url += (lb.test(f) ? '&' : '?') + m.data), delete m.data),
          m.cache === !1 &&
            (m.url = nb.test(f) ? f.replace(nb, '$1_=' + kb++) : f + (lb.test(f) ? '&' : '?') + '_=' + kb++)),
        m.ifModified &&
          (n.lastModified[f] && x.setRequestHeader('If-Modified-Since', n.lastModified[f]),
          n.etag[f] && x.setRequestHeader('If-None-Match', n.etag[f])),
        ((m.data && m.hasContent && m.contentType !== !1) || c.contentType) &&
          x.setRequestHeader('Content-Type', m.contentType),
        x.setRequestHeader(
          'Accept',
          m.dataTypes[0] && m.accepts[m.dataTypes[0]]
            ? m.accepts[m.dataTypes[0]] + ('*' !== m.dataTypes[0] ? ', ' + ub + '; q=0.01' : '')
            : m.accepts['*']
        )
      for (l in m.headers) x.setRequestHeader(l, m.headers[l])
      if (m.beforeSend && (m.beforeSend.call(o, x, m) === !1 || 2 === v)) return x.abort()
      w = 'abort'
      for (l in { success: 1, error: 1, complete: 1 }) x[l](m[l])
      if ((e = xb(tb, m, c, x))) {
        if (((x.readyState = 1), k && p.trigger('ajaxSend', [x, m]), 2 === v)) return x
        m.async &&
          m.timeout > 0 &&
          (i = a.setTimeout(function () {
            x.abort('timeout')
          }, m.timeout))
        try {
          ;(v = 1), e.send(t, z)
        } catch (y) {
          if (!(2 > v)) throw y
          z(-1, y)
        }
      } else z(-1, 'No Transport')
      function z(b, c, d, h) {
        var j,
          l,
          t,
          u,
          w,
          y = c
        2 !== v &&
          ((v = 2),
          i && a.clearTimeout(i),
          (e = void 0),
          (g = h || ''),
          (x.readyState = b > 0 ? 4 : 0),
          (j = (b >= 200 && 300 > b) || 304 === b),
          d && (u = zb(m, x, d)),
          (u = Ab(m, u, x, j)),
          j
            ? (m.ifModified &&
                ((w = x.getResponseHeader('Last-Modified')),
                w && (n.lastModified[f] = w),
                (w = x.getResponseHeader('etag')),
                w && (n.etag[f] = w)),
              204 === b || 'HEAD' === m.type
                ? (y = 'nocontent')
                : 304 === b
                ? (y = 'notmodified')
                : ((y = u.state), (l = u.data), (t = u.error), (j = !t)))
            : ((t = y), (!b && y) || ((y = 'error'), 0 > b && (b = 0))),
          (x.status = b),
          (x.statusText = (c || y) + ''),
          j ? q.resolveWith(o, [l, y, x]) : q.rejectWith(o, [x, y, t]),
          x.statusCode(s),
          (s = void 0),
          k && p.trigger(j ? 'ajaxSuccess' : 'ajaxError', [x, m, j ? l : t]),
          r.fireWith(o, [x, y]),
          k && (p.trigger('ajaxComplete', [x, m]), --n.active || n.event.trigger('ajaxStop')))
      }
      return x
    },
    getJSON: function (a, b, c) {
      return n.get(a, b, c, 'json')
    },
    getScript: function (a, b) {
      return n.get(a, void 0, b, 'script')
    }
  }),
    n.each(['get', 'post'], function (a, b) {
      n[b] = function (a, c, d, e) {
        return (
          n.isFunction(c) && ((e = e || d), (d = c), (c = void 0)),
          n.ajax(n.extend({ url: a, type: b, dataType: e, data: c, success: d }, n.isPlainObject(a) && a))
        )
      }
    }),
    (n._evalUrl = function (a) {
      return n.ajax({ url: a, type: 'GET', dataType: 'script', async: !1, global: !1, throws: !0 })
    }),
    n.fn.extend({
      wrapAll: function (a) {
        var b
        return n.isFunction(a)
          ? this.each(function (b) {
              n(this).wrapAll(a.call(this, b))
            })
          : (this[0] &&
              ((b = n(a, this[0].ownerDocument).eq(0).clone(!0)),
              this[0].parentNode && b.insertBefore(this[0]),
              b
                .map(function () {
                  var a = this
                  while (a.firstElementChild) a = a.firstElementChild
                  return a
                })
                .append(this)),
            this)
      },
      wrapInner: function (a) {
        return n.isFunction(a)
          ? this.each(function (b) {
              n(this).wrapInner(a.call(this, b))
            })
          : this.each(function () {
              var b = n(this),
                c = b.contents()
              c.length ? c.wrapAll(a) : b.append(a)
            })
      },
      wrap: function (a) {
        var b = n.isFunction(a)
        return this.each(function (c) {
          n(this).wrapAll(b ? a.call(this, c) : a)
        })
      },
      unwrap: function () {
        return this.parent()
          .each(function () {
            n.nodeName(this, 'body') || n(this).replaceWith(this.childNodes)
          })
          .end()
      }
    }),
    (n.expr.filters.hidden = function (a) {
      return !n.expr.filters.visible(a)
    }),
    (n.expr.filters.visible = function (a) {
      return a.offsetWidth > 0 || a.offsetHeight > 0 || a.getClientRects().length > 0
    })
  var Bb = /%20/g,
    Cb = /\[\]$/,
    Db = /\r?\n/g,
    Eb = /^(?:submit|button|image|reset|file)$/i,
    Fb = /^(?:input|select|textarea|keygen)/i
  function Gb(a, b, c, d) {
    var e
    if (n.isArray(b))
      n.each(b, function (b, e) {
        c || Cb.test(a) ? d(a, e) : Gb(a + '[' + ('object' == typeof e && null != e ? b : '') + ']', e, c, d)
      })
    else if (c || 'object' !== n.type(b)) d(a, b)
    else for (e in b) Gb(a + '[' + e + ']', b[e], c, d)
  }
  ;(n.param = function (a, b) {
    var c,
      d = [],
      e = function (a, b) {
        ;(b = n.isFunction(b) ? b() : null == b ? '' : b),
          (d[d.length] = encodeURIComponent(a) + '=' + encodeURIComponent(b))
      }
    if (
      (void 0 === b && (b = n.ajaxSettings && n.ajaxSettings.traditional),
      n.isArray(a) || (a.jquery && !n.isPlainObject(a)))
    )
      n.each(a, function () {
        e(this.name, this.value)
      })
    else for (c in a) Gb(c, a[c], b, e)
    return d.join('&').replace(Bb, '+')
  }),
    n.fn.extend({
      serialize: function () {
        return n.param(this.serializeArray())
      },
      serializeArray: function () {
        return this.map(function () {
          var a = n.prop(this, 'elements')
          return a ? n.makeArray(a) : this
        })
          .filter(function () {
            var a = this.type
            return (
              this.name &&
              !n(this).is(':disabled') &&
              Fb.test(this.nodeName) &&
              !Eb.test(a) &&
              (this.checked || !X.test(a))
            )
          })
          .map(function (a, b) {
            var c = n(this).val()
            return null == c
              ? null
              : n.isArray(c)
              ? n.map(c, function (a) {
                  return { name: b.name, value: a.replace(Db, '\r\n') }
                })
              : { name: b.name, value: c.replace(Db, '\r\n') }
          })
          .get()
      }
    }),
    (n.ajaxSettings.xhr = function () {
      try {
        return new a.XMLHttpRequest()
      } catch (b) {}
    })
  var Hb = { 0: 200, 1223: 204 },
    Ib = n.ajaxSettings.xhr()
  ;(l.cors = !!Ib && 'withCredentials' in Ib),
    (l.ajax = Ib = !!Ib),
    n.ajaxTransport(function (b) {
      var c, d
      return l.cors || (Ib && !b.crossDomain)
        ? {
            send: function (e, f) {
              var g,
                h = b.xhr()
              if ((h.open(b.type, b.url, b.async, b.username, b.password), b.xhrFields))
                for (g in b.xhrFields) h[g] = b.xhrFields[g]
              b.mimeType && h.overrideMimeType && h.overrideMimeType(b.mimeType),
                b.crossDomain || e['X-Requested-With'] || (e['X-Requested-With'] = 'XMLHttpRequest')
              for (g in e) h.setRequestHeader(g, e[g])
              ;(c = function (a) {
                return function () {
                  c &&
                    ((c = d = h.onload = h.onerror = h.onabort = h.onreadystatechange = null),
                    'abort' === a
                      ? h.abort()
                      : 'error' === a
                      ? 'number' != typeof h.status
                        ? f(0, 'error')
                        : f(h.status, h.statusText)
                      : f(
                          Hb[h.status] || h.status,
                          h.statusText,
                          'text' !== (h.responseType || 'text') || 'string' != typeof h.responseText
                            ? { binary: h.response }
                            : { text: h.responseText },
                          h.getAllResponseHeaders()
                        ))
                }
              }),
                (h.onload = c()),
                (d = h.onerror = c('error')),
                void 0 !== h.onabort
                  ? (h.onabort = d)
                  : (h.onreadystatechange = function () {
                      4 === h.readyState &&
                        a.setTimeout(function () {
                          c && d()
                        })
                    }),
                (c = c('abort'))
              try {
                h.send((b.hasContent && b.data) || null)
              } catch (i) {
                if (c) throw i
              }
            },
            abort: function () {
              c && c()
            }
          }
        : void 0
    }),
    n.ajaxSetup({
      accepts: { script: 'text/javascript, application/javascript, application/ecmascript, application/x-ecmascript' },
      contents: { script: /\b(?:java|ecma)script\b/ },
      converters: {
        'text script': function (a) {
          return n.globalEval(a), a
        }
      }
    }),
    n.ajaxPrefilter('script', function (a) {
      void 0 === a.cache && (a.cache = !1), a.crossDomain && (a.type = 'GET')
    }),
    n.ajaxTransport('script', function (a) {
      if (a.crossDomain) {
        var b, c
        return {
          send: function (e, f) {
            ;(b = n('<script>')
              .prop({ charset: a.scriptCharset, src: a.url })
              .on(
                'load error',
                (c = function (a) {
                  b.remove(), (c = null), a && f('error' === a.type ? 404 : 200, a.type)
                })
              )),
              d.head.appendChild(b[0])
          },
          abort: function () {
            c && c()
          }
        }
      }
    })
  var Jb = [],
    Kb = /(=)\?(?=&|$)|\?\?/
  n.ajaxSetup({
    jsonp: 'callback',
    jsonpCallback: function () {
      var a = Jb.pop() || n.expando + '_' + kb++
      return (this[a] = !0), a
    }
  }),
    n.ajaxPrefilter('json jsonp', function (b, c, d) {
      var e,
        f,
        g,
        h =
          b.jsonp !== !1 &&
          (Kb.test(b.url)
            ? 'url'
            : 'string' == typeof b.data &&
              0 === (b.contentType || '').indexOf('application/x-www-form-urlencoded') &&
              Kb.test(b.data) &&
              'data')
      return h || 'jsonp' === b.dataTypes[0]
        ? ((e = b.jsonpCallback = n.isFunction(b.jsonpCallback) ? b.jsonpCallback() : b.jsonpCallback),
          h
            ? (b[h] = b[h].replace(Kb, '$1' + e))
            : b.jsonp !== !1 && (b.url += (lb.test(b.url) ? '&' : '?') + b.jsonp + '=' + e),
          (b.converters['script json'] = function () {
            return g || n.error(e + ' was not called'), g[0]
          }),
          (b.dataTypes[0] = 'json'),
          (f = a[e]),
          (a[e] = function () {
            g = arguments
          }),
          d.always(function () {
            void 0 === f ? n(a).removeProp(e) : (a[e] = f),
              b[e] && ((b.jsonpCallback = c.jsonpCallback), Jb.push(e)),
              g && n.isFunction(f) && f(g[0]),
              (g = f = void 0)
          }),
          'script')
        : void 0
    }),
    (n.parseHTML = function (a, b, c) {
      if (!a || 'string' != typeof a) return null
      'boolean' == typeof b && ((c = b), (b = !1)), (b = b || d)
      var e = x.exec(a),
        f = !c && []
      return e
        ? [b.createElement(e[1])]
        : ((e = ca([a], b, f)), f && f.length && n(f).remove(), n.merge([], e.childNodes))
    })
  var Lb = n.fn.load
  ;(n.fn.load = function (a, b, c) {
    if ('string' != typeof a && Lb) return Lb.apply(this, arguments)
    var d,
      e,
      f,
      g = this,
      h = a.indexOf(' ')
    return (
      h > -1 && ((d = n.trim(a.slice(h))), (a = a.slice(0, h))),
      n.isFunction(b) ? ((c = b), (b = void 0)) : b && 'object' == typeof b && (e = 'POST'),
      g.length > 0 &&
        n
          .ajax({ url: a, type: e || 'GET', dataType: 'html', data: b })
          .done(function (a) {
            ;(f = arguments), g.html(d ? n('<div>').append(n.parseHTML(a)).find(d) : a)
          })
          .always(
            c &&
              function (a, b) {
                g.each(function () {
                  c.apply(this, f || [a.responseText, b, a])
                })
              }
          ),
      this
    )
  }),
    n.each(['ajaxStart', 'ajaxStop', 'ajaxComplete', 'ajaxError', 'ajaxSuccess', 'ajaxSend'], function (a, b) {
      n.fn[b] = function (a) {
        return this.on(b, a)
      }
    }),
    (n.expr.filters.animated = function (a) {
      return n.grep(n.timers, function (b) {
        return a === b.elem
      }).length
    })
  function Mb(a) {
    return n.isWindow(a) ? a : 9 === a.nodeType && a.defaultView
  }
  ;(n.offset = {
    setOffset: function (a, b, c) {
      var d,
        e,
        f,
        g,
        h,
        i,
        j,
        k = n.css(a, 'position'),
        l = n(a),
        m = {}
      'static' === k && (a.style.position = 'relative'),
        (h = l.offset()),
        (f = n.css(a, 'top')),
        (i = n.css(a, 'left')),
        (j = ('absolute' === k || 'fixed' === k) && (f + i).indexOf('auto') > -1),
        j ? ((d = l.position()), (g = d.top), (e = d.left)) : ((g = parseFloat(f) || 0), (e = parseFloat(i) || 0)),
        n.isFunction(b) && (b = b.call(a, c, n.extend({}, h))),
        null != b.top && (m.top = b.top - h.top + g),
        null != b.left && (m.left = b.left - h.left + e),
        'using' in b ? b.using.call(a, m) : l.css(m)
    }
  }),
    n.fn.extend({
      offset: function (a) {
        if (arguments.length)
          return void 0 === a
            ? this
            : this.each(function (b) {
                n.offset.setOffset(this, a, b)
              })
        var b,
          c,
          d = this[0],
          e = { top: 0, left: 0 },
          f = d && d.ownerDocument
        if (f)
          return (
            (b = f.documentElement),
            n.contains(b, d)
              ? ((e = d.getBoundingClientRect()),
                (c = Mb(f)),
                { top: e.top + c.pageYOffset - b.clientTop, left: e.left + c.pageXOffset - b.clientLeft })
              : e
          )
      },
      position: function () {
        if (this[0]) {
          var a,
            b,
            c = this[0],
            d = { top: 0, left: 0 }
          return (
            'fixed' === n.css(c, 'position')
              ? (b = c.getBoundingClientRect())
              : ((a = this.offsetParent()),
                (b = this.offset()),
                n.nodeName(a[0], 'html') || (d = a.offset()),
                (d.top += n.css(a[0], 'borderTopWidth', !0)),
                (d.left += n.css(a[0], 'borderLeftWidth', !0))),
            { top: b.top - d.top - n.css(c, 'marginTop', !0), left: b.left - d.left - n.css(c, 'marginLeft', !0) }
          )
        }
      },
      offsetParent: function () {
        return this.map(function () {
          var a = this.offsetParent
          while (a && 'static' === n.css(a, 'position')) a = a.offsetParent
          return a || Ea
        })
      }
    }),
    n.each({ scrollLeft: 'pageXOffset', scrollTop: 'pageYOffset' }, function (a, b) {
      var c = 'pageYOffset' === b
      n.fn[a] = function (d) {
        return K(
          this,
          function (a, d, e) {
            var f = Mb(a)
            return void 0 === e
              ? f
                ? f[b]
                : a[d]
              : void (f ? f.scrollTo(c ? f.pageXOffset : e, c ? e : f.pageYOffset) : (a[d] = e))
          },
          a,
          d,
          arguments.length
        )
      }
    }),
    n.each(['top', 'left'], function (a, b) {
      n.cssHooks[b] = Ga(l.pixelPosition, function (a, c) {
        return c ? ((c = Fa(a, b)), Ba.test(c) ? n(a).position()[b] + 'px' : c) : void 0
      })
    }),
    n.each({ Height: 'height', Width: 'width' }, function (a, b) {
      n.each({ padding: 'inner' + a, content: b, '': 'outer' + a }, function (c, d) {
        n.fn[d] = function (d, e) {
          var f = arguments.length && (c || 'boolean' != typeof d),
            g = c || (d === !0 || e === !0 ? 'margin' : 'border')
          return K(
            this,
            function (b, c, d) {
              var e
              return n.isWindow(b)
                ? b.document.documentElement['client' + a]
                : 9 === b.nodeType
                ? ((e = b.documentElement),
                  Math.max(
                    b.body['scroll' + a],
                    e['scroll' + a],
                    b.body['offset' + a],
                    e['offset' + a],
                    e['client' + a]
                  ))
                : void 0 === d
                ? n.css(b, c, g)
                : n.style(b, c, d, g)
            },
            b,
            f ? d : void 0,
            f,
            null
          )
        }
      })
    }),
    n.fn.extend({
      bind: function (a, b, c) {
        return this.on(a, null, b, c)
      },
      unbind: function (a, b) {
        return this.off(a, null, b)
      },
      delegate: function (a, b, c, d) {
        return this.on(b, a, c, d)
      },
      undelegate: function (a, b, c) {
        return 1 === arguments.length ? this.off(a, '**') : this.off(b, a || '**', c)
      },
      size: function () {
        return this.length
      }
    }),
    (n.fn.andSelf = n.fn.addBack),
    'function' == typeof define &&
      define.amd &&
      define('jquery', [], function () {
        return n
      })
  var Nb = a.jQuery,
    Ob = a.$
  return (
    (n.noConflict = function (b) {
      return a.$ === n && (a.$ = Ob), b && a.jQuery === n && (a.jQuery = Nb), n
    }),
    b || (a.jQuery = a.$ = n),
    n
  )
})


/*!
 * handlebars.min.js
 */
/*!
handlebars v1.3.0

Copyright (C) 2011 by Yehuda Katz

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in
all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
THE SOFTWARE.

@license
*/
var Handlebars = (function () {
  var e = (function () {
    'use strict'
    function t(e) {
      this.string = e
    }
    var e
    t.prototype.toString = function () {
      return '' + this.string
    }
    e = t
    return e
  })()
  var t = (function (e) {
    'use strict'
    function o(e) {
      return r[e] || '&'
    }
    function u(e, t) {
      for (var n in t) {
        if (Object.prototype.hasOwnProperty.call(t, n)) {
          e[n] = t[n]
        }
      }
    }
    function c(e) {
      if (e instanceof n) {
        return e.toString()
      } else if (!e && e !== 0) {
        return ''
      }
      e = '' + e
      if (!s.test(e)) {
        return e
      }
      return e.replace(i, o)
    }
    function h(e) {
      if (!e && e !== 0) {
        return true
      } else if (l(e) && e.length === 0) {
        return true
      } else {
        return false
      }
    }
    var t = {}
    var n = e
    var r = { '&': '&', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#x27;', '`': '&#x60;' }
    var i = /[&<>"'`]/g
    var s = /[&<>"'`]/
    t.extend = u
    var a = Object.prototype.toString
    t.toString = a
    var f = function (e) {
      return typeof e === 'function'
    }
    if (f(/x/)) {
      f = function (e) {
        return typeof e === 'function' && a.call(e) === '[object Function]'
      }
    }
    var f
    t.isFunction = f
    var l =
      Array.isArray ||
      function (e) {
        return e && typeof e === 'object' ? a.call(e) === '[object Array]' : false
      }
    t.isArray = l
    t.escapeExpression = c
    t.isEmpty = h
    return t
  })(e)
  var n = (function () {
    'use strict'
    function n(e, n) {
      var r
      if (n && n.firstLine) {
        r = n.firstLine
        e += ' - ' + r + ':' + n.firstColumn
      }
      var i = Error.prototype.constructor.call(this, e)
      for (var s = 0; s < t.length; s++) {
        this[t[s]] = i[t[s]]
      }
      if (r) {
        this.lineNumber = r
        this.column = n.firstColumn
      }
    }
    var e
    var t = ['description', 'fileName', 'lineNumber', 'message', 'name', 'number', 'stack']
    n.prototype = new Error()
    e = n
    return e
  })()
  var r = (function (e, t) {
    'use strict'
    function h(e, t) {
      this.helpers = e || {}
      this.partials = t || {}
      p(this)
    }
    function p(e) {
      e.registerHelper('helperMissing', function (e) {
        if (arguments.length === 2) {
          return undefined
        } else {
          throw new i("Missing helper: '" + e + "'")
        }
      })
      e.registerHelper('blockHelperMissing', function (t, n) {
        var r = n.inverse || function () {},
          i = n.fn
        if (f(t)) {
          t = t.call(this)
        }
        if (t === true) {
          return i(this)
        } else if (t === false || t == null) {
          return r(this)
        } else if (a(t)) {
          if (t.length > 0) {
            return e.helpers.each(t, n)
          } else {
            return r(this)
          }
        } else {
          return i(t)
        }
      })
      e.registerHelper('each', function (e, t) {
        var n = t.fn,
          r = t.inverse
        var i = 0,
          s = '',
          o
        if (f(e)) {
          e = e.call(this)
        }
        if (t.data) {
          o = m(t.data)
        }
        if (e && typeof e === 'object') {
          if (a(e)) {
            for (var u = e.length; i < u; i++) {
              if (o) {
                o.index = i
                o.first = i === 0
                o.last = i === e.length - 1
              }
              s = s + n(e[i], { data: o })
            }
          } else {
            for (var l in e) {
              if (e.hasOwnProperty(l)) {
                if (o) {
                  o.key = l
                  o.index = i
                  o.first = i === 0
                }
                s = s + n(e[l], { data: o })
                i++
              }
            }
          }
        }
        if (i === 0) {
          s = r(this)
        }
        return s
      })
      e.registerHelper('if', function (e, t) {
        if (f(e)) {
          e = e.call(this)
        }
        if ((!t.hash.includeZero && !e) || r.isEmpty(e)) {
          return t.inverse(this)
        } else {
          return t.fn(this)
        }
      })
      e.registerHelper('unless', function (t, n) {
        return e.helpers['if'].call(this, t, { fn: n.inverse, inverse: n.fn, hash: n.hash })
      })
      e.registerHelper('with', function (e, t) {
        if (f(e)) {
          e = e.call(this)
        }
        if (!r.isEmpty(e)) return t.fn(e)
      })
      e.registerHelper('log', function (t, n) {
        var r = n.data && n.data.level != null ? parseInt(n.data.level, 10) : 1
        e.log(r, t)
      })
    }
    function v(e, t) {
      d.log(e, t)
    }
    var n = {}
    var r = e
    var i = t
    var s = '1.3.0'
    n.VERSION = s
    var o = 4
    n.COMPILER_REVISION = o
    var u = { 1: '<= 1.0.rc.2', 2: '== 1.0.0-rc.3', 3: '== 1.0.0-rc.4', 4: '>= 1.0.0' }
    n.REVISION_CHANGES = u
    var a = r.isArray,
      f = r.isFunction,
      l = r.toString,
      c = '[object Object]'
    n.HandlebarsEnvironment = h
    h.prototype = {
      constructor: h,
      logger: d,
      log: v,
      registerHelper: function (e, t, n) {
        if (l.call(e) === c) {
          if (n || t) {
            throw new i('Arg not supported with multiple helpers')
          }
          r.extend(this.helpers, e)
        } else {
          if (n) {
            t.not = n
          }
          this.helpers[e] = t
        }
      },
      registerPartial: function (e, t) {
        if (l.call(e) === c) {
          r.extend(this.partials, e)
        } else {
          this.partials[e] = t
        }
      }
    }
    var d = {
      methodMap: { 0: 'debug', 1: 'info', 2: 'warn', 3: 'error' },
      DEBUG: 0,
      INFO: 1,
      WARN: 2,
      ERROR: 3,
      level: 3,
      log: function (e, t) {
        if (d.level <= e) {
          var n = d.methodMap[e]
          if (typeof console !== 'undefined' && console[n]) {
            console[n].call(console, t)
          }
        }
      }
    }
    n.logger = d
    n.log = v
    var m = function (e) {
      var t = {}
      r.extend(t, e)
      return t
    }
    n.createFrame = m
    return n
  })(t, n)
  var i = (function (e, t, n) {
    'use strict'
    function a(e) {
      var t = (e && e[0]) || 1,
        n = o
      if (t !== n) {
        if (t < n) {
          var r = u[n],
            i = u[t]
          throw new s(
            'Template was precompiled with an older version of Handlebars than the current runtime. ' +
              'Please update your precompiler to a newer version (' +
              r +
              ') or downgrade your runtime to an older version (' +
              i +
              ').'
          )
        } else {
          throw new s(
            'Template was precompiled with a newer version of Handlebars than the current runtime. ' +
              'Please update your runtime to a newer version (' +
              e[1] +
              ').'
          )
        }
      }
    }
    function f(e, t) {
      if (!t) {
        throw new s('No environment passed to template')
      }
      var n = function (e, n, r, i, o, u) {
        var a = t.VM.invokePartial.apply(this, arguments)
        if (a != null) {
          return a
        }
        if (t.compile) {
          var f = { helpers: i, partials: o, data: u }
          o[n] = t.compile(e, { data: u !== undefined }, t)
          return o[n](r, f)
        } else {
          throw new s('The partial ' + n + ' could not be compiled when running in runtime-only mode')
        }
      }
      var r = {
        escapeExpression: i.escapeExpression,
        invokePartial: n,
        programs: [],
        program: function (e, t, n) {
          var r = this.programs[e]
          if (n) {
            r = c(e, t, n)
          } else if (!r) {
            r = this.programs[e] = c(e, t)
          }
          return r
        },
        merge: function (e, t) {
          var n = e || t
          if (e && t && e !== t) {
            n = {}
            i.extend(n, t)
            i.extend(n, e)
          }
          return n
        },
        programWithDepth: t.VM.programWithDepth,
        noop: t.VM.noop,
        compilerInfo: null
      }
      return function (n, i) {
        i = i || {}
        var s = i.partial ? i : t,
          o,
          u
        if (!i.partial) {
          o = i.helpers
          u = i.partials
        }
        var a = e.call(r, s, n, o, u, i.data)
        if (!i.partial) {
          t.VM.checkRevision(r.compilerInfo)
        }
        return a
      }
    }
    function l(e, t, n) {
      var r = Array.prototype.slice.call(arguments, 3)
      var i = function (e, i) {
        i = i || {}
        return t.apply(this, [e, i.data || n].concat(r))
      }
      i.program = e
      i.depth = r.length
      return i
    }
    function c(e, t, n) {
      var r = function (e, r) {
        r = r || {}
        return t(e, r.data || n)
      }
      r.program = e
      r.depth = 0
      return r
    }
    function h(e, t, n, r, i, o) {
      var u = { partial: true, helpers: r, partials: i, data: o }
      if (e === undefined) {
        throw new s('The partial ' + t + ' could not be found')
      } else if (e instanceof Function) {
        return e(n, u)
      }
    }
    function p() {
      return ''
    }
    var r = {}
    var i = e
    var s = t
    var o = n.COMPILER_REVISION
    var u = n.REVISION_CHANGES
    r.checkRevision = a
    r.template = f
    r.programWithDepth = l
    r.program = c
    r.invokePartial = h
    r.noop = p
    return r
  })(t, n, r)
  var s = (function (e, t, n, r, i) {
    'use strict'
    var s
    var o = e
    var u = t
    var a = n
    var f = r
    var l = i
    var c = function () {
      var e = new o.HandlebarsEnvironment()
      f.extend(e, o)
      e.SafeString = u
      e.Exception = a
      e.Utils = f
      e.VM = l
      e.template = function (t) {
        return l.template(t, e)
      }
      return e
    }
    var h = c()
    h.create = c
    s = h
    return s
  })(r, e, n, t, i)
  var o = (function (e) {
    'use strict'
    function r(e) {
      e = e || {}
      this.firstLine = e.first_line
      this.firstColumn = e.first_column
      this.lastColumn = e.last_column
      this.lastLine = e.last_line
    }
    var t
    var n = e
    var i = {
      ProgramNode: function (e, t, n, s) {
        var o, u
        if (arguments.length === 3) {
          s = n
          n = null
        } else if (arguments.length === 2) {
          s = t
          t = null
        }
        r.call(this, s)
        this.type = 'program'
        this.statements = e
        this.strip = {}
        if (n) {
          u = n[0]
          if (u) {
            o = {
              first_line: u.firstLine,
              last_line: u.lastLine,
              last_column: u.lastColumn,
              first_column: u.firstColumn
            }
            this.inverse = new i.ProgramNode(n, t, o)
          } else {
            this.inverse = new i.ProgramNode(n, t)
          }
          this.strip.right = t.left
        } else if (t) {
          this.strip.left = t.right
        }
      },
      MustacheNode: function (e, t, n, s, o) {
        r.call(this, o)
        this.type = 'mustache'
        this.strip = s
        if (n != null && n.charAt) {
          var u = n.charAt(3) || n.charAt(2)
          this.escaped = u !== '{' && u !== '&'
        } else {
          this.escaped = !!n
        }
        if (e instanceof i.SexprNode) {
          this.sexpr = e
        } else {
          this.sexpr = new i.SexprNode(e, t)
        }
        this.sexpr.isRoot = true
        this.id = this.sexpr.id
        this.params = this.sexpr.params
        this.hash = this.sexpr.hash
        this.eligibleHelper = this.sexpr.eligibleHelper
        this.isHelper = this.sexpr.isHelper
      },
      SexprNode: function (e, t, n) {
        r.call(this, n)
        this.type = 'sexpr'
        this.hash = t
        var i = (this.id = e[0])
        var s = (this.params = e.slice(1))
        var o = (this.eligibleHelper = i.isSimple)
        this.isHelper = o && (s.length || t)
      },
      PartialNode: function (e, t, n, i) {
        r.call(this, i)
        this.type = 'partial'
        this.partialName = e
        this.context = t
        this.strip = n
      },
      BlockNode: function (e, t, i, s, o) {
        r.call(this, o)
        if (e.sexpr.id.original !== s.path.original) {
          throw new n(e.sexpr.id.original + " doesn't match " + s.path.original, this)
        }
        this.type = 'block'
        this.mustache = e
        this.program = t
        this.inverse = i
        this.strip = { left: e.strip.left, right: s.strip.right }
        ;(t || i).strip.left = e.strip.right
        ;(i || t).strip.right = s.strip.left
        if (i && !t) {
          this.isInverse = true
        }
      },
      ContentNode: function (e, t) {
        r.call(this, t)
        this.type = 'content'
        this.string = e
      },
      HashNode: function (e, t) {
        r.call(this, t)
        this.type = 'hash'
        this.pairs = e
      },
      IdNode: function (e, t) {
        r.call(this, t)
        this.type = 'ID'
        var i = '',
          s = [],
          o = 0
        for (var u = 0, a = e.length; u < a; u++) {
          var f = e[u].part
          i += (e[u].separator || '') + f
          if (f === '..' || f === '.' || f === 'this') {
            if (s.length > 0) {
              throw new n('Invalid path: ' + i, this)
            } else if (f === '..') {
              o++
            } else {
              this.isScoped = true
            }
          } else {
            s.push(f)
          }
        }
        this.original = i
        this.parts = s
        this.string = s.join('.')
        this.depth = o
        this.isSimple = e.length === 1 && !this.isScoped && o === 0
        this.stringModeValue = this.string
      },
      PartialNameNode: function (e, t) {
        r.call(this, t)
        this.type = 'PARTIAL_NAME'
        this.name = e.original
      },
      DataNode: function (e, t) {
        r.call(this, t)
        this.type = 'DATA'
        this.id = e
      },
      StringNode: function (e, t) {
        r.call(this, t)
        this.type = 'STRING'
        this.original = this.string = this.stringModeValue = e
      },
      IntegerNode: function (e, t) {
        r.call(this, t)
        this.type = 'INTEGER'
        this.original = this.integer = e
        this.stringModeValue = Number(e)
      },
      BooleanNode: function (e, t) {
        r.call(this, t)
        this.type = 'BOOLEAN'
        this.bool = e
        this.stringModeValue = e === 'true'
      },
      CommentNode: function (e, t) {
        r.call(this, t)
        this.type = 'comment'
        this.comment = e
      }
    }
    t = i
    return t
  })(n)
  var u = (function () {
    'use strict'
    var e
    var t = (function () {
      function t(e, t) {
        return { left: e.charAt(2) === '~', right: t.charAt(0) === '~' || t.charAt(1) === '~' }
      }
      function r() {
        this.yy = {}
      }
      var e = {
        trace: function () {},
        yy: {},
        symbols_: {
          error: 2,
          root: 3,
          statements: 4,
          EOF: 5,
          program: 6,
          simpleInverse: 7,
          statement: 8,
          openInverse: 9,
          closeBlock: 10,
          openBlock: 11,
          mustache: 12,
          partial: 13,
          CONTENT: 14,
          COMMENT: 15,
          OPEN_BLOCK: 16,
          sexpr: 17,
          CLOSE: 18,
          OPEN_INVERSE: 19,
          OPEN_ENDBLOCK: 20,
          path: 21,
          OPEN: 22,
          OPEN_UNESCAPED: 23,
          CLOSE_UNESCAPED: 24,
          OPEN_PARTIAL: 25,
          partialName: 26,
          partial_option0: 27,
          sexpr_repetition0: 28,
          sexpr_option0: 29,
          dataName: 30,
          param: 31,
          STRING: 32,
          INTEGER: 33,
          BOOLEAN: 34,
          OPEN_SEXPR: 35,
          CLOSE_SEXPR: 36,
          hash: 37,
          hash_repetition_plus0: 38,
          hashSegment: 39,
          ID: 40,
          EQUALS: 41,
          DATA: 42,
          pathSegments: 43,
          SEP: 44,
          $accept: 0,
          $end: 1
        },
        terminals_: {
          2: 'error',
          5: 'EOF',
          14: 'CONTENT',
          15: 'COMMENT',
          16: 'OPEN_BLOCK',
          18: 'CLOSE',
          19: 'OPEN_INVERSE',
          20: 'OPEN_ENDBLOCK',
          22: 'OPEN',
          23: 'OPEN_UNESCAPED',
          24: 'CLOSE_UNESCAPED',
          25: 'OPEN_PARTIAL',
          32: 'STRING',
          33: 'INTEGER',
          34: 'BOOLEAN',
          35: 'OPEN_SEXPR',
          36: 'CLOSE_SEXPR',
          40: 'ID',
          41: 'EQUALS',
          42: 'DATA',
          44: 'SEP'
        },
        productions_: [
          0,
          [3, 2],
          [3, 1],
          [6, 2],
          [6, 3],
          [6, 2],
          [6, 1],
          [6, 1],
          [6, 0],
          [4, 1],
          [4, 2],
          [8, 3],
          [8, 3],
          [8, 1],
          [8, 1],
          [8, 1],
          [8, 1],
          [11, 3],
          [9, 3],
          [10, 3],
          [12, 3],
          [12, 3],
          [13, 4],
          [7, 2],
          [17, 3],
          [17, 1],
          [31, 1],
          [31, 1],
          [31, 1],
          [31, 1],
          [31, 1],
          [31, 3],
          [37, 1],
          [39, 3],
          [26, 1],
          [26, 1],
          [26, 1],
          [30, 2],
          [21, 1],
          [43, 3],
          [43, 1],
          [27, 0],
          [27, 1],
          [28, 0],
          [28, 2],
          [29, 0],
          [29, 1],
          [38, 1],
          [38, 2]
        ],
        performAction: function (n, r, i, s, o, u, a) {
          var f = u.length - 1
          switch (o) {
            case 1:
              return new s.ProgramNode(u[f - 1], this._$)
              break
            case 2:
              return new s.ProgramNode([], this._$)
              break
            case 3:
              this.$ = new s.ProgramNode([], u[f - 1], u[f], this._$)
              break
            case 4:
              this.$ = new s.ProgramNode(u[f - 2], u[f - 1], u[f], this._$)
              break
            case 5:
              this.$ = new s.ProgramNode(u[f - 1], u[f], [], this._$)
              break
            case 6:
              this.$ = new s.ProgramNode(u[f], this._$)
              break
            case 7:
              this.$ = new s.ProgramNode([], this._$)
              break
            case 8:
              this.$ = new s.ProgramNode([], this._$)
              break
            case 9:
              this.$ = [u[f]]
              break
            case 10:
              u[f - 1].push(u[f])
              this.$ = u[f - 1]
              break
            case 11:
              this.$ = new s.BlockNode(u[f - 2], u[f - 1].inverse, u[f - 1], u[f], this._$)
              break
            case 12:
              this.$ = new s.BlockNode(u[f - 2], u[f - 1], u[f - 1].inverse, u[f], this._$)
              break
            case 13:
              this.$ = u[f]
              break
            case 14:
              this.$ = u[f]
              break
            case 15:
              this.$ = new s.ContentNode(u[f], this._$)
              break
            case 16:
              this.$ = new s.CommentNode(u[f], this._$)
              break
            case 17:
              this.$ = new s.MustacheNode(u[f - 1], null, u[f - 2], t(u[f - 2], u[f]), this._$)
              break
            case 18:
              this.$ = new s.MustacheNode(u[f - 1], null, u[f - 2], t(u[f - 2], u[f]), this._$)
              break
            case 19:
              this.$ = { path: u[f - 1], strip: t(u[f - 2], u[f]) }
              break
            case 20:
              this.$ = new s.MustacheNode(u[f - 1], null, u[f - 2], t(u[f - 2], u[f]), this._$)
              break
            case 21:
              this.$ = new s.MustacheNode(u[f - 1], null, u[f - 2], t(u[f - 2], u[f]), this._$)
              break
            case 22:
              this.$ = new s.PartialNode(u[f - 2], u[f - 1], t(u[f - 3], u[f]), this._$)
              break
            case 23:
              this.$ = t(u[f - 1], u[f])
              break
            case 24:
              this.$ = new s.SexprNode([u[f - 2]].concat(u[f - 1]), u[f], this._$)
              break
            case 25:
              this.$ = new s.SexprNode([u[f]], null, this._$)
              break
            case 26:
              this.$ = u[f]
              break
            case 27:
              this.$ = new s.StringNode(u[f], this._$)
              break
            case 28:
              this.$ = new s.IntegerNode(u[f], this._$)
              break
            case 29:
              this.$ = new s.BooleanNode(u[f], this._$)
              break
            case 30:
              this.$ = u[f]
              break
            case 31:
              u[f - 1].isHelper = true
              this.$ = u[f - 1]
              break
            case 32:
              this.$ = new s.HashNode(u[f], this._$)
              break
            case 33:
              this.$ = [u[f - 2], u[f]]
              break
            case 34:
              this.$ = new s.PartialNameNode(u[f], this._$)
              break
            case 35:
              this.$ = new s.PartialNameNode(new s.StringNode(u[f], this._$), this._$)
              break
            case 36:
              this.$ = new s.PartialNameNode(new s.IntegerNode(u[f], this._$))
              break
            case 37:
              this.$ = new s.DataNode(u[f], this._$)
              break
            case 38:
              this.$ = new s.IdNode(u[f], this._$)
              break
            case 39:
              u[f - 2].push({ part: u[f], separator: u[f - 1] })
              this.$ = u[f - 2]
              break
            case 40:
              this.$ = [{ part: u[f] }]
              break
            case 43:
              this.$ = []
              break
            case 44:
              u[f - 1].push(u[f])
              break
            case 47:
              this.$ = [u[f]]
              break
            case 48:
              u[f - 1].push(u[f])
              break
          }
        },
        table: [
          {
            3: 1,
            4: 2,
            5: [1, 3],
            8: 4,
            9: 5,
            11: 6,
            12: 7,
            13: 8,
            14: [1, 9],
            15: [1, 10],
            16: [1, 12],
            19: [1, 11],
            22: [1, 13],
            23: [1, 14],
            25: [1, 15]
          },
          { 1: [3] },
          {
            5: [1, 16],
            8: 17,
            9: 5,
            11: 6,
            12: 7,
            13: 8,
            14: [1, 9],
            15: [1, 10],
            16: [1, 12],
            19: [1, 11],
            22: [1, 13],
            23: [1, 14],
            25: [1, 15]
          },
          { 1: [2, 2] },
          { 5: [2, 9], 14: [2, 9], 15: [2, 9], 16: [2, 9], 19: [2, 9], 20: [2, 9], 22: [2, 9], 23: [2, 9], 25: [2, 9] },
          {
            4: 20,
            6: 18,
            7: 19,
            8: 4,
            9: 5,
            11: 6,
            12: 7,
            13: 8,
            14: [1, 9],
            15: [1, 10],
            16: [1, 12],
            19: [1, 21],
            20: [2, 8],
            22: [1, 13],
            23: [1, 14],
            25: [1, 15]
          },
          {
            4: 20,
            6: 22,
            7: 19,
            8: 4,
            9: 5,
            11: 6,
            12: 7,
            13: 8,
            14: [1, 9],
            15: [1, 10],
            16: [1, 12],
            19: [1, 21],
            20: [2, 8],
            22: [1, 13],
            23: [1, 14],
            25: [1, 15]
          },
          {
            5: [2, 13],
            14: [2, 13],
            15: [2, 13],
            16: [2, 13],
            19: [2, 13],
            20: [2, 13],
            22: [2, 13],
            23: [2, 13],
            25: [2, 13]
          },
          {
            5: [2, 14],
            14: [2, 14],
            15: [2, 14],
            16: [2, 14],
            19: [2, 14],
            20: [2, 14],
            22: [2, 14],
            23: [2, 14],
            25: [2, 14]
          },
          {
            5: [2, 15],
            14: [2, 15],
            15: [2, 15],
            16: [2, 15],
            19: [2, 15],
            20: [2, 15],
            22: [2, 15],
            23: [2, 15],
            25: [2, 15]
          },
          {
            5: [2, 16],
            14: [2, 16],
            15: [2, 16],
            16: [2, 16],
            19: [2, 16],
            20: [2, 16],
            22: [2, 16],
            23: [2, 16],
            25: [2, 16]
          },
          { 17: 23, 21: 24, 30: 25, 40: [1, 28], 42: [1, 27], 43: 26 },
          { 17: 29, 21: 24, 30: 25, 40: [1, 28], 42: [1, 27], 43: 26 },
          { 17: 30, 21: 24, 30: 25, 40: [1, 28], 42: [1, 27], 43: 26 },
          { 17: 31, 21: 24, 30: 25, 40: [1, 28], 42: [1, 27], 43: 26 },
          { 21: 33, 26: 32, 32: [1, 34], 33: [1, 35], 40: [1, 28], 43: 26 },
          { 1: [2, 1] },
          {
            5: [2, 10],
            14: [2, 10],
            15: [2, 10],
            16: [2, 10],
            19: [2, 10],
            20: [2, 10],
            22: [2, 10],
            23: [2, 10],
            25: [2, 10]
          },
          { 10: 36, 20: [1, 37] },
          {
            4: 38,
            8: 4,
            9: 5,
            11: 6,
            12: 7,
            13: 8,
            14: [1, 9],
            15: [1, 10],
            16: [1, 12],
            19: [1, 11],
            20: [2, 7],
            22: [1, 13],
            23: [1, 14],
            25: [1, 15]
          },
          {
            7: 39,
            8: 17,
            9: 5,
            11: 6,
            12: 7,
            13: 8,
            14: [1, 9],
            15: [1, 10],
            16: [1, 12],
            19: [1, 21],
            20: [2, 6],
            22: [1, 13],
            23: [1, 14],
            25: [1, 15]
          },
          { 17: 23, 18: [1, 40], 21: 24, 30: 25, 40: [1, 28], 42: [1, 27], 43: 26 },
          { 10: 41, 20: [1, 37] },
          { 18: [1, 42] },
          {
            18: [2, 43],
            24: [2, 43],
            28: 43,
            32: [2, 43],
            33: [2, 43],
            34: [2, 43],
            35: [2, 43],
            36: [2, 43],
            40: [2, 43],
            42: [2, 43]
          },
          { 18: [2, 25], 24: [2, 25], 36: [2, 25] },
          {
            18: [2, 38],
            24: [2, 38],
            32: [2, 38],
            33: [2, 38],
            34: [2, 38],
            35: [2, 38],
            36: [2, 38],
            40: [2, 38],
            42: [2, 38],
            44: [1, 44]
          },
          { 21: 45, 40: [1, 28], 43: 26 },
          {
            18: [2, 40],
            24: [2, 40],
            32: [2, 40],
            33: [2, 40],
            34: [2, 40],
            35: [2, 40],
            36: [2, 40],
            40: [2, 40],
            42: [2, 40],
            44: [2, 40]
          },
          { 18: [1, 46] },
          { 18: [1, 47] },
          { 24: [1, 48] },
          { 18: [2, 41], 21: 50, 27: 49, 40: [1, 28], 43: 26 },
          { 18: [2, 34], 40: [2, 34] },
          { 18: [2, 35], 40: [2, 35] },
          { 18: [2, 36], 40: [2, 36] },
          {
            5: [2, 11],
            14: [2, 11],
            15: [2, 11],
            16: [2, 11],
            19: [2, 11],
            20: [2, 11],
            22: [2, 11],
            23: [2, 11],
            25: [2, 11]
          },
          { 21: 51, 40: [1, 28], 43: 26 },
          {
            8: 17,
            9: 5,
            11: 6,
            12: 7,
            13: 8,
            14: [1, 9],
            15: [1, 10],
            16: [1, 12],
            19: [1, 11],
            20: [2, 3],
            22: [1, 13],
            23: [1, 14],
            25: [1, 15]
          },
          {
            4: 52,
            8: 4,
            9: 5,
            11: 6,
            12: 7,
            13: 8,
            14: [1, 9],
            15: [1, 10],
            16: [1, 12],
            19: [1, 11],
            20: [2, 5],
            22: [1, 13],
            23: [1, 14],
            25: [1, 15]
          },
          { 14: [2, 23], 15: [2, 23], 16: [2, 23], 19: [2, 23], 20: [2, 23], 22: [2, 23], 23: [2, 23], 25: [2, 23] },
          {
            5: [2, 12],
            14: [2, 12],
            15: [2, 12],
            16: [2, 12],
            19: [2, 12],
            20: [2, 12],
            22: [2, 12],
            23: [2, 12],
            25: [2, 12]
          },
          { 14: [2, 18], 15: [2, 18], 16: [2, 18], 19: [2, 18], 20: [2, 18], 22: [2, 18], 23: [2, 18], 25: [2, 18] },
          {
            18: [2, 45],
            21: 56,
            24: [2, 45],
            29: 53,
            30: 60,
            31: 54,
            32: [1, 57],
            33: [1, 58],
            34: [1, 59],
            35: [1, 61],
            36: [2, 45],
            37: 55,
            38: 62,
            39: 63,
            40: [1, 64],
            42: [1, 27],
            43: 26
          },
          { 40: [1, 65] },
          {
            18: [2, 37],
            24: [2, 37],
            32: [2, 37],
            33: [2, 37],
            34: [2, 37],
            35: [2, 37],
            36: [2, 37],
            40: [2, 37],
            42: [2, 37]
          },
          { 14: [2, 17], 15: [2, 17], 16: [2, 17], 19: [2, 17], 20: [2, 17], 22: [2, 17], 23: [2, 17], 25: [2, 17] },
          {
            5: [2, 20],
            14: [2, 20],
            15: [2, 20],
            16: [2, 20],
            19: [2, 20],
            20: [2, 20],
            22: [2, 20],
            23: [2, 20],
            25: [2, 20]
          },
          {
            5: [2, 21],
            14: [2, 21],
            15: [2, 21],
            16: [2, 21],
            19: [2, 21],
            20: [2, 21],
            22: [2, 21],
            23: [2, 21],
            25: [2, 21]
          },
          { 18: [1, 66] },
          { 18: [2, 42] },
          { 18: [1, 67] },
          {
            8: 17,
            9: 5,
            11: 6,
            12: 7,
            13: 8,
            14: [1, 9],
            15: [1, 10],
            16: [1, 12],
            19: [1, 11],
            20: [2, 4],
            22: [1, 13],
            23: [1, 14],
            25: [1, 15]
          },
          { 18: [2, 24], 24: [2, 24], 36: [2, 24] },
          {
            18: [2, 44],
            24: [2, 44],
            32: [2, 44],
            33: [2, 44],
            34: [2, 44],
            35: [2, 44],
            36: [2, 44],
            40: [2, 44],
            42: [2, 44]
          },
          { 18: [2, 46], 24: [2, 46], 36: [2, 46] },
          {
            18: [2, 26],
            24: [2, 26],
            32: [2, 26],
            33: [2, 26],
            34: [2, 26],
            35: [2, 26],
            36: [2, 26],
            40: [2, 26],
            42: [2, 26]
          },
          {
            18: [2, 27],
            24: [2, 27],
            32: [2, 27],
            33: [2, 27],
            34: [2, 27],
            35: [2, 27],
            36: [2, 27],
            40: [2, 27],
            42: [2, 27]
          },
          {
            18: [2, 28],
            24: [2, 28],
            32: [2, 28],
            33: [2, 28],
            34: [2, 28],
            35: [2, 28],
            36: [2, 28],
            40: [2, 28],
            42: [2, 28]
          },
          {
            18: [2, 29],
            24: [2, 29],
            32: [2, 29],
            33: [2, 29],
            34: [2, 29],
            35: [2, 29],
            36: [2, 29],
            40: [2, 29],
            42: [2, 29]
          },
          {
            18: [2, 30],
            24: [2, 30],
            32: [2, 30],
            33: [2, 30],
            34: [2, 30],
            35: [2, 30],
            36: [2, 30],
            40: [2, 30],
            42: [2, 30]
          },
          { 17: 68, 21: 24, 30: 25, 40: [1, 28], 42: [1, 27], 43: 26 },
          { 18: [2, 32], 24: [2, 32], 36: [2, 32], 39: 69, 40: [1, 70] },
          { 18: [2, 47], 24: [2, 47], 36: [2, 47], 40: [2, 47] },
          {
            18: [2, 40],
            24: [2, 40],
            32: [2, 40],
            33: [2, 40],
            34: [2, 40],
            35: [2, 40],
            36: [2, 40],
            40: [2, 40],
            41: [1, 71],
            42: [2, 40],
            44: [2, 40]
          },
          {
            18: [2, 39],
            24: [2, 39],
            32: [2, 39],
            33: [2, 39],
            34: [2, 39],
            35: [2, 39],
            36: [2, 39],
            40: [2, 39],
            42: [2, 39],
            44: [2, 39]
          },
          {
            5: [2, 22],
            14: [2, 22],
            15: [2, 22],
            16: [2, 22],
            19: [2, 22],
            20: [2, 22],
            22: [2, 22],
            23: [2, 22],
            25: [2, 22]
          },
          {
            5: [2, 19],
            14: [2, 19],
            15: [2, 19],
            16: [2, 19],
            19: [2, 19],
            20: [2, 19],
            22: [2, 19],
            23: [2, 19],
            25: [2, 19]
          },
          { 36: [1, 72] },
          { 18: [2, 48], 24: [2, 48], 36: [2, 48], 40: [2, 48] },
          { 41: [1, 71] },
          {
            21: 56,
            30: 60,
            31: 73,
            32: [1, 57],
            33: [1, 58],
            34: [1, 59],
            35: [1, 61],
            40: [1, 28],
            42: [1, 27],
            43: 26
          },
          {
            18: [2, 31],
            24: [2, 31],
            32: [2, 31],
            33: [2, 31],
            34: [2, 31],
            35: [2, 31],
            36: [2, 31],
            40: [2, 31],
            42: [2, 31]
          },
          { 18: [2, 33], 24: [2, 33], 36: [2, 33], 40: [2, 33] }
        ],
        defaultActions: { 3: [2, 2], 16: [2, 1], 50: [2, 42] },
        parseError: function (t, n) {
          throw new Error(t)
        },
        parse: function (t) {
          function v(e) {
            r.length = r.length - 2 * e
            i.length = i.length - e
            s.length = s.length - e
          }
          function m() {
            var e
            e = n.lexer.lex() || 1
            if (typeof e !== 'number') {
              e = n.symbols_[e] || e
            }
            return e
          }
          var n = this,
            r = [0],
            i = [null],
            s = [],
            o = this.table,
            u = '',
            a = 0,
            f = 0,
            l = 0,
            c = 2,
            h = 1
          this.lexer.setInput(t)
          this.lexer.yy = this.yy
          this.yy.lexer = this.lexer
          this.yy.parser = this
          if (typeof this.lexer.yylloc == 'undefined') this.lexer.yylloc = {}
          var p = this.lexer.yylloc
          s.push(p)
          var d = this.lexer.options && this.lexer.options.ranges
          if (typeof this.yy.parseError === 'function') this.parseError = this.yy.parseError
          var g,
            y,
            b,
            w,
            E,
            S,
            x = {},
            T,
            N,
            C,
            k
          while (true) {
            b = r[r.length - 1]
            if (this.defaultActions[b]) {
              w = this.defaultActions[b]
            } else {
              if (g === null || typeof g == 'undefined') {
                g = m()
              }
              w = o[b] && o[b][g]
            }
            if (typeof w === 'undefined' || !w.length || !w[0]) {
              var L = ''
              if (!l) {
                k = []
                for (T in o[b])
                  if (this.terminals_[T] && T > 2) {
                    k.push("'" + this.terminals_[T] + "'")
                  }
                if (this.lexer.showPosition) {
                  L =
                    'Parse error on line ' +
                    (a + 1) +
                    ':\n' +
                    this.lexer.showPosition() +
                    '\nExpecting ' +
                    k.join(', ') +
                    ", got '" +
                    (this.terminals_[g] || g) +
                    "'"
                } else {
                  L =
                    'Parse error on line ' +
                    (a + 1) +
                    ': Unexpected ' +
                    (g == 1 ? 'end of input' : "'" + (this.terminals_[g] || g) + "'")
                }
                this.parseError(L, {
                  text: this.lexer.match,
                  token: this.terminals_[g] || g,
                  line: this.lexer.yylineno,
                  loc: p,
                  expected: k
                })
              }
            }
            if (w[0] instanceof Array && w.length > 1) {
              throw new Error('Parse Error: multiple actions possible at state: ' + b + ', token: ' + g)
            }
            switch (w[0]) {
              case 1:
                r.push(g)
                i.push(this.lexer.yytext)
                s.push(this.lexer.yylloc)
                r.push(w[1])
                g = null
                if (!y) {
                  f = this.lexer.yyleng
                  u = this.lexer.yytext
                  a = this.lexer.yylineno
                  p = this.lexer.yylloc
                  if (l > 0) l--
                } else {
                  g = y
                  y = null
                }
                break
              case 2:
                N = this.productions_[w[1]][1]
                x.$ = i[i.length - N]
                x._$ = {
                  first_line: s[s.length - (N || 1)].first_line,
                  last_line: s[s.length - 1].last_line,
                  first_column: s[s.length - (N || 1)].first_column,
                  last_column: s[s.length - 1].last_column
                }
                if (d) {
                  x._$.range = [s[s.length - (N || 1)].range[0], s[s.length - 1].range[1]]
                }
                S = this.performAction.call(x, u, f, a, this.yy, w[1], i, s)
                if (typeof S !== 'undefined') {
                  return S
                }
                if (N) {
                  r = r.slice(0, -1 * N * 2)
                  i = i.slice(0, -1 * N)
                  s = s.slice(0, -1 * N)
                }
                r.push(this.productions_[w[1]][0])
                i.push(x.$)
                s.push(x._$)
                C = o[r[r.length - 2]][r[r.length - 1]]
                r.push(C)
                break
              case 3:
                return true
            }
          }
          return true
        }
      }
      var n = (function () {
        var e = {
          EOF: 1,
          parseError: function (t, n) {
            if (this.yy.parser) {
              this.yy.parser.parseError(t, n)
            } else {
              throw new Error(t)
            }
          },
          setInput: function (e) {
            this._input = e
            this._more = this._less = this.done = false
            this.yylineno = this.yyleng = 0
            this.yytext = this.matched = this.match = ''
            this.conditionStack = ['INITIAL']
            this.yylloc = { first_line: 1, first_column: 0, last_line: 1, last_column: 0 }
            if (this.options.ranges) this.yylloc.range = [0, 0]
            this.offset = 0
            return this
          },
          input: function () {
            var e = this._input[0]
            this.yytext += e
            this.yyleng++
            this.offset++
            this.match += e
            this.matched += e
            var t = e.match(/(?:\r\n?|\n).*/g)
            if (t) {
              this.yylineno++
              this.yylloc.last_line++
            } else {
              this.yylloc.last_column++
            }
            if (this.options.ranges) this.yylloc.range[1]++
            this._input = this._input.slice(1)
            return e
          },
          unput: function (e) {
            var t = e.length
            var n = e.split(/(?:\r\n?|\n)/g)
            this._input = e + this._input
            this.yytext = this.yytext.substr(0, this.yytext.length - t - 1)
            this.offset -= t
            var r = this.match.split(/(?:\r\n?|\n)/g)
            this.match = this.match.substr(0, this.match.length - 1)
            this.matched = this.matched.substr(0, this.matched.length - 1)
            if (n.length - 1) this.yylineno -= n.length - 1
            var i = this.yylloc.range
            this.yylloc = {
              first_line: this.yylloc.first_line,
              last_line: this.yylineno + 1,
              first_column: this.yylloc.first_column,
              last_column: n
                ? (n.length === r.length ? this.yylloc.first_column : 0) + r[r.length - n.length].length - n[0].length
                : this.yylloc.first_column - t
            }
            if (this.options.ranges) {
              this.yylloc.range = [i[0], i[0] + this.yyleng - t]
            }
            return this
          },
          more: function () {
            this._more = true
            return this
          },
          less: function (e) {
            this.unput(this.match.slice(e))
          },
          pastInput: function () {
            var e = this.matched.substr(0, this.matched.length - this.match.length)
            return (e.length > 20 ? '...' : '') + e.substr(-20).replace(/\n/g, '')
          },
          upcomingInput: function () {
            var e = this.match
            if (e.length < 20) {
              e += this._input.substr(0, 20 - e.length)
            }
            return (e.substr(0, 20) + (e.length > 20 ? '...' : '')).replace(/\n/g, '')
          },
          showPosition: function () {
            var e = this.pastInput()
            var t = new Array(e.length + 1).join('-')
            return e + this.upcomingInput() + '\n' + t + '^'
          },
          next: function () {
            if (this.done) {
              return this.EOF
            }
            if (!this._input) this.done = true
            var e, t, n, r, i, s
            if (!this._more) {
              this.yytext = ''
              this.match = ''
            }
            var o = this._currentRules()
            for (var u = 0; u < o.length; u++) {
              n = this._input.match(this.rules[o[u]])
              if (n && (!t || n[0].length > t[0].length)) {
                t = n
                r = u
                if (!this.options.flex) break
              }
            }
            if (t) {
              s = t[0].match(/(?:\r\n?|\n).*/g)
              if (s) this.yylineno += s.length
              this.yylloc = {
                first_line: this.yylloc.last_line,
                last_line: this.yylineno + 1,
                first_column: this.yylloc.last_column,
                last_column: s
                  ? s[s.length - 1].length - s[s.length - 1].match(/\r?\n?/)[0].length
                  : this.yylloc.last_column + t[0].length
              }
              this.yytext += t[0]
              this.match += t[0]
              this.matches = t
              this.yyleng = this.yytext.length
              if (this.options.ranges) {
                this.yylloc.range = [this.offset, (this.offset += this.yyleng)]
              }
              this._more = false
              this._input = this._input.slice(t[0].length)
              this.matched += t[0]
              e = this.performAction.call(
                this,
                this.yy,
                this,
                o[r],
                this.conditionStack[this.conditionStack.length - 1]
              )
              if (this.done && this._input) this.done = false
              if (e) return e
              else return
            }
            if (this._input === '') {
              return this.EOF
            } else {
              return this.parseError(
                'Lexical error on line ' + (this.yylineno + 1) + '. Unrecognized text.\n' + this.showPosition(),
                { text: '', token: null, line: this.yylineno }
              )
            }
          },
          lex: function () {
            var t = this.next()
            if (typeof t !== 'undefined') {
              return t
            } else {
              return this.lex()
            }
          },
          begin: function (t) {
            this.conditionStack.push(t)
          },
          popState: function () {
            return this.conditionStack.pop()
          },
          _currentRules: function () {
            return this.conditions[this.conditionStack[this.conditionStack.length - 1]].rules
          },
          topState: function () {
            return this.conditionStack[this.conditionStack.length - 2]
          },
          pushState: function (t) {
            this.begin(t)
          }
        }
        e.options = {}
        e.performAction = function (t, n, r, i) {
          function s(e, t) {
            return (n.yytext = n.yytext.substr(e, n.yyleng - t))
          }
          var o = i
          switch (r) {
            case 0:
              if (n.yytext.slice(-2) === '\\\\') {
                s(0, 1)
                this.begin('mu')
              } else if (n.yytext.slice(-1) === '\\') {
                s(0, 1)
                this.begin('emu')
              } else {
                this.begin('mu')
              }
              if (n.yytext) return 14
              break
            case 1:
              return 14
              break
            case 2:
              this.popState()
              return 14
              break
            case 3:
              s(0, 4)
              this.popState()
              return 15
              break
            case 4:
              return 35
              break
            case 5:
              return 36
              break
            case 6:
              return 25
              break
            case 7:
              return 16
              break
            case 8:
              return 20
              break
            case 9:
              return 19
              break
            case 10:
              return 19
              break
            case 11:
              return 23
              break
            case 12:
              return 22
              break
            case 13:
              this.popState()
              this.begin('com')
              break
            case 14:
              s(3, 5)
              this.popState()
              return 15
              break
            case 15:
              return 22
              break
            case 16:
              return 41
              break
            case 17:
              return 40
              break
            case 18:
              return 40
              break
            case 19:
              return 44
              break
            case 20:
              break
            case 21:
              this.popState()
              return 24
              break
            case 22:
              this.popState()
              return 18
              break
            case 23:
              n.yytext = s(1, 2).replace(/\\"/g, '"')
              return 32
              break
            case 24:
              n.yytext = s(1, 2).replace(/\\'/g, "'")
              return 32
              break
            case 25:
              return 42
              break
            case 26:
              return 34
              break
            case 27:
              return 34
              break
            case 28:
              return 33
              break
            case 29:
              return 40
              break
            case 30:
              n.yytext = s(1, 2)
              return 40
              break
            case 31:
              return 'INVALID'
              break
            case 32:
              return 5
              break
          }
        }
        e.rules = [
          /^(?:[^\x00]*?(?=(\{\{)))/,
          /^(?:[^\x00]+)/,
          /^(?:[^\x00]{2,}?(?=(\{\{|\\\{\{|\\\\\{\{|$)))/,
          /^(?:[\s\S]*?--\}\})/,
          /^(?:\()/,
          /^(?:\))/,
          /^(?:\{\{(~)?>)/,
          /^(?:\{\{(~)?#)/,
          /^(?:\{\{(~)?\/)/,
          /^(?:\{\{(~)?\^)/,
          /^(?:\{\{(~)?\s*else\b)/,
          /^(?:\{\{(~)?\{)/,
          /^(?:\{\{(~)?&)/,
          /^(?:\{\{!--)/,
          /^(?:\{\{![\s\S]*?\}\})/,
          /^(?:\{\{(~)?)/,
          /^(?:=)/,
          /^(?:\.\.)/,
          /^(?:\.(?=([=~}\s\/.)])))/,
          /^(?:[\/.])/,
          /^(?:\s+)/,
          /^(?:\}(~)?\}\})/,
          /^(?:(~)?\}\})/,
          /^(?:"(\\["]|[^"])*")/,
          /^(?:'(\\[']|[^'])*')/,
          /^(?:@)/,
          /^(?:true(?=([~}\s)])))/,
          /^(?:false(?=([~}\s)])))/,
          /^(?:-?[0-9]+(?=([~}\s)])))/,
          /^(?:([^\s!"#%-,\.\/;->@\[-\^`\{-~]+(?=([=~}\s\/.)]))))/,
          /^(?:\[[^\]]*\])/,
          /^(?:.)/,
          /^(?:$)/
        ]
        e.conditions = {
          mu: {
            rules: [
              4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31,
              32
            ],
            inclusive: false
          },
          emu: { rules: [2], inclusive: false },
          com: { rules: [3], inclusive: false },
          INITIAL: { rules: [0, 1, 32], inclusive: true }
        }
        return e
      })()
      e.lexer = n
      r.prototype = e
      e.Parser = r
      return new r()
    })()
    e = t
    return e
  })()
  var a = (function (e, t) {
    'use strict'
    function s(e) {
      if (e.constructor === i.ProgramNode) {
        return e
      }
      r.yy = i
      return r.parse(e)
    }
    var n = {}
    var r = e
    var i = t
    n.parser = r
    n.parse = s
    return n
  })(u, o)
  var f = (function (e) {
    'use strict'
    function r() {}
    function i(e, t, r) {
      if (e == null || (typeof e !== 'string' && e.constructor !== r.AST.ProgramNode)) {
        throw new n('You must pass a string or Handlebars AST to Handlebars.precompile. You passed ' + e)
      }
      t = t || {}
      if (!('data' in t)) {
        t.data = true
      }
      var i = r.parse(e)
      var s = new r.Compiler().compile(i, t)
      return new r.JavaScriptCompiler().compile(s, t)
    }
    function s(e, t, r) {
      function s() {
        var n = r.parse(e)
        var i = new r.Compiler().compile(n, t)
        var s = new r.JavaScriptCompiler().compile(i, t, undefined, true)
        return r.template(s)
      }
      if (e == null || (typeof e !== 'string' && e.constructor !== r.AST.ProgramNode)) {
        throw new n('You must pass a string or Handlebars AST to Handlebars.compile. You passed ' + e)
      }
      t = t || {}
      if (!('data' in t)) {
        t.data = true
      }
      var i
      return function (e, t) {
        if (!i) {
          i = s()
        }
        return i.call(this, e, t)
      }
    }
    var t = {}
    var n = e
    t.Compiler = r
    r.prototype = {
      compiler: r,
      disassemble: function () {
        var e = this.opcodes,
          t,
          n = [],
          r,
          i
        for (var s = 0, o = e.length; s < o; s++) {
          t = e[s]
          if (t.opcode === 'DECLARE') {
            n.push('DECLARE ' + t.name + '=' + t.value)
          } else {
            r = []
            for (var u = 0; u < t.args.length; u++) {
              i = t.args[u]
              if (typeof i === 'string') {
                i = '"' + i.replace('\n', '\\n') + '"'
              }
              r.push(i)
            }
            n.push(t.opcode + ' ' + r.join(' '))
          }
        }
        return n.join('\n')
      },
      equals: function (e) {
        var t = this.opcodes.length
        if (e.opcodes.length !== t) {
          return false
        }
        for (var n = 0; n < t; n++) {
          var r = this.opcodes[n],
            i = e.opcodes[n]
          if (r.opcode !== i.opcode || r.args.length !== i.args.length) {
            return false
          }
          for (var s = 0; s < r.args.length; s++) {
            if (r.args[s] !== i.args[s]) {
              return false
            }
          }
        }
        t = this.children.length
        if (e.children.length !== t) {
          return false
        }
        for (n = 0; n < t; n++) {
          if (!this.children[n].equals(e.children[n])) {
            return false
          }
        }
        return true
      },
      guid: 0,
      compile: function (e, t) {
        this.opcodes = []
        this.children = []
        this.depths = { list: [] }
        this.options = t
        var n = this.options.knownHelpers
        this.options.knownHelpers = {
          helperMissing: true,
          blockHelperMissing: true,
          each: true,
          if: true,
          unless: true,
          with: true,
          log: true
        }
        if (n) {
          for (var r in n) {
            this.options.knownHelpers[r] = n[r]
          }
        }
        return this.accept(e)
      },
      accept: function (e) {
        var t = e.strip || {},
          n
        if (t.left) {
          this.opcode('strip')
        }
        n = this[e.type](e)
        if (t.right) {
          this.opcode('strip')
        }
        return n
      },
      program: function (e) {
        var t = e.statements
        for (var n = 0, r = t.length; n < r; n++) {
          this.accept(t[n])
        }
        this.isSimple = r === 1
        this.depths.list = this.depths.list.sort(function (e, t) {
          return e - t
        })
        return this
      },
      compileProgram: function (e) {
        var t = new this.compiler().compile(e, this.options)
        var n = this.guid++,
          r
        this.usePartial = this.usePartial || t.usePartial
        this.children[n] = t
        for (var i = 0, s = t.depths.list.length; i < s; i++) {
          r = t.depths.list[i]
          if (r < 2) {
            continue
          } else {
            this.addDepth(r - 1)
          }
        }
        return n
      },
      block: function (e) {
        var t = e.mustache,
          n = e.program,
          r = e.inverse
        if (n) {
          n = this.compileProgram(n)
        }
        if (r) {
          r = this.compileProgram(r)
        }
        var i = t.sexpr
        var s = this.classifySexpr(i)
        if (s === 'helper') {
          this.helperSexpr(i, n, r)
        } else if (s === 'simple') {
          this.simpleSexpr(i)
          this.opcode('pushProgram', n)
          this.opcode('pushProgram', r)
          this.opcode('emptyHash')
          this.opcode('blockValue')
        } else {
          this.ambiguousSexpr(i, n, r)
          this.opcode('pushProgram', n)
          this.opcode('pushProgram', r)
          this.opcode('emptyHash')
          this.opcode('ambiguousBlockValue')
        }
        this.opcode('append')
      },
      hash: function (e) {
        var t = e.pairs,
          n,
          r
        this.opcode('pushHash')
        for (var i = 0, s = t.length; i < s; i++) {
          n = t[i]
          r = n[1]
          if (this.options.stringParams) {
            if (r.depth) {
              this.addDepth(r.depth)
            }
            this.opcode('getContext', r.depth || 0)
            this.opcode('pushStringParam', r.stringModeValue, r.type)
            if (r.type === 'sexpr') {
              this.sexpr(r)
            }
          } else {
            this.accept(r)
          }
          this.opcode('assignToHash', n[0])
        }
        this.opcode('popHash')
      },
      partial: function (e) {
        var t = e.partialName
        this.usePartial = true
        if (e.context) {
          this.ID(e.context)
        } else {
          this.opcode('push', 'depth0')
        }
        this.opcode('invokePartial', t.name)
        this.opcode('append')
      },
      content: function (e) {
        this.opcode('appendContent', e.string)
      },
      mustache: function (e) {
        this.sexpr(e.sexpr)
        if (e.escaped && !this.options.noEscape) {
          this.opcode('appendEscaped')
        } else {
          this.opcode('append')
        }
      },
      ambiguousSexpr: function (e, t, n) {
        var r = e.id,
          i = r.parts[0],
          s = t != null || n != null
        this.opcode('getContext', r.depth)
        this.opcode('pushProgram', t)
        this.opcode('pushProgram', n)
        this.opcode('invokeAmbiguous', i, s)
      },
      simpleSexpr: function (e) {
        var t = e.id
        if (t.type === 'DATA') {
          this.DATA(t)
        } else if (t.parts.length) {
          this.ID(t)
        } else {
          this.addDepth(t.depth)
          this.opcode('getContext', t.depth)
          this.opcode('pushContext')
        }
        this.opcode('resolvePossibleLambda')
      },
      helperSexpr: function (e, t, r) {
        var i = this.setupFullMustacheParams(e, t, r),
          s = e.id.parts[0]
        if (this.options.knownHelpers[s]) {
          this.opcode('invokeKnownHelper', i.length, s)
        } else if (this.options.knownHelpersOnly) {
          throw new n('You specified knownHelpersOnly, but used the unknown helper ' + s, e)
        } else {
          this.opcode('invokeHelper', i.length, s, e.isRoot)
        }
      },
      sexpr: function (e) {
        var t = this.classifySexpr(e)
        if (t === 'simple') {
          this.simpleSexpr(e)
        } else if (t === 'helper') {
          this.helperSexpr(e)
        } else {
          this.ambiguousSexpr(e)
        }
      },
      ID: function (e) {
        this.addDepth(e.depth)
        this.opcode('getContext', e.depth)
        var t = e.parts[0]
        if (!t) {
          this.opcode('pushContext')
        } else {
          this.opcode('lookupOnContext', e.parts[0])
        }
        for (var n = 1, r = e.parts.length; n < r; n++) {
          this.opcode('lookup', e.parts[n])
        }
      },
      DATA: function (e) {
        this.options.data = true
        if (e.id.isScoped || e.id.depth) {
          throw new n('Scoped data references are not supported: ' + e.original, e)
        }
        this.opcode('lookupData')
        var t = e.id.parts
        for (var r = 0, i = t.length; r < i; r++) {
          this.opcode('lookup', t[r])
        }
      },
      STRING: function (e) {
        this.opcode('pushString', e.string)
      },
      INTEGER: function (e) {
        this.opcode('pushLiteral', e.integer)
      },
      BOOLEAN: function (e) {
        this.opcode('pushLiteral', e.bool)
      },
      comment: function () {},
      opcode: function (e) {
        this.opcodes.push({ opcode: e, args: [].slice.call(arguments, 1) })
      },
      declare: function (e, t) {
        this.opcodes.push({ opcode: 'DECLARE', name: e, value: t })
      },
      addDepth: function (e) {
        if (e === 0) {
          return
        }
        if (!this.depths[e]) {
          this.depths[e] = true
          this.depths.list.push(e)
        }
      },
      classifySexpr: function (e) {
        var t = e.isHelper
        var n = e.eligibleHelper
        var r = this.options
        if (n && !t) {
          var i = e.id.parts[0]
          if (r.knownHelpers[i]) {
            t = true
          } else if (r.knownHelpersOnly) {
            n = false
          }
        }
        if (t) {
          return 'helper'
        } else if (n) {
          return 'ambiguous'
        } else {
          return 'simple'
        }
      },
      pushParams: function (e) {
        var t = e.length,
          n
        while (t--) {
          n = e[t]
          if (this.options.stringParams) {
            if (n.depth) {
              this.addDepth(n.depth)
            }
            this.opcode('getContext', n.depth || 0)
            this.opcode('pushStringParam', n.stringModeValue, n.type)
            if (n.type === 'sexpr') {
              this.sexpr(n)
            }
          } else {
            this[n.type](n)
          }
        }
      },
      setupFullMustacheParams: function (e, t, n) {
        var r = e.params
        this.pushParams(r)
        this.opcode('pushProgram', t)
        this.opcode('pushProgram', n)
        if (e.hash) {
          this.hash(e.hash)
        } else {
          this.opcode('emptyHash')
        }
        return r
      }
    }
    t.precompile = i
    t.compile = s
    return t
  })(n)
  var l = (function (e, t) {
    'use strict'
    function u(e) {
      this.value = e
    }
    function a() {}
    var n
    var r = e.COMPILER_REVISION
    var i = e.REVISION_CHANGES
    var s = e.log
    var o = t
    a.prototype = {
      nameLookup: function (e, t) {
        var n, r
        if (e.indexOf('depth') === 0) {
          n = true
        }
        if (/^[0-9]+$/.test(t)) {
          r = e + '[' + t + ']'
        } else if (a.isValidJavaScriptVariableName(t)) {
          r = e + '.' + t
        } else {
          r = e + "['" + t + "']"
        }
        if (n) {
          return '(' + e + ' && ' + r + ')'
        } else {
          return r
        }
      },
      compilerInfo: function () {
        var e = r,
          t = i[e]
        return 'this.compilerInfo = [' + e + ",'" + t + "'];\n"
      },
      appendToBuffer: function (e) {
        if (this.environment.isSimple) {
          return 'return ' + e + ';'
        } else {
          return {
            appendToBuffer: true,
            content: e,
            toString: function () {
              return 'buffer += ' + e + ';'
            }
          }
        }
      },
      initializeBuffer: function () {
        return this.quotedString('')
      },
      namespace: 'Handlebars',
      compile: function (e, t, n, r) {
        this.environment = e
        this.options = t || {}
        s('debug', this.environment.disassemble() + '\n\n')
        this.name = this.environment.name
        this.isChild = !!n
        this.context = n || { programs: [], environments: [], aliases: {} }
        this.preamble()
        this.stackSlot = 0
        this.stackVars = []
        this.registers = { list: [] }
        this.hashes = []
        this.compileStack = []
        this.inlineStack = []
        this.compileChildren(e, t)
        var i = e.opcodes,
          u
        this.i = 0
        for (var a = i.length; this.i < a; this.i++) {
          u = i[this.i]
          if (u.opcode === 'DECLARE') {
            this[u.name] = u.value
          } else {
            this[u.opcode].apply(this, u.args)
          }
          if (u.opcode !== this.stripNext) {
            this.stripNext = false
          }
        }
        this.pushSource('')
        if (this.stackSlot || this.inlineStack.length || this.compileStack.length) {
          throw new o('Compile completed with content left on stack')
        }
        return this.createFunctionContext(r)
      },
      preamble: function () {
        var e = []
        if (!this.isChild) {
          var t = this.namespace
          var n = 'helpers = this.merge(helpers, ' + t + '.helpers);'
          if (this.environment.usePartial) {
            n = n + ' partials = this.merge(partials, ' + t + '.partials);'
          }
          if (this.options.data) {
            n = n + ' data = data || {};'
          }
          e.push(n)
        } else {
          e.push('')
        }
        if (!this.environment.isSimple) {
          e.push(', buffer = ' + this.initializeBuffer())
        } else {
          e.push('')
        }
        this.lastContext = 0
        this.source = e
      },
      createFunctionContext: function (e) {
        var t = this.stackVars.concat(this.registers.list)
        if (t.length > 0) {
          this.source[1] = this.source[1] + ', ' + t.join(', ')
        }
        if (!this.isChild) {
          for (var n in this.context.aliases) {
            if (this.context.aliases.hasOwnProperty(n)) {
              this.source[1] = this.source[1] + ', ' + n + '=' + this.context.aliases[n]
            }
          }
        }
        if (this.source[1]) {
          this.source[1] = 'var ' + this.source[1].substring(2) + ';'
        }
        if (!this.isChild) {
          this.source[1] += '\n' + this.context.programs.join('\n') + '\n'
        }
        if (!this.environment.isSimple) {
          this.pushSource('return buffer;')
        }
        var r = this.isChild ? ['depth0', 'data'] : ['Handlebars', 'depth0', 'helpers', 'partials', 'data']
        for (var i = 0, o = this.environment.depths.list.length; i < o; i++) {
          r.push('depth' + this.environment.depths.list[i])
        }
        var u = this.mergeSource()
        if (!this.isChild) {
          u = this.compilerInfo() + u
        }
        if (e) {
          r.push(u)
          return Function.apply(this, r)
        } else {
          var a = 'function ' + (this.name || '') + '(' + r.join(',') + ') {\n  ' + u + '}'
          s('debug', a + '\n\n')
          return a
        }
      },
      mergeSource: function () {
        var e = '',
          t
        for (var n = 0, r = this.source.length; n < r; n++) {
          var i = this.source[n]
          if (i.appendToBuffer) {
            if (t) {
              t = t + '\n    + ' + i.content
            } else {
              t = i.content
            }
          } else {
            if (t) {
              e += 'buffer += ' + t + ';\n  '
              t = undefined
            }
            e += i + '\n  '
          }
        }
        return e
      },
      blockValue: function () {
        this.context.aliases.blockHelperMissing = 'helpers.blockHelperMissing'
        var e = ['depth0']
        this.setupParams(0, e)
        this.replaceStack(function (t) {
          e.splice(1, 0, t)
          return 'blockHelperMissing.call(' + e.join(', ') + ')'
        })
      },
      ambiguousBlockValue: function () {
        this.context.aliases.blockHelperMissing = 'helpers.blockHelperMissing'
        var e = ['depth0']
        this.setupParams(0, e)
        var t = this.topStack()
        e.splice(1, 0, t)
        this.pushSource('if (!' + this.lastHelper + ') { ' + t + ' = blockHelperMissing.call(' + e.join(', ') + '); }')
      },
      appendContent: function (e) {
        if (this.pendingContent) {
          e = this.pendingContent + e
        }
        if (this.stripNext) {
          e = e.replace(/^\s+/, '')
        }
        this.pendingContent = e
      },
      strip: function () {
        if (this.pendingContent) {
          this.pendingContent = this.pendingContent.replace(/\s+$/, '')
        }
        this.stripNext = 'strip'
      },
      append: function () {
        this.flushInline()
        var e = this.popStack()
        this.pushSource('if(' + e + ' || ' + e + ' === 0) { ' + this.appendToBuffer(e) + ' }')
        if (this.environment.isSimple) {
          this.pushSource('else { ' + this.appendToBuffer("''") + ' }')
        }
      },
      appendEscaped: function () {
        this.context.aliases.escapeExpression = 'this.escapeExpression'
        this.pushSource(this.appendToBuffer('escapeExpression(' + this.popStack() + ')'))
      },
      getContext: function (e) {
        if (this.lastContext !== e) {
          this.lastContext = e
        }
      },
      lookupOnContext: function (e) {
        this.push(this.nameLookup('depth' + this.lastContext, e, 'context'))
      },
      pushContext: function () {
        this.pushStackLiteral('depth' + this.lastContext)
      },
      resolvePossibleLambda: function () {
        this.context.aliases.functionType = '"function"'
        this.replaceStack(function (e) {
          return 'typeof ' + e + ' === functionType ? ' + e + '.apply(depth0) : ' + e
        })
      },
      lookup: function (e) {
        this.replaceStack(function (t) {
          return t + ' == null || ' + t + ' === false ? ' + t + ' : ' + this.nameLookup(t, e, 'context')
        })
      },
      lookupData: function () {
        this.pushStackLiteral('data')
      },
      pushStringParam: function (e, t) {
        this.pushStackLiteral('depth' + this.lastContext)
        this.pushString(t)
        if (t !== 'sexpr') {
          if (typeof e === 'string') {
            this.pushString(e)
          } else {
            this.pushStackLiteral(e)
          }
        }
      },
      emptyHash: function () {
        this.pushStackLiteral('{}')
        if (this.options.stringParams) {
          this.push('{}')
          this.push('{}')
        }
      },
      pushHash: function () {
        if (this.hash) {
          this.hashes.push(this.hash)
        }
        this.hash = { values: [], types: [], contexts: [] }
      },
      popHash: function () {
        var e = this.hash
        this.hash = this.hashes.pop()
        if (this.options.stringParams) {
          this.push('{' + e.contexts.join(',') + '}')
          this.push('{' + e.types.join(',') + '}')
        }
        this.push('{\n    ' + e.values.join(',\n    ') + '\n  }')
      },
      pushString: function (e) {
        this.pushStackLiteral(this.quotedString(e))
      },
      push: function (e) {
        this.inlineStack.push(e)
        return e
      },
      pushLiteral: function (e) {
        this.pushStackLiteral(e)
      },
      pushProgram: function (e) {
        if (e != null) {
          this.pushStackLiteral(this.programExpression(e))
        } else {
          this.pushStackLiteral(null)
        }
      },
      invokeHelper: function (e, t, n) {
        this.context.aliases.helperMissing = 'helpers.helperMissing'
        this.useRegister('helper')
        var r = (this.lastHelper = this.setupHelper(e, t, true))
        var i = this.nameLookup('depth' + this.lastContext, t, 'context')
        var s = 'helper = ' + r.name + ' || ' + i
        if (r.paramsInit) {
          s += ',' + r.paramsInit
        }
        this.push(
          '(' +
            s +
            ',helper ' +
            '? helper.call(' +
            r.callParams +
            ') ' +
            ': helperMissing.call(' +
            r.helperMissingParams +
            '))'
        )
        if (!n) {
          this.flushInline()
        }
      },
      invokeKnownHelper: function (e, t) {
        var n = this.setupHelper(e, t)
        this.push(n.name + '.call(' + n.callParams + ')')
      },
      invokeAmbiguous: function (e, t) {
        this.context.aliases.functionType = '"function"'
        this.useRegister('helper')
        this.emptyHash()
        var n = this.setupHelper(0, e, t)
        var r = (this.lastHelper = this.nameLookup('helpers', e, 'helper'))
        var i = this.nameLookup('depth' + this.lastContext, e, 'context')
        var s = this.nextStack()
        if (n.paramsInit) {
          this.pushSource(n.paramsInit)
        }
        this.pushSource('if (helper = ' + r + ') { ' + s + ' = helper.call(' + n.callParams + '); }')
        this.pushSource(
          'else { helper = ' +
            i +
            '; ' +
            s +
            ' = typeof helper === functionType ? helper.call(' +
            n.callParams +
            ') : helper; }'
        )
      },
      invokePartial: function (e) {
        var t = [this.nameLookup('partials', e, 'partial'), "'" + e + "'", this.popStack(), 'helpers', 'partials']
        if (this.options.data) {
          t.push('data')
        }
        this.context.aliases.self = 'this'
        this.push('self.invokePartial(' + t.join(', ') + ')')
      },
      assignToHash: function (e) {
        var t = this.popStack(),
          n,
          r
        if (this.options.stringParams) {
          r = this.popStack()
          n = this.popStack()
        }
        var i = this.hash
        if (n) {
          i.contexts.push("'" + e + "': " + n)
        }
        if (r) {
          i.types.push("'" + e + "': " + r)
        }
        i.values.push("'" + e + "': (" + t + ')')
      },
      compiler: a,
      compileChildren: function (e, t) {
        var n = e.children,
          r,
          i
        for (var s = 0, o = n.length; s < o; s++) {
          r = n[s]
          i = new this.compiler()
          var u = this.matchExistingProgram(r)
          if (u == null) {
            this.context.programs.push('')
            u = this.context.programs.length
            r.index = u
            r.name = 'program' + u
            this.context.programs[u] = i.compile(r, t, this.context)
            this.context.environments[u] = r
          } else {
            r.index = u
            r.name = 'program' + u
          }
        }
      },
      matchExistingProgram: function (e) {
        for (var t = 0, n = this.context.environments.length; t < n; t++) {
          var r = this.context.environments[t]
          if (r && r.equals(e)) {
            return t
          }
        }
      },
      programExpression: function (e) {
        this.context.aliases.self = 'this'
        if (e == null) {
          return 'self.noop'
        }
        var t = this.environment.children[e],
          n = t.depths.list,
          r
        var i = [t.index, t.name, 'data']
        for (var s = 0, o = n.length; s < o; s++) {
          r = n[s]
          if (r === 1) {
            i.push('depth0')
          } else {
            i.push('depth' + (r - 1))
          }
        }
        return (n.length === 0 ? 'self.program(' : 'self.programWithDepth(') + i.join(', ') + ')'
      },
      register: function (e, t) {
        this.useRegister(e)
        this.pushSource(e + ' = ' + t + ';')
      },
      useRegister: function (e) {
        if (!this.registers[e]) {
          this.registers[e] = true
          this.registers.list.push(e)
        }
      },
      pushStackLiteral: function (e) {
        return this.push(new u(e))
      },
      pushSource: function (e) {
        if (this.pendingContent) {
          this.source.push(this.appendToBuffer(this.quotedString(this.pendingContent)))
          this.pendingContent = undefined
        }
        if (e) {
          this.source.push(e)
        }
      },
      pushStack: function (e) {
        this.flushInline()
        var t = this.incrStack()
        if (e) {
          this.pushSource(t + ' = ' + e + ';')
        }
        this.compileStack.push(t)
        return t
      },
      replaceStack: function (e) {
        var t = '',
          n = this.isInline(),
          r,
          i,
          s
        if (n) {
          var o = this.popStack(true)
          if (o instanceof u) {
            r = o.value
            s = true
          } else {
            i = !this.stackSlot
            var a = !i ? this.topStackName() : this.incrStack()
            t = '(' + this.push(a) + ' = ' + o + '),'
            r = this.topStack()
          }
        } else {
          r = this.topStack()
        }
        var f = e.call(this, r)
        if (n) {
          if (!s) {
            this.popStack()
          }
          if (i) {
            this.stackSlot--
          }
          this.push('(' + t + f + ')')
        } else {
          if (!/^stack/.test(r)) {
            r = this.nextStack()
          }
          this.pushSource(r + ' = (' + t + f + ');')
        }
        return r
      },
      nextStack: function () {
        return this.pushStack()
      },
      incrStack: function () {
        this.stackSlot++
        if (this.stackSlot > this.stackVars.length) {
          this.stackVars.push('stack' + this.stackSlot)
        }
        return this.topStackName()
      },
      topStackName: function () {
        return 'stack' + this.stackSlot
      },
      flushInline: function () {
        var e = this.inlineStack
        if (e.length) {
          this.inlineStack = []
          for (var t = 0, n = e.length; t < n; t++) {
            var r = e[t]
            if (r instanceof u) {
              this.compileStack.push(r)
            } else {
              this.pushStack(r)
            }
          }
        }
      },
      isInline: function () {
        return this.inlineStack.length
      },
      popStack: function (e) {
        var t = this.isInline(),
          n = (t ? this.inlineStack : this.compileStack).pop()
        if (!e && n instanceof u) {
          return n.value
        } else {
          if (!t) {
            if (!this.stackSlot) {
              throw new o('Invalid stack pop')
            }
            this.stackSlot--
          }
          return n
        }
      },
      topStack: function (e) {
        var t = this.isInline() ? this.inlineStack : this.compileStack,
          n = t[t.length - 1]
        if (!e && n instanceof u) {
          return n.value
        } else {
          return n
        }
      },
      quotedString: function (e) {
        return (
          '"' +
          e
            .replace(/\\/g, '\\\\')
            .replace(/"/g, '\\"')
            .replace(/\n/g, '\\n')
            .replace(/\r/g, '\\r')
            .replace(/\u2028/g, '\\u2028')
            .replace(/\u2029/g, '\\u2029') +
          '"'
        )
      },
      setupHelper: function (e, t, n) {
        var r = [],
          i = this.setupParams(e, r, n)
        var s = this.nameLookup('helpers', t, 'helper')
        return {
          params: r,
          paramsInit: i,
          name: s,
          callParams: ['depth0'].concat(r).join(', '),
          helperMissingParams: n && ['depth0', this.quotedString(t)].concat(r).join(', ')
        }
      },
      setupOptions: function (e, t) {
        var n = [],
          r = [],
          i = [],
          s,
          o,
          u
        n.push('hash:' + this.popStack())
        if (this.options.stringParams) {
          n.push('hashTypes:' + this.popStack())
          n.push('hashContexts:' + this.popStack())
        }
        o = this.popStack()
        u = this.popStack()
        if (u || o) {
          if (!u) {
            this.context.aliases.self = 'this'
            u = 'self.noop'
          }
          if (!o) {
            this.context.aliases.self = 'this'
            o = 'self.noop'
          }
          n.push('inverse:' + o)
          n.push('fn:' + u)
        }
        for (var a = 0; a < e; a++) {
          s = this.popStack()
          t.push(s)
          if (this.options.stringParams) {
            i.push(this.popStack())
            r.push(this.popStack())
          }
        }
        if (this.options.stringParams) {
          n.push('contexts:[' + r.join(',') + ']')
          n.push('types:[' + i.join(',') + ']')
        }
        if (this.options.data) {
          n.push('data:data')
        }
        return n
      },
      setupParams: function (e, t, n) {
        var r = '{' + this.setupOptions(e, t).join(',') + '}'
        if (n) {
          this.useRegister('options')
          t.push('options')
          return 'options=' + r
        } else {
          t.push(r)
          return ''
        }
      }
    }
    var f = (
      'break else new var' +
      ' case finally return void' +
      ' catch for switch while' +
      ' continue function this with' +
      ' default if throw' +
      ' delete in try' +
      ' do instanceof typeof' +
      ' abstract enum int short' +
      ' boolean export interface static' +
      ' byte extends long super' +
      ' char final native synchronized' +
      ' class float package throws' +
      ' const goto private transient' +
      ' debugger implements protected volatile' +
      ' double import public let yield'
    ).split(' ')
    var l = (a.RESERVED_WORDS = {})
    for (var c = 0, h = f.length; c < h; c++) {
      l[f[c]] = true
    }
    a.isValidJavaScriptVariableName = function (e) {
      if (!a.RESERVED_WORDS[e] && /^[a-zA-Z_$][0-9a-zA-Z_$]*$/.test(e)) {
        return true
      }
      return false
    }
    n = a
    return n
  })(r, n)
  var c = (function (e, t, n, r, i) {
    'use strict'
    var s
    var o = e
    var u = t
    var a = n.parser
    var f = n.parse
    var l = r.Compiler
    var c = r.compile
    var h = r.precompile
    var p = i
    var d = o.create
    var v = function () {
      var e = d()
      e.compile = function (t, n) {
        return c(t, n, e)
      }
      e.precompile = function (t, n) {
        return h(t, n, e)
      }
      e.AST = u
      e.Compiler = l
      e.JavaScriptCompiler = p
      e.Parser = a
      e.parse = f
      return e
    }
    o = v()
    o.create = v
    s = o
    return s
  })(s, o, a, f, l)
  return c
})()


/*!
 * ajax-cart.js
 */
/*============================================================================
	Ajax the add to cart experience
	Plugin Documentation - http://shopify.github.io/Timber/#ajax-cart
	(c) Copyright 2015 Shopify Inc. Author: Carson Shold (@cshold). All Rights Reserved.

	This file includes:
		- Basic Shopify Ajax API calls
		- Ajax cart plugin

	This requires:
		- jQuery 1.8+
		- handlebars.min.js (for cart template)
		- modernizr.min.js
		- snippet/ajax-cart-template.liquid

	Customized version of Shopify's jQuery API
	(c) Copyright 2009-2015 Shopify Inc. Author: Caroline Schnapp. All Rights Reserved.
==============================================================================*/
if (typeof ShopifyAPI === 'undefined') {
  ShopifyAPI = {}
}

/*============================================================================
	API Helper Functions
==============================================================================*/
function attributeToString(attribute) {
  if (typeof attribute !== 'string') {
    attribute += ''
    if (attribute === 'undefined') {
      attribute = ''
    }
  }
  return jQuery.trim(attribute)
}

/*============================================================================
	API Functions
==============================================================================*/
ShopifyAPI.onCartUpdate = function (cart) {
  // alert('There are now ' + cart.item_count + ' items in the cart.');
}

ShopifyAPI.updateCartNote = function (note, callback) {
  var $body = $(document.body),
    params = {
      type: 'POST',
      url: '/cart/update.js',
      data: 'note=' + attributeToString(note),
      dataType: 'json',
      beforeSend: function () {
        $body.trigger('beforeUpdateCartNote.ajaxCart', note)
      },
      success: function (cart) {
        if (typeof callback === 'function') {
          callback(cart)
        } else {
          ShopifyAPI.onCartUpdate(cart)
        }
        $body.trigger('afterUpdateCartNote.ajaxCart', [note, cart])
      },
      error: function (XMLHttpRequest, textStatus) {
        $body.trigger('errorUpdateCartNote.ajaxCart', [XMLHttpRequest, textStatus])
        ShopifyAPI.onError(XMLHttpRequest, textStatus)
      },
      complete: function (jqxhr, text) {
        $body.trigger('completeUpdateCartNote.ajaxCart', [this, jqxhr, text])
      }
    }
  jQuery.ajax(params)
}

ShopifyAPI.updateCartAttribute = function (attribute, value, callback) {
  var $body = $(document.body),
    params = {
      type: 'POST',
      url: '/cart/update.js',
      data: JSON.stringify({ attributes: { [attribute]: value } }),
      contentType: 'application/json',
      dataType: 'json',
      beforeSend: function () {
        $body.trigger('beforeUpdateCartAttribute.ajaxCart', [attribute, value])
      },
      success: function (cart) {
        if (typeof callback === 'function') {
          callback(cart)
        } else {
          ShopifyAPI.onCartUpdate(cart)
        }
        $body.trigger('afterUpdateCartAttribute.ajaxCart', [attribute, value, cart])
      },
      error: function (XMLHttpRequest, textStatus) {
        $body.trigger('errorUpdateCartAttribute.ajaxCart', [XMLHttpRequest, textStatus])
        ShopifyAPI.onError(XMLHttpRequest, textStatus)
      },
      complete: function (jqxhr, text) {
        $body.trigger('completeUpdateCartAttribute.ajaxCart', [this, jqxhr, text])
      }
    }
  jQuery.ajax(params)
}

ShopifyAPI.onError = function (XMLHttpRequest, textStatus) {
  var data = eval('(' + XMLHttpRequest.responseText + ')')
  if (!!data.message) {
    alert(data.message + '(' + data.status + '): ' + data.description)
  }
}

/*============================================================================
	POST to cart/add.js returns the JSON of the cart
		- Allow use of form element instead of just id
		- Allow custom error callback
==============================================================================*/
ShopifyAPI.addItemFromForm = function (form, callback, errorCallback) {
  var $body = $(document.body),
    params = {
      type: 'POST',
      url: '/cart/add.js',
      data: jQuery(form).serialize(),
      dataType: 'json',
      beforeSend: function (jqxhr, settings) {
        $body.trigger('beforeAddItem.ajaxCart', form)
      },
      success: function (line_item) {
        if (typeof callback === 'function') {
          callback(line_item, form)
        } else {
          ShopifyAPI.onItemAdded(line_item, form)
        }
        $body.trigger('afterAddItem.ajaxCart', [line_item, form])
        if (window._learnq && window.item) {
          window._learnq.push(['track', 'Added to Cart', item])
        }
      },
      error: function (XMLHttpRequest, textStatus) {
        if (typeof errorCallback === 'function') {
          errorCallback(XMLHttpRequest, textStatus)
        } else {
          ShopifyAPI.onError(XMLHttpRequest, textStatus)
        }
        $body.trigger('errorAddItem.ajaxCart', [XMLHttpRequest, textStatus])
      },
      complete: function (jqxhr, text) {
        $body.trigger('completeAddItem.ajaxCart', [this, jqxhr, text])
      }
    }
  jQuery.ajax(params)
}

// Get from cart.js returns the cart in JSON
ShopifyAPI.getCart = function (callback) {
  $(document.body).trigger('beforeGetCart.ajaxCart')
  jQuery.getJSON('/cart.js', function (cart, textStatus) {
    if (typeof callback === 'function') {
      callback(cart)
    } else {
      ShopifyAPI.onCartUpdate(cart)
    }
    $(document.body).trigger('afterGetCart.ajaxCart', cart)
  })
}

// POST to cart/change.js returns the cart in JSON
ShopifyAPI.changeItem = function (line, quantity, callback) {
  var $body = $(document.body),
    params = {
      type: 'POST',
      url: '/cart/change.js',
      data: 'quantity=' + quantity + '&line=' + line,
      dataType: 'json',
      beforeSend: function () {
        $body.trigger('beforeChangeItem.ajaxCart', [line, quantity])
      },
      success: function (cart) {
        if (typeof callback === 'function') {
          callback(cart)
        } else {
          ShopifyAPI.onCartUpdate(cart)
        }
        $body.trigger('afterChangeItem.ajaxCart', [line, quantity, cart])
      },
      error: function (XMLHttpRequest, textStatus) {
        $body.trigger('errorChangeItem.ajaxCart', [XMLHttpRequest, textStatus])
        ShopifyAPI.onError(XMLHttpRequest, textStatus)
      },
      complete: function (jqxhr, text) {
        $body.trigger('completeChangeItem.ajaxCart', [this, jqxhr, text])
      }
    }
  jQuery.ajax(params)
}

// POST to cart/change.js returns the cart in JSON
ShopifyAPI.changeProperties = function (line, quantity, properties, callback) {
  var $body = $(document.body),
    params = {
      type: 'POST',
      url: '/cart/change.js',
      data: JSON.stringify({
        line: line,
        quantity: quantity,
        properties: properties
      }),
      contentType: 'application/json',
      dataType: 'json',
      success: function (cart) {
        if (typeof callback === 'function') {
          callback(cart)
        }
      },
      error: function (XMLHttpRequest, textStatus) {
        ShopifyAPI.onError(XMLHttpRequest, textStatus)
      }
    }
  jQuery.ajax(params)
}

/*============================================================================
	Ajax Shopify Add To Cart
==============================================================================*/
var ajaxCart = (function (module, $) {
  'use strict'

  // Public functions
  var init, loadCart, loadSidebar, loadMiniCart, getStatus, setStatus

  // Private general variables
  var settings,
    themeSettings,
    isUpdating,
    userData,
    line1Qty,
    moochiMoneyProperties,
    giftCardProperties,
    newGiftCardRegistered,
    moochiMoneyOpen,
    giftCardsOpen,
    shippingReturnsOpen,
    $html,
    $body

  // Private plugin variables
  var $formContainer,
    $addToCart,
    $cartCountSelector,
    $cartCostSelector,
    $cartContainer,
    $cartSidebarContainer,
    $miniCartContainer,
    $cartForm,
    $allPopups,
    $popupProduct,
    $overlay

  // Private functions
  var updateCountPrice,
    formOverride,
    itemAddedCallback,
    itemErrorCallback,
    productCartUpdateCallback,
    cartUpdateCallback,
    sidebarUpdateCallback,
    miniCartUpdateCallback,
    buildCart,
    buildCartSidebar,
    buildMiniCart,
    buildMiniCartMoochiMoney,
    buildMiniCartGiftCards,
    buildPopup,
    cartCallback,
    adjustCart,
    adjustSidebar,
    adjustCartCallback,
    adjustSidebarCallback,
    adjustMiniCartCallback,
    qtySelectors,
    validateQty,
    getUserData

  /*============================================================================
		Initialise the plugin and define global options
	==============================================================================*/
  init = function (options) {
    // Default settings
    settings = {
      showPopup: true,
      miniCart: false,
      formSelector: 'form[action^="/cart/add"]',
      cartContainer: '#cart-container',
      cartSidebarContainer: '#cart-sidebar-container',
      miniCartContainer: '#mini-cart-container',
      minicartMoochiMoneyContainer: '#minicart-moochi-money-container',
      minicartGiftCardsContainer: '#minicart-gift-cards-container',
      popupContainer: '.popup-product',
      addToCartSelector: 'input[type="submit"]',
      cartCountSelector: null,
      cartCostSelector: null,
      disableAjaxCart: false,
      enableQtySelectors: true,
      cartImgSize: '200x', // Shopify size: e.g. '300x200_crop_center'
      cartImgSrcset: ['200x', '400x'], // Array of Shopify sizes (width required for srcset)
      miniCartImgSize: '200x', // Shopify size: e.g. '300x200_crop_center'
      miniCartImgSrcset: ['200x', '400x'], // Array of Shopify sizes (width required for srcset)
      popupImgSize: '200x', // Product popup - Shopify size: e.g. '300x200_crop_center'
      popupImgSrcset: ['200x', '400x'] // Product popup - array of Shopify sizes (width required for srcset)
    }

    // Init theme settings
    themeSettings = (window.PSTheme && window.PSTheme.Settings) || {}

    // Override defaults with arguments
    $.extend(settings, options)

    // Select DOM elements
    $formContainer = $(settings.formSelector)
    $cartContainer = $(settings.cartContainer)
    $cartSidebarContainer = $(settings.cartSidebarContainer)
    $miniCartContainer = $(settings.miniCartContainer)
    $popupProduct = $(settings.popupContainer)
    $addToCart = $formContainer.find(settings.addToCartSelector)
    $cartCountSelector = $(settings.cartCountSelector)
    $cartCostSelector = $(settings.cartCostSelector)
    $cartForm = $('form.ajaxcart')
    $allPopups = $('.popup')
    $overlay = $('.overlay')

    // General Selectors
    $html = $('html')
    $body = $(document.body)

    // Track cart activity status
    isUpdating = false

    // Setup ajax quantity selectors on the any template if enableQtySelectors is true
    if (settings.enableQtySelectors) {
      qtySelectors()
    }

    // Take over the add to cart form submit action if ajax enabled
    if (!settings.disableAjaxCart && $addToCart.length) {
      formOverride()
    }

    if (settings.showPopup) {
      // Close product popup on continue click
      $popupProduct.on('click', '.continue-link a', function (e) {
        e.preventDefault()

        $html.removeClass('popup-shown')
        $allPopups.removeClass('shown')
        $overlay.removeClass('shown')
        slate.popUpShown = false
      })
    }

    // Run this function in case we're using the quantity selector outside of the cart
    adjustCart()

    // Defaults
    userData = null
    line1Qty = 1 // Will be overriden on cart load
    moochiMoneyProperties = null
    giftCardProperties = []
    newGiftCardRegistered = false
    moochiMoneyOpen = true
    giftCardsOpen = false
    shippingReturnsOpen = false

    // Run on cart page
    if ($cartContainer.length) {
      adjustSidebar()
      getUserData(loadSidebar)
    }

    // Run on minicart
    if ($miniCartContainer.length) {
      getUserData()
    }
  }

  loadCart = function () {
    ShopifyAPI.getCart(cartUpdateCallback)
  }

  loadSidebar = function () {
    ShopifyAPI.getCart(sidebarUpdateCallback)
  }

  loadMiniCart = function () {
    $html.addClass('mini-cart-shown')
    ShopifyAPI.getCart(miniCartUpdateCallback)
  }

  updateCountPrice = function (cart) {
    if ($cartCountSelector) {
      $cartCountSelector.html(cart.item_count).parent().removeClass('hidden-count')

      if (cart.item_count === 0) {
        $cartCountSelector.parent().addClass('hidden-count')
      }
    }
    if ($cartCostSelector) {
      $cartCostSelector.html(slate.Currency.formatMoney(cart.total_price, theme.moneyFormat))
    }
  }

  formOverride = function () {
    $formContainer.on('submit', function (evt) {
      evt.preventDefault()

      // Add class to be styled if desired
      $addToCart.removeClass('is-added').addClass('is-adding')

      // Remove any previous quantity errors
      $('.qty-error').remove()

      ShopifyAPI.addItemFromForm(evt.target, itemAddedCallback, itemErrorCallback)
    })
  }

  itemAddedCallback = function (product) {
    $addToCart.removeClass('is-adding').addClass('is-added')
    if (settings.showPopup) {
      buildPopup(product)
    }
    ShopifyAPI.getCart(productCartUpdateCallback)
  }

  itemErrorCallback = function (XMLHttpRequest, textStatus) {
    var data = eval('(' + XMLHttpRequest.responseText + ')')
    $addToCart.removeClass('is-adding is-added')

    if (!!data.message) {
      if (data.status == 422) {
        $formContainer.after('<div class="errors qty-error">' + data.description + '</div>')
      }
    }
  }

  productCartUpdateCallback = function (cart) {
    // Update quantity and price
    updateCountPrice(cart)

    // Show mini cart (only if the popup isn't shown)
    if (!settings.showPopup && settings.miniCart) {
      $html.addClass('mini-cart-shown')
      buildMiniCart(cart)
    }
  }

  cartUpdateCallback = function (cart) {
    // Update quantity and price
    updateCountPrice(cart)
    buildCart(cart)
    buildCartSidebar(cart)
  }

  sidebarUpdateCallback = function (cart) {
    buildCartSidebar(cart)
  }

  miniCartUpdateCallback = function (cart) {
    // Update quantity and price
    updateCountPrice(cart)
    buildMiniCart(cart)
  }

  buildCart = function (cart) {
    // Start with a fresh cart div
    $cartContainer.empty()
    $cartForm.removeClass('empty-cart')

    // Show empty cart
    if (cart.item_count === 0) {
      var data = {},
        source = $('#CartEmptyTemplate').html(),
        template = Handlebars.compile(source)

      $cartForm.addClass('empty-cart')

      $cartContainer.append(template(data))

      cartCallback(cart)
      return
    }

    // Handlebars.js cart layout
    var items = [],
      item = {},
      data = {},
      source = $('#CartTemplate').html(),
      template = Handlebars.compile(source)

    // Add each item to our handlebars.js data
    $.each(cart.items, function (index, cartItem) {
      var prodTitleArray = cartItem.product_title.split(' / '),
        prodTitle = cartItem.product_title

      if (index == 0) {
        line1Qty = cartItem.quantity
      }

      if (Array.isArray(prodTitleArray) && prodTitleArray.length > 1) {
        prodTitle = prodTitleArray[0].trim()
      }

      if (cartItem.variant_title) {
        var prodVariation = cartItem.options_with_values
      } else {
        var prodVariation = ''
      }

      var prodSize = ''
      if (cartItem.options_with_values !== null) {
        $.each(cartItem.options_with_values, function (key, value) {
          if (value.name.toLowerCase() === 'size') {
            prodSize = value.value
            delete prodVariation[key]

            // Clear if size was the only variant
            if (cartItem.options_with_values.length == 1) {
              prodVariation = ''
            }
          }
        })
      }

      if (cartItem.image !== null) {
        var prodImage = cartItem.image
      } else {
        var prodImage = theme.defaultImage
      }

      var imgOutput = slate.Image.getSizedImageUrl(prodImage, settings.cartImgSize)

      var imgSrcsetOutput = ''

      for (var i = 0; i < settings.cartImgSrcset.length; i++) {
        if (i !== 0) {
          imgSrcsetOutput += ', '
        }
        // Get first number from Shopify image size (split at x)
        var srcsetWidth = settings.cartImgSrcset[i].split('x', 1)[0]
        imgSrcsetOutput += slate.Image.getSizedImageUrl(prodImage, settings.cartImgSrcset[i]) + ' ' + srcsetWidth + 'w'
      }

      if (cartItem.properties !== null) {
        $.each(cartItem.properties, function (key, value) {
          if (key.charAt(0) === '_' || !value) {
            delete cartItem.properties[key]
          }
        })
      }

      // Create item's data object and add to 'items' array
      item = {
        key: cartItem.key,
        line: index + 1, // Shopify uses a 1+ index in the API
        url: cartItem.url,
        img: imgOutput,
        imgSrcset: imgSrcsetOutput,
        imgAlt: cartItem.title,
        name: prodTitle,
        vendor: cartItem.vendor,
        variation: prodVariation,
        size: prodSize,
        properties: cartItem.properties,
        itemQty: cartItem.quantity,
        price: slate.Currency.formatMoney(cartItem.discounted_price, theme.moneyFormat),
        originalPrice: slate.Currency.formatMoney(cartItem.original_price, theme.moneyFormat),
        linePrice: slate.Currency.formatMoney(cartItem.line_price, theme.moneyFormat),
        originalLinePrice: slate.Currency.formatMoney(cartItem.original_line_price, theme.moneyFormat),
        discounts: cartItem.discounts,
        discountsApplied: cartItem.line_price === cartItem.original_line_price ? false : true
      }

      items.push(item)
    })

    // Gather all cart data and add to DOM
    data = {
      items: items,
      note: cart.note
    }

    $cartContainer.append(template(data))

    cartCallback(cart)
  }

  buildCartSidebar = function (cart) {
    // Start with a fresh cart div
    $cartSidebarContainer.empty()

    // Show empty cart
    if (cart.item_count === 0) {
      return
    }

    // Handlebars.js cart layout
    var data = {},
      source = $('#CartSidebarTemplate').html()
    if (!source) {
      return
    }

    var template = Handlebars.compile(source),
      moochiMoneyPerItem = 50,
      moochiMoneyBalance = '...',
      moochiMoneyAvailable = false,
      moochiMoneyAvailableAmount = 0,
      moochiMoneyText = false,
      moochiMoneyDropdown = false,
      moochiMoneyOptions = [],
      moochiMoneyApplied = false,
      moochiMoneyAmount = 0,
      moochiMoneyError = false,
      hasQualifyingItems = false,
      hasGiftCardsAvailable = false,
      giftCardsText = false,
      giftCardsDropdown = false,
      giftCardsAvailable = [],
      giftCardsApplied = false,
      giftCardsAmount = 0,
      giftCards = [],
      giftCardInCart = false,
      giftCardRegisteredMessage = false

    // Reset old saved properties
    moochiMoneyProperties = null
    giftCardProperties = []

    if (newGiftCardRegistered) {
      giftCardRegisteredMessage = true
      newGiftCardRegistered = false
    }

    $.each(cart.items, function (index, cartItem) {
      if (index == 0) {
        line1Qty = cartItem.quantity
      }

      // Don't show moochi money or gift cards if there's a gift card product in the cart
      if (cartItem.product_id == theme.giftCardProduct) {
        giftCardInCart = true
        moochiMoneyError = true
      }

      // Must have at least one $50+ item to use moochi money
      if (cartItem.price >= moochiMoneyPerItem * 100) {
        hasQualifyingItems = true
      }

      if (cartItem.properties !== null) {
        $.each(cartItem.properties, function (key, value) {
          if (key == '_deferred_payments') {
            for (var i = 0; i < value.length; i++) {
              if (value[i].type == 'GiftCard') {
                giftCardProperties.push(value[i])

                giftCardsApplied = true
                giftCardsAmount = giftCardsAmount + value[i].value / 100

                var giftCardInfo = {
                  id: value[i].card_number,
                  value: value[i].value / 100
                }
                giftCards.push(giftCardInfo)
              }

              if (value[i].type == 'Loyalty') {
                moochiMoneyProperties = value[i]

                moochiMoneyApplied = true
                moochiMoneyAmount = value[i].value / 100
              }
            }
          } else if (key == '_sale') {
            if (value == 'true') {
              moochiMoneyError = true
            }
          }
        })
      }
    })

    // Check cart attributes for deferred payments
    if (cart.attributes && cart.attributes._deferred_payments) {
      const deferredPayments = cart.attributes._deferred_payments
      if (Array.isArray(deferredPayments)) {
        for (let i = 0; i < deferredPayments.length; i++) {
          if (deferredPayments[i].type == 'Loyalty') {
            moochiMoneyProperties = deferredPayments[i]

            moochiMoneyApplied = true
            moochiMoneyAmount = deferredPayments[i].value / 100
          }
        }
      }
    }

    if (userData !== null) {
      // Get moochi money
      if (typeof userData.loyalty[0] !== 'undefined') {
        moochiMoneyBalance = userData.loyalty[0].available_points
      } else {
        moochiMoneyBalance = 0
      }

      moochiMoneyAvailableAmount = cart.item_count * moochiMoneyPerItem

      if (moochiMoneyAvailableAmount > moochiMoneyBalance) {
        moochiMoneyAvailableAmount = moochiMoneyBalance
      }

      // Only redeem if balance is above 50
      if (moochiMoneyBalance >= moochiMoneyPerItem && hasQualifyingItems) {
        moochiMoneyAvailable = true
      }

      // Show dropdown if 100 or more moochi money available
      if (moochiMoneyAvailableAmount >= moochiMoneyPerItem * 2) {
        moochiMoneyDropdown = true

        // Populate dropdown in multiples of 50
        var totalOptions = Math.floor(moochiMoneyAvailableAmount / moochiMoneyPerItem)

        for (var i = 0; i < totalOptions; i++) {
          var option = {
            option: (i + 1) * moochiMoneyPerItem
          }
          moochiMoneyOptions.push(option)
        }
      } else if (moochiMoneyAvailable) {
        moochiMoneyAvailableAmount = moochiMoneyPerItem
        moochiMoneyText = true
      }

      // Get gift cards
      if (userData.giftcard.length > 0) {
        for (var i = 0; i < userData.giftcard.length; i++) {
          if (userData.giftcard[i].available_balance > 0) {
            var alreadyApplied = false

            var giftCardInfo = {
              id: userData.giftcard[i].gift_card_number,
              value: userData.giftcard[i].available_balance
            }

            for (var j = 0; j < giftCards.length; j++) {
              if (giftCards[j].id == giftCardInfo.id) {
                alreadyApplied = true
                break
              }
            }

            if (!alreadyApplied) {
              hasGiftCardsAvailable = true
              giftCardsAvailable.push(giftCardInfo)
            }
          }
        }

        // Show dropdown if multiple gift cards
        if (giftCardsAvailable.length > 1) {
          giftCardsDropdown = true
        } else {
          giftCardsText = true
        }
      }
      $('.cart-sidebar-loading').addClass('hidden')
    }

    // Gather all cart data and add to DOM
    data = {
      moochiMoneyOpen: moochiMoneyOpen,
      giftCardsOpen: giftCardsOpen,
      shippingReturnsOpen: shippingReturnsOpen,
      totalPrice: slate.Currency.formatMoney(cart.original_total_price, theme.moneyFormat),
      moochiMoneyBalance: moochiMoneyBalance,
      moochiMoneyAvailable: moochiMoneyAvailable,
      moochiMoneyAvailableAmount: moochiMoneyAvailableAmount,
      moochiMoneyText: moochiMoneyText,
      moochiMoneyDropdown: moochiMoneyDropdown,
      moochiMoneyOptions: moochiMoneyOptions,
      moochiMoneyApplied: moochiMoneyApplied,
      moochiMoneyAmount: moochiMoneyAmount,
      moochiMoneyAmountCurrency: slate.Currency.formatMoney(moochiMoneyAmount * 100, theme.moneyFormat),
      moochiMoneyError: moochiMoneyError,
      hasGiftCardsAvailable: hasGiftCardsAvailable,
      giftCardsText: giftCardsText,
      giftCardsDropdown: giftCardsDropdown,
      giftCardsAvailable: giftCardsAvailable,
      giftCardsApplied: giftCardsApplied,
      giftCardsAmount: giftCardsAmount,
      giftCardsAmountCurrency: slate.Currency.formatMoney(giftCardsAmount * 100, theme.moneyFormat),
      giftCards: giftCards,
      giftCardInCart: giftCardInCart,
      giftCardRegisteredMessage: giftCardRegisteredMessage,
      totalCartDiscount:
        cart.total_discount === 0 ? 0 : slate.Currency.formatMoney(cart.total_discount, theme.moneyFormat),
      totalCartDiscountApplied: cart.total_discount === 0 ? false : true,
      totalPriceAfterDiscounts: slate.Currency.formatMoney(cart.total_price, theme.moneyFormat)
    }

    $cartSidebarContainer.append(template(data))

    cartCallback(cart)
  }

  buildMiniCart = function (cart) {
    // Start with a fresh cart div
    $miniCartContainer.empty()

    // Show empty cart
    if (cart.item_count === 0) {
      var data = {},
        source = $('#MiniCartEmptyTemplate').html(),
        template = Handlebars.compile(source)

      $miniCartContainer.append(template(data))

      cartCallback(cart)
      return
    }

    // Handlebars.js cart layout
    var items = [],
      item = {},
      data = {},
      source = $('#MiniCartTemplate').html(),
      template = Handlebars.compile(source),
      giftCardsApplied = false,
      giftCardsAmount = 0

    // Add each item to our handlebars.js data
    $.each(cart.items, function (index, cartItem) {
      var prodTitleArray = cartItem.product_title.split(' / '),
        prodTitle = cartItem.product_title

      if (Array.isArray(prodTitleArray) && prodTitleArray.length > 1) {
        prodTitle = prodTitleArray[0].trim()
      }

      if (cartItem.variant_title) {
        var prodVariation = cartItem.options_with_values
      } else {
        var prodVariation = ''
      }

      var prodSize = ''
      if (cartItem.options_with_values !== null) {
        $.each(cartItem.options_with_values, function (key, value) {
          if (value.name.toLowerCase() === 'size') {
            prodSize = value.value
            delete prodVariation[key]

            // Clear if size was the only variant
            if (cartItem.options_with_values.length == 1) {
              prodVariation = ''
            }
          }
        })
      }

      if (cartItem.image !== null) {
        var prodImage = cartItem.image
      } else {
        var prodImage = theme.defaultImage
      }

      var imgOutput = slate.Image.getSizedImageUrl(prodImage, settings.miniCartImgSize)

      var imgSrcsetOutput = ''

      for (var i = 0; i < settings.miniCartImgSrcset.length; i++) {
        if (i !== 0) {
          imgSrcsetOutput += ', '
        }
        // Get first number from Shopify image size (split at x)
        var srcsetWidth = settings.miniCartImgSrcset[i].split('x', 1)[0]
        imgSrcsetOutput +=
          slate.Image.getSizedImageUrl(prodImage, settings.miniCartImgSrcset[i]) + ' ' + srcsetWidth + 'w'
      }

      if (cartItem.properties !== null) {
        var deferredPayments = cartItem.properties._deferred_payments
        if (Array.isArray(deferredPayments)) {
          for (var i = 0; i < deferredPayments.length; i++) {
            if (deferredPayments[i].type == 'GiftCard') {
              giftCardsApplied = true
              giftCardsAmount += deferredPayments[i].value / 100
            }
          }
        }

        $.each(cartItem.properties, function (key, value) {
          if (key.charAt(0) === '_' || !value) {
            delete cartItem.properties[key]
          }
        })
      }

      // Create item's data object and add to 'items' array
      item = {
        key: cartItem.key,
        line: index + 1, // Shopify uses a 1+ index in the API
        url: cartItem.url,
        img: imgOutput,
        imgSrcset: imgSrcsetOutput,
        imgAlt: cartItem.title,
        name: prodTitle,
        vendor: cartItem.vendor,
        variation: prodVariation,
        size: prodSize,
        properties: cartItem.properties,
        itemQty: cartItem.quantity,
        price: slate.Currency.formatMoney(cartItem.discounted_price, theme.moneyFormat),
        originalPrice: slate.Currency.formatMoney(cartItem.original_price, theme.moneyFormat),
        linePrice: slate.Currency.formatMoney(cartItem.line_price, theme.moneyFormat),
        originalLinePrice: slate.Currency.formatMoney(cartItem.original_line_price, theme.moneyFormat),
        discounts: cartItem.discounts,
        discountsApplied: cartItem.line_price === cartItem.original_line_price ? false : true
      }

      items.push(item)
    })

    // Free shipping calculation
    var enableShippingProgress = themeSettings.enableMinicartShippingProgress
    var freeShippingThreshold = parseInt(themeSettings.minicartShippingThreshold, 10) || 29900
    var cartTotal = cart.total_price
    var freeShippingQualified = cartTotal >= freeShippingThreshold
    var amountToFreeShipping = freeShippingQualified ? 0 : freeShippingThreshold - cartTotal
    var shippingProgressPercent = Math.min((cartTotal / freeShippingThreshold) * 100, 100)
    var inProgressMessage = themeSettings.minicartShippingInProgressMessage || "you're $X away from free shipping!"
    var qualifiedMessage = themeSettings.minicartShippingQualifiedMessage || "you've qualified for free shipping!"
    var shippingMessage = freeShippingQualified
      ? qualifiedMessage
      : inProgressMessage.replace('$X', '$' + slate.Currency.formatMoney(amountToFreeShipping, '{{amount}}'))

    // Check cart attributes for applied moochi money for subtotal data
    var moochiMoneyApplied = false
    var moochiMoneyAmount = 0
    if (cart.attributes && cart.attributes._deferred_payments) {
      var deferredPayments = cart.attributes._deferred_payments
      if (Array.isArray(deferredPayments)) {
        for (var i = 0; i < deferredPayments.length; i++) {
          if (deferredPayments[i].type == 'Loyalty') {
            moochiMoneyApplied = true
            moochiMoneyAmount = deferredPayments[i].value / 100
          }
        }
      }
    }

    // Gather all cart data and add to DOM
    data = {
      items: items,
      totalPrice: slate.Currency.formatMoney(cart.original_total_price, theme.moneyFormat),
      totalCartDiscount:
        cart.total_discount === 0 ? 0 : slate.Currency.formatMoney(cart.total_discount, theme.moneyFormat),
      totalCartDiscountApplied: cart.total_discount === 0 ? false : true,
      enableShippingProgress: enableShippingProgress,
      freeShippingQualified: freeShippingQualified,
      shippingMessage: shippingMessage,
      shippingProgressPercent: shippingProgressPercent,
      moochiMoneyApplied: moochiMoneyApplied,
      moochiMoneyAmount: moochiMoneyAmount,
      moochiMoneyAmountCurrency: slate.Currency.formatMoney(moochiMoneyAmount * 100, theme.moneyFormat),
      giftCardsApplied: giftCardsApplied,
      giftCardsAmountCurrency: slate.Currency.formatMoney(giftCardsAmount * 100, theme.moneyFormat),
      hasDiscounts: moochiMoneyApplied || giftCardsApplied,
      totalPriceAfterDiscounts: slate.Currency.formatMoney(
        cart.original_total_price - moochiMoneyAmount * 100 - giftCardsAmount * 100,
        theme.moneyFormat
      )
    }

    $miniCartContainer.append(template(data))

    cartCallback(cart)

    // Set checkout button popup
    function setCheckoutButton() {
      const $signInPopup = $('.popup-sign-in')
      const $checkoutBtn = $('#mini-cart-checkout-btn')
      const $popupCheckoutBtn = $('.btn-popup-checkout')
      const $actionsWrapper = $('.mini-cart-actions')

      if ($signInPopup.length && $actionsWrapper.data('guest') === true) {
        $checkoutBtn.on('click', function (e) {
          e.preventDefault()

          globalThis.sessionStorage.setItem('cartRedirectAfterLogin', 'true')

          $html.addClass('popup-shown')
          $allPopups.removeClass('shown')
          $signInPopup.addClass('shown')
          $overlay.addClass('shown')

          setTimeout(function () {
            slate.popUpShown = true
          }, 300)
        })

        $popupCheckoutBtn.on('click', function () {
          window.location.href = '/checkout'
        })
      }
    }

    setCheckoutButton()

    // Re-init minicart upsells vue component after cart re-render
    if (typeof window.initMinicartUpsells === 'function') {
      window.initMinicartUpsells()
    }

    // Build moochi money and gift cards in minicart, load user data if not already loaded
    function buildMiniCartFeatures(cart) {
      buildMiniCartMoochiMoney(cart)
      buildMiniCartGiftCards(cart)
    }
    userData !== null
      ? ShopifyAPI.getCart(buildMiniCartFeatures)
      : getUserData(function () {
          ShopifyAPI.getCart(buildMiniCartFeatures)
        })
  }

  buildMiniCartMoochiMoney = function (cart) {
    // Select container
    var $container = $(settings.minicartMoochiMoneyContainer)
    if (!$container.length) {
      return
    }

    // Start with a fresh container
    $container.empty()

    // Don't show if cart is empty
    if (cart.item_count === 0) {
      return
    }

    // Handlebars.js template
    var data = {},
      source = $('#MinicartMoochiMoneyTemplate').html()
    if (!source) {
      return
    }

    var template = Handlebars.compile(source),
      moochiMoneyPerItem = 50,
      moochiMoneyBalance = 0,
      moochiMoneyAvailable = false,
      moochiMoneyAvailableAmount = 0,
      moochiMoneyText = false,
      moochiMoneyApplied = false,
      moochiMoneyAmount = 0,
      moochiMoneyError = false,
      hasQualifyingItems = false,
      spendForNextReward = 600,
      moochiMoneyProgressPercent = 0

    // Check cart items for qualifying items and sale items
    $.each(cart.items, function (index, cartItem) {
      if (cartItem.price >= moochiMoneyPerItem * 100) {
        hasQualifyingItems = true
      }

      // Check for gift card in cart or sale items
      if (cartItem.product_id == theme.giftCardProduct) {
        moochiMoneyError = true
      }

      if (cartItem.properties !== null) {
        $.each(cartItem.properties, function (key, value) {
          if (key == '_sale' && value == 'true') {
            moochiMoneyError = true
          }
        })
      }
    })

    // Check cart attributes for applied moochi money
    if (cart.attributes && cart.attributes._deferred_payments) {
      const deferredPayments = cart.attributes._deferred_payments
      if (Array.isArray(deferredPayments)) {
        for (let i = 0; i < deferredPayments.length; i++) {
          if (deferredPayments[i].type == 'Loyalty') {
            moochiMoneyApplied = true
            moochiMoneyAmount = deferredPayments[i].value / 100
          }
        }
      }
    }

    // Get moochi money balance from user data
    if (userData !== null) {
      if (typeof userData.loyalty[0] !== 'undefined') {
        moochiMoneyBalance = userData.loyalty[0].available_points
        spendForNextReward = Math.ceil(userData.loyalty[0].spend_for_next_reward) || 600
      }

      moochiMoneyAvailableAmount = cart.item_count * moochiMoneyPerItem
      if (moochiMoneyAvailableAmount > moochiMoneyBalance) {
        moochiMoneyAvailableAmount = moochiMoneyBalance
      }

      // Only redeem if balance is above 50 and has qualifying items
      if (moochiMoneyBalance >= moochiMoneyPerItem && hasQualifyingItems) {
        moochiMoneyAvailable = true
      }

      if (moochiMoneyAvailable) {
        moochiMoneyAvailableAmount = moochiMoneyPerItem
        moochiMoneyText = true
      }

      // Calculate progress to next voucher (vouchers are at $50 increments)
      var voucherThreshold = 50
      var currentProgress = voucherThreshold - (spendForNextReward % voucherThreshold || voucherThreshold)
      moochiMoneyProgressPercent = Math.min((currentProgress / voucherThreshold) * 100, 100)
    }

    // All moochi money data
    data = {
      moochiMoneyBalance: moochiMoneyBalance,
      moochiMoneyAvailable: moochiMoneyAvailable,
      moochiMoneyAvailableAmount: moochiMoneyAvailableAmount,
      moochiMoneyText: moochiMoneyText,
      moochiMoneyApplied: moochiMoneyApplied,
      moochiMoneyAmount: moochiMoneyAmount,
      moochiMoneyAmountCurrency: slate.Currency.formatMoney(moochiMoneyAmount * 100, theme.moneyFormat),
      moochiMoneyError: moochiMoneyError,
      spendForNextReward: spendForNextReward,
      moochiMoneyProgressPercent: moochiMoneyProgressPercent
    }

    $container.append(template(data))
  }

  buildMiniCartGiftCards = function (cart) {
    var $container = $(settings.minicartGiftCardsContainer)
    if (!$container.length) return

    $container.empty()

    if (cart.item_count === 0) return

    var source = $('#MinicartGiftCardsTemplate').html()
    if (!source) return

    var template = Handlebars.compile(source),
      giftCardInCart = false,
      giftCardRegisteredMessage = false,
      hasGiftCardsAvailable = false,
      giftCardsText = false,
      giftCardsDropdown = false,
      giftCardsAvailable = [],
      giftCardsApplied = false,
      giftCardsAmount = 0,
      giftCards = []

    if (newGiftCardRegistered) {
      giftCardRegisteredMessage = true
      newGiftCardRegistered = false
    }

    $.each(cart.items, function (index, cartItem) {
      if (cartItem.product_id == theme.giftCardProduct) {
        giftCardInCart = true
      }

      if (cartItem.properties !== null) {
        $.each(cartItem.properties, function (key, value) {
          if (key == '_deferred_payments' && Array.isArray(value)) {
            for (var i = 0; i < value.length; i++) {
              if (value[i].type == 'GiftCard') {
                giftCardsApplied = true
                giftCardsAmount += value[i].value / 100
                giftCards.push({ id: value[i].card_number, value: value[i].value / 100 })
              }
            }
          }
        })
      }
    })

    if (userData !== null && userData.giftcard && userData.giftcard.length > 0) {
      for (var i = 0; i < userData.giftcard.length; i++) {
        if (userData.giftcard[i].available_balance > 0) {
          var alreadyApplied = false
          var giftCardInfo = {
            id: userData.giftcard[i].gift_card_number,
            value: userData.giftcard[i].available_balance
          }
          for (var j = 0; j < giftCards.length; j++) {
            if (giftCards[j].id == giftCardInfo.id) {
              alreadyApplied = true
              break
            }
          }
          if (!alreadyApplied) {
            hasGiftCardsAvailable = true
            giftCardsAvailable.push(giftCardInfo)
          }
        }
      }

      if (giftCardsAvailable.length > 1) {
        giftCardsDropdown = true
      } else if (giftCardsAvailable.length === 1) {
        giftCardsText = true
      }
    }

    var data = {
      giftCardInCart: giftCardInCart,
      giftCardRegisteredMessage: giftCardRegisteredMessage,
      hasGiftCardsAvailable: hasGiftCardsAvailable,
      giftCardsText: giftCardsText,
      giftCardsDropdown: giftCardsDropdown,
      giftCardsAvailable: giftCardsAvailable,
      giftCardsApplied: giftCardsApplied,
      giftCardsAmountCurrency: slate.Currency.formatMoney(giftCardsAmount * 100, theme.moneyFormat),
      giftCards: giftCards
    }

    $container.append(template(data))
  }

  buildPopup = function (product) {
    // Start with a fresh cart div
    $popupProduct.empty()

    var data = {},
      source = $('#ProductPopupTemplate').html(),
      template = Handlebars.compile(source)

    if (product.image !== null) {
      var prodImage = product.image
    } else {
      var prodImage = theme.defaultImage
    }

    if (product.variant_options.length > 0) {
      var option_1 = product.variant_options[0]

      if (option_1.indexOf('Default') !== -1) {
        option_1 = ''
      }
    } else {
      var option_1 = ''
    }

    if (product.variant_options.length > 1) {
      var option_2 = product.variant_options[1]
    } else {
      var option_2 = ''
    }

    if (product.variant_options.length > 2) {
      var option_3 = product.variant_options[2]
    } else {
      var option_3 = ''
    }

    var imgOutput = slate.Image.getSizedImageUrl(prodImage, settings.popupImgSize)
    var imgSrcsetOutput = ''

    for (var i = 0; i < settings.popupImgSrcset.length; i++) {
      if (i !== 0) {
        imgSrcsetOutput += ', '
      }
      // Get first number from Shopify image size (split at x)
      var srcsetWidth = settings.popupImgSrcset[i].split('x', 1)[0]
      imgSrcsetOutput += slate.Image.getSizedImageUrl(prodImage, settings.popupImgSrcset[i]) + ' ' + srcsetWidth + 'w'
    }

    // Gather all product data and add to DOM
    data = {
      name: product.product_title,
      img: imgOutput,
      imgSrcset: imgSrcsetOutput,
      imgAlt: product.title,
      option_1: option_1,
      option_2: option_2,
      option_3: option_3,
      properties: product.properties,
      price: slate.Currency.formatMoney(product.price, theme.moneyFormat),
      originalPrice: slate.Currency.formatMoney(product.original_price, theme.moneyFormat),
      discountsApplied: product.line_price === product.original_line_price ? false : true,
      quantity: product.quantity
    }

    $popupProduct.append(template(data))

    $html.addClass('popup-shown')
    $allPopups.removeClass('shown')
    $popupProduct.addClass('shown')
    $overlay.addClass('shown')

    setTimeout(function () {
      slate.popUpShown = true
    }, 300)
  }

  cartCallback = function (cart) {
    if (window.Shopify && Shopify.StorefrontExpressButtons) {
      Shopify.StorefrontExpressButtons.initialize()
    }
  }

  adjustCart = function () {
    // Delegate all events because elements reload with the cart

    // Add or remove from the quantity
    $body.on('click', '.ajaxcart__qty-adjust', function () {
      if (isUpdating) {
        return
      }

      var $el = $(this),
        line = $el.data('line'),
        $qtySelector = $el.siblings('.ajaxcart__qty-num'),
        qty = parseInt($qtySelector.val().replace(/\D/g, '')),
        isMiniCart = false

      if ($el.hasClass('is-mini-cart')) {
        isMiniCart = true
      }

      var qty = validateQty(qty)

      // Add or subtract from the current quantity
      if ($el.hasClass('ajaxcart__qty--plus')) {
        qty += 1
      } else {
        qty -= 1
        if (qty <= 0) qty = 0
      }

      // If it has a data-line, update the cart.
      // Otherwise, just update the input's number
      if (line) {
        updateQuantity(line, qty, isMiniCart)
      } else {
        $qtySelector.val(qty)
      }
    })

    // Update quantity based on input on change
    $body.on('change', '.ajaxcart__qty-num', function () {
      if (isUpdating) {
        return
      }

      var $el = $(this),
        line = $el.data('line'),
        qty = parseInt($el.val().replace(/\D/g, '')),
        isMiniCart = false

      if ($el.hasClass('is-mini-cart')) {
        isMiniCart = true
      }

      var qty = validateQty(qty)

      // If it has a data-line, update the cart
      if (line) {
        updateQuantity(line, qty, isMiniCart)
      }
    })

    // Completely remove product
    $body.on('click', '.ajaxcart__remove', function (e) {
      if (isUpdating) {
        return
      }

      var $el = $(this),
        line = $el.data('line'),
        qty = 0,
        isMiniCart = false

      if ($el.hasClass('is-mini-cart')) {
        isMiniCart = true
      }

      // If it has a data-line, update the cart
      if (line) {
        e.preventDefault()
        updateQuantity(line, qty, isMiniCart)
      }
    })

    // Prevent cart from being submitted while quantities are changing
    $body.on('submit', 'form.ajaxcart', function (evt) {
      if (isUpdating) {
        evt.preventDefault()
      }
    })

    // Highlight the text when focused
    $body.on('focus', '.ajaxcart__qty-adjust', function () {
      var $el = $(this)
      setTimeout(function () {
        $el.select()
      }, 50)
    })

    function updateQuantity(line, qty, isMiniCart) {
      isUpdating = true

      // Add activity classes when changing cart quantities
      var $row = $('.ajaxcart__row[data-line="' + line + '"]').addClass('is-loading')

      if (qty === 0) {
        $row.addClass('is-removed')
      }

      // Slight delay to make sure removed animation is done
      setTimeout(function () {
        if (isMiniCart) {
          ShopifyAPI.changeItem(line, qty, adjustMiniCartCallback)
        } else {
          ShopifyAPI.changeItem(line, qty, adjustCartCallback)
        }
      }, 250)
    }

    // Save note anytime it's changed
    $body.on('change', 'textarea[name="note"]', function () {
      var newNote = $(this).val()

      // Update the cart note in case they don't click update/checkout
      ShopifyAPI.updateCartNote(newNote, function (cart) {})
    })

    // Add new gift card to account
    $body.on('click', '.ajaxcart__gc-apply-new', function (e) {
      e.preventDefault()

      if (isUpdating) {
        return
      }

      var $el = $(this),
        $input = $el.siblings('.ajaxcart__gc-new-id'),
        cardNumber = $input.val(),
        $error = $el.closest('.accordion').find('.form-error'),
        properties = {},
        allPayments = []

      $error.addClass('hide')

      if (!cardNumber) {
        $error.removeClass('hide').text('Please enter a gift card number')
        return
      }

      if (cardNumber && userInfo.id) {
        isUpdating = true
        $el.addClass('loading')

        var options = {
          type: 'POST',
          url: '/a/ps/' + userInfo.id + '/giftCard/register',
          timeout: 0,
          headers: {
            'custom-token': userInfo.token
          },
          data: JSON.stringify({
            card_number: cardNumber
          }),
          contentType: 'application/json',
          dataType: 'json'
        }

        $.ajax(options)
          .done(function (response) {
            isUpdating = false
            $el.removeClass('loading')
            if (response.message == 'success') {
              $input.val('')
              newGiftCardRegistered = true
              loadSidebar()
              userData = null
              getUserData(function () {
                ShopifyAPI.getCart(buildMiniCartGiftCards)
              })
            } else {
              $error.removeClass('hide').text(response.message)
            }
          })
          .fail(function () {
            isUpdating = false
            $el.removeClass('loading')
            $error.removeClass('hide').text('An error occurred. Please try again.')
          })
      }
    })
  }

  adjustSidebar = function () {
    // Keep accordions open at their current states when sidebar reloads
    $body.on('click', '.moochi-money-balance .accordion-toggle', function () {
      var $this = $(this)

      if ($this.hasClass('active')) {
        moochiMoneyOpen = true
        giftCardsOpen = false
        shippingReturnsOpen = false
      } else {
        moochiMoneyOpen = false
      }
    })

    $body.on('click', '.gift-cards .accordion-toggle', function () {
      var $this = $(this)

      if ($this.hasClass('active')) {
        moochiMoneyOpen = false
        giftCardsOpen = true
        shippingReturnsOpen = false
      } else {
        giftCardsOpen = false
      }
    })

    $body.on('click', '.accordion-cms .accordion-toggle', function () {
      var $this = $(this)

      if ($this.hasClass('active')) {
        moochiMoneyOpen = false
        giftCardsOpen = false
        shippingReturnsOpen = true
      } else {
        shippingReturnsOpen = false
      }
    })

    // Apply moochi money
    // $body.on('click', '.ajaxcart__mm-apply', function(e) {
    // 	e.preventDefault();

    // 	if (isUpdating) {
    // 		return;
    // 	}

    // 	var $el = $(this),
    // 		amount = $el.data('amount'),
    // 		$selector = $el.siblings('.ajaxcart__mm-amount'),
    // 		properties = {},
    // 		allPayments = [];

    // 	if(!amount) {
    // 		amount = $selector.val();
    // 	}

    // 	allPayments.push({
    // 		"type": "Loyalty",
    // 		"currency": theme.currency,
    // 		"loyalty_point": amount,
    // 		"loyalty_programme": "Moochi Loyalty",
    // 		"value": amount * 100
    // 	});

    // 	properties = {
    // 		"_deferred_payments": allPayments.concat(giftCardProperties)
    // 	};

    // 	isUpdating = true;
    // 	$el.addClass('loading');
    // 	ShopifyAPI.changeProperties(1, line1Qty, properties, adjustSidebarCallback);
    // });

    // Remove moochi money
    // $body.on('click', '.ajaxcart__mm-remove', function(e) {
    // 	e.preventDefault();

    // 	if (isUpdating) {
    // 		return;
    // 	}

    // 	var $el = $(this),
    // 		properties = {},
    // 		allPayments = [];

    // 	properties = {
    // 		"_deferred_payments": allPayments.concat(giftCardProperties)
    // 	};

    // 	isUpdating = true;
    // 	$el.addClass('loading');
    // 	ShopifyAPI.changeProperties(1, line1Qty, properties, adjustSidebarCallback);
    // });

    // Apply gift card
    // migrate to moochi_money

    // Remove gift card
    // migrate to moochi_money
  }

  adjustCartCallback = function (cart) {
    // Update quantity and price
    updateCountPrice(cart)

    // Update sidebar
    buildCartSidebar(cart)

    // Reprint cart on short timeout so you don't see the content being removed
    setTimeout(function () {
      isUpdating = false
      ShopifyAPI.getCart(buildCart)
    }, 150)
  }

  adjustSidebarCallback = function (cart) {
    isUpdating = false

    // Update sidebar
    buildCartSidebar(cart)
  }

  adjustMiniCartCallback = function (cart) {
    // Update quantity and price
    updateCountPrice(cart)

    // Reprint cart on short timeout so you don't see the content being removed
    setTimeout(function () {
      isUpdating = false
      ShopifyAPI.getCart(buildMiniCart)
    }, 150)
  }

  qtySelectors = function () {
    // Change number inputs to JS ones, similar to ajax cart but without API integration.
    // Make sure to add the existing name and id to the new input element
    var numInputs = $('.js-qty')

    if (numInputs.length) {
      // Setup listeners to add/subtract from the input
      $('.js-qty__adjust').on('click', function () {
        var el = $(this),
          qtySelector = el.siblings('.js-qty__num'),
          qty = parseInt(qtySelector.val().replace(/\D/g, ''), 10)

        var qty = validateQty(qty)

        // Add or subtract from the current quantity
        if (el.hasClass('js-qty__adjust--plus')) {
          qty = qty + 1
        } else {
          qty = qty - 1

          if (el.parent().hasClass('allow-0')) {
            if (qty <= 0) qty = 0
          } else {
            if (qty <= 1) qty = 1
          }
        }

        // Update the input's number
        qtySelector.val(qty)
      })
    }
  }

  validateQty = function (qty) {
    if (parseFloat(qty) == parseInt(qty) && !isNaN(qty)) {
      // We have a valid number!
    } else {
      // Not a number. Default to 1.
      qty = 1
    }
    return qty
  }

  getUserData = function (callback) {
    // If user logged in
    if (userInfo.id) {
      var options = {
        type: 'GET',
        url: '/a/ps/' + userInfo.id + '/status',
        timeout: 0,
        headers: {
          'custom-token': userInfo.token
        }
      }

      $.ajax(options).done(function (response) {
        if (response.message == 'success') {
          userData = response.data
          if (typeof callback === 'function') {
            callback()
          }
        }
      })
    } else {
      $('.cart-sidebar-loading').addClass('hidden')
    }
  }

  getStatus = function () {
    return isUpdating
  }

  setStatus = function (val) {
    isUpdating = val
  }

  module = {
    init: init,
    load: loadCart,
    loadSidebar: loadSidebar,
    loadMini: loadMiniCart,
    getStatus: getStatus,
    setStatus: setStatus,
    adjustSidebarCallback: adjustSidebarCallback,
    adjustMiniCartCallback: adjustMiniCartCallback
  }

  return module
})(ajaxCart || {}, jQuery)


/*!
 * slick-custom.min.js
 */
/*! Slick Version 1.8.0
 * Includes this custom fix to stop lazy load srcset images downloading twice: https://github.com/kenwheeler/slick/pull/2738 !*/
!(function (i) {
  'use strict'
  'function' == typeof define && define.amd
    ? define(['jquery'], i)
    : 'undefined' != typeof exports
    ? (module.exports = i(require('jquery')))
    : i(jQuery)
})(function (a) {
  'use strict'
  var s,
    r = window.Slick || {}
  ;(s = 0),
    ((r = function (i, e) {
      var t,
        o = this
      ;(o.defaults = {
        accessibility: !0,
        adaptiveHeight: !1,
        appendArrows: a(i),
        appendDots: a(i),
        arrows: !0,
        asNavFor: null,
        prevArrow: '<button class="slick-prev" aria-label="Previous" type="button">Previous</button>',
        nextArrow: '<button class="slick-next" aria-label="Next" type="button">Next</button>',
        autoplay: !1,
        autoplaySpeed: 3e3,
        centerMode: !1,
        centerPadding: '50px',
        cssEase: 'ease',
        customPaging: function (i, e) {
          return a('<button type="button" />').text(e + 1)
        },
        dots: !1,
        dotsClass: 'slick-dots',
        draggable: !0,
        easing: 'linear',
        edgeFriction: 0.35,
        fade: !1,
        focusOnSelect: !1,
        focusOnChange: !1,
        infinite: !0,
        initialSlide: 0,
        lazyLoad: 'ondemand',
        mobileFirst: !1,
        pauseOnHover: !0,
        pauseOnFocus: !0,
        pauseOnDotsHover: !1,
        respondTo: 'window',
        responsive: null,
        rows: 1,
        rtl: !1,
        slide: '',
        slidesPerRow: 1,
        slidesToShow: 1,
        slidesToScroll: 1,
        speed: 500,
        swipe: !0,
        swipeToSlide: !1,
        touchMove: !0,
        touchThreshold: 5,
        useCSS: !0,
        useTransform: !0,
        variableWidth: !1,
        vertical: !1,
        verticalSwiping: !1,
        waitForAnimate: !0,
        zIndex: 1e3
      }),
        (o.initials = {
          animating: !1,
          dragging: !1,
          autoPlayTimer: null,
          currentDirection: 0,
          currentLeft: null,
          currentSlide: 0,
          direction: 1,
          $dots: null,
          listWidth: null,
          listHeight: null,
          loadIndex: 0,
          $nextArrow: null,
          $prevArrow: null,
          scrolling: !1,
          slideCount: null,
          slideWidth: null,
          $slideTrack: null,
          $slides: null,
          sliding: !1,
          slideOffset: 0,
          swipeLeft: null,
          swiping: !1,
          $list: null,
          touchObject: {},
          transformsEnabled: !1,
          unslicked: !1
        }),
        a.extend(o, o.initials),
        (o.activeBreakpoint = null),
        (o.animType = null),
        (o.animProp = null),
        (o.breakpoints = []),
        (o.breakpointSettings = []),
        (o.cssTransitions = !1),
        (o.focussed = !1),
        (o.interrupted = !1),
        (o.hidden = 'hidden'),
        (o.paused = !0),
        (o.positionProp = null),
        (o.respondTo = null),
        (o.rowCount = 1),
        (o.shouldClick = !0),
        (o.$slider = a(i)),
        (o.$slidesCache = null),
        (o.transformType = null),
        (o.transitionType = null),
        (o.visibilityChange = 'visibilitychange'),
        (o.windowWidth = 0),
        (o.windowTimer = null),
        (t = a(i).data('slick') || {}),
        (o.options = a.extend({}, o.defaults, e, t)),
        (o.currentSlide = o.options.initialSlide),
        (o.originalSettings = o.options),
        void 0 !== document.mozHidden
          ? ((o.hidden = 'mozHidden'), (o.visibilityChange = 'mozvisibilitychange'))
          : void 0 !== document.webkitHidden &&
            ((o.hidden = 'webkitHidden'), (o.visibilityChange = 'webkitvisibilitychange')),
        (o.autoPlay = a.proxy(o.autoPlay, o)),
        (o.autoPlayClear = a.proxy(o.autoPlayClear, o)),
        (o.autoPlayIterator = a.proxy(o.autoPlayIterator, o)),
        (o.changeSlide = a.proxy(o.changeSlide, o)),
        (o.clickHandler = a.proxy(o.clickHandler, o)),
        (o.selectHandler = a.proxy(o.selectHandler, o)),
        (o.setPosition = a.proxy(o.setPosition, o)),
        (o.swipeHandler = a.proxy(o.swipeHandler, o)),
        (o.dragHandler = a.proxy(o.dragHandler, o)),
        (o.keyHandler = a.proxy(o.keyHandler, o)),
        (o.instanceUid = s++),
        (o.htmlExpr = /^(?:\s*(<[\w\W]+>)[^>]*)$/),
        o.registerBreakpoints(),
        o.init(!0)
    }).prototype.activateADA = function () {
      this.$slideTrack
        .find('.slick-active')
        .attr({ 'aria-hidden': 'false' })
        .find('a, input, button, select')
        .attr({ tabindex: '0' })
    }),
    (r.prototype.addSlide = r.prototype.slickAdd =
      function (i, e, t) {
        var o = this
        if ('boolean' == typeof e) (t = e), (e = null)
        else if (e < 0 || e >= o.slideCount) return !1
        o.unload(),
          'number' == typeof e
            ? 0 === e && 0 === o.$slides.length
              ? a(i).appendTo(o.$slideTrack)
              : t
              ? a(i).insertBefore(o.$slides.eq(e))
              : a(i).insertAfter(o.$slides.eq(e))
            : !0 === t
            ? a(i).prependTo(o.$slideTrack)
            : a(i).appendTo(o.$slideTrack),
          (o.$slides = o.$slideTrack.children(this.options.slide)),
          o.$slideTrack.children(this.options.slide).detach(),
          o.$slideTrack.append(o.$slides),
          o.$slides.each(function (i, e) {
            a(e).attr('data-slick-index', i)
          }),
          (o.$slidesCache = o.$slides),
          o.reinit()
      }),
    (r.prototype.animateHeight = function () {
      var i = this
      if (1 === i.options.slidesToShow && !0 === i.options.adaptiveHeight && !1 === i.options.vertical) {
        var e = i.$slides.eq(i.currentSlide).outerHeight(!0)
        i.$list.animate({ height: e }, i.options.speed)
      }
    }),
    (r.prototype.animateSlide = function (i, e) {
      var t = {},
        o = this
      o.animateHeight(),
        !0 === o.options.rtl && !1 === o.options.vertical && (i = -i),
        !1 === o.transformsEnabled
          ? !1 === o.options.vertical
            ? o.$slideTrack.animate({ left: i }, o.options.speed, o.options.easing, e)
            : o.$slideTrack.animate({ top: i }, o.options.speed, o.options.easing, e)
          : !1 === o.cssTransitions
          ? (!0 === o.options.rtl && (o.currentLeft = -o.currentLeft),
            a({ animStart: o.currentLeft }).animate(
              { animStart: i },
              {
                duration: o.options.speed,
                easing: o.options.easing,
                step: function (i) {
                  ;(i = Math.ceil(i)),
                    !1 === o.options.vertical
                      ? (t[o.animType] = 'translate(' + i + 'px, 0px)')
                      : (t[o.animType] = 'translate(0px,' + i + 'px)'),
                    o.$slideTrack.css(t)
                },
                complete: function () {
                  e && e.call()
                }
              }
            ))
          : (o.applyTransition(),
            (i = Math.ceil(i)),
            !1 === o.options.vertical
              ? (t[o.animType] = 'translate3d(' + i + 'px, 0px, 0px)')
              : (t[o.animType] = 'translate3d(0px,' + i + 'px, 0px)'),
            o.$slideTrack.css(t),
            e &&
              setTimeout(function () {
                o.disableTransition(), e.call()
              }, o.options.speed))
    }),
    (r.prototype.getNavTarget = function () {
      var i = this.options.asNavFor
      return i && null !== i && (i = a(i).not(this.$slider)), i
    }),
    (r.prototype.asNavFor = function (e) {
      var i = this.getNavTarget()
      null !== i &&
        'object' == typeof i &&
        i.each(function () {
          var i = a(this).slick('getSlick')
          i.unslicked || i.slideHandler(e, !0)
        })
    }),
    (r.prototype.applyTransition = function (i) {
      var e = this,
        t = {}
      !1 === e.options.fade
        ? (t[e.transitionType] = e.transformType + ' ' + e.options.speed + 'ms ' + e.options.cssEase)
        : (t[e.transitionType] = 'opacity ' + e.options.speed + 'ms ' + e.options.cssEase),
        !1 === e.options.fade ? e.$slideTrack.css(t) : e.$slides.eq(i).css(t)
    }),
    (r.prototype.autoPlay = function () {
      var i = this
      i.autoPlayClear(),
        i.slideCount > i.options.slidesToShow &&
          (i.autoPlayTimer = setInterval(i.autoPlayIterator, i.options.autoplaySpeed))
    }),
    (r.prototype.autoPlayClear = function () {
      this.autoPlayTimer && clearInterval(this.autoPlayTimer)
    }),
    (r.prototype.autoPlayIterator = function () {
      var i = this,
        e = i.currentSlide + i.options.slidesToScroll
      i.paused ||
        i.interrupted ||
        i.focussed ||
        (!1 === i.options.infinite &&
          (1 === i.direction && i.currentSlide + 1 === i.slideCount - 1
            ? (i.direction = 0)
            : 0 === i.direction &&
              ((e = i.currentSlide - i.options.slidesToScroll), i.currentSlide - 1 == 0 && (i.direction = 1))),
        i.slideHandler(e))
    }),
    (r.prototype.buildArrows = function () {
      var i = this
      !0 === i.options.arrows &&
        ((i.$prevArrow = a(i.options.prevArrow).addClass('slick-arrow')),
        (i.$nextArrow = a(i.options.nextArrow).addClass('slick-arrow')),
        i.slideCount > i.options.slidesToShow
          ? (i.$prevArrow.removeClass('slick-hidden').removeAttr('aria-hidden tabindex'),
            i.$nextArrow.removeClass('slick-hidden').removeAttr('aria-hidden tabindex'),
            i.htmlExpr.test(i.options.prevArrow) && i.$prevArrow.prependTo(i.options.appendArrows),
            i.htmlExpr.test(i.options.nextArrow) && i.$nextArrow.appendTo(i.options.appendArrows),
            !0 !== i.options.infinite && i.$prevArrow.addClass('slick-disabled').attr('aria-disabled', 'true'))
          : i.$prevArrow.add(i.$nextArrow).addClass('slick-hidden').attr({ 'aria-disabled': 'true', tabindex: '-1' }))
    }),
    (r.prototype.buildDots = function () {
      var i,
        e,
        t = this
      if (!0 === t.options.dots && t.slideCount > t.options.slidesToShow) {
        for (
          t.$slider.addClass('slick-dotted'), e = a('<ul />').addClass(t.options.dotsClass), i = 0;
          i <= t.getDotCount();
          i += 1
        )
          e.append(a('<li />').append(t.options.customPaging.call(this, t, i)))
        ;(t.$dots = e.appendTo(t.options.appendDots)), t.$dots.find('li').first().addClass('slick-active')
      }
    }),
    (r.prototype.buildOut = function () {
      var i = this
      ;(i.$slides = i.$slider.children(i.options.slide + ':not(.slick-cloned)').addClass('slick-slide')),
        (i.slideCount = i.$slides.length),
        i.$slides.each(function (i, e) {
          a(e)
            .attr('data-slick-index', i)
            .data('originalStyling', a(e).attr('style') || '')
        }),
        i.$slider.addClass('slick-slider'),
        (i.$slideTrack =
          0 === i.slideCount
            ? a('<div class="slick-track"/>').appendTo(i.$slider)
            : i.$slides.wrapAll('<div class="slick-track"/>').parent()),
        (i.$list = i.$slideTrack.wrap('<div class="slick-list"/>').parent()),
        i.$slideTrack.css('opacity', 0),
        (!0 !== i.options.centerMode && !0 !== i.options.swipeToSlide) || (i.options.slidesToScroll = 1),
        a('img[data-lazy]', i.$slider).not('[src]').addClass('slick-loading'),
        i.setupInfinite(),
        i.buildArrows(),
        i.buildDots(),
        i.updateDots(),
        i.setSlideClasses('number' == typeof i.currentSlide ? i.currentSlide : 0),
        !0 === i.options.draggable && i.$list.addClass('draggable')
    }),
    (r.prototype.buildRows = function () {
      var i,
        e,
        t,
        o,
        s,
        n,
        r,
        l = this
      if (((o = document.createDocumentFragment()), (n = l.$slider.children()), 0 < l.options.rows)) {
        for (r = l.options.slidesPerRow * l.options.rows, s = Math.ceil(n.length / r), i = 0; i < s; i++) {
          var d = document.createElement('div')
          for (e = 0; e < l.options.rows; e++) {
            var a = document.createElement('div')
            for (t = 0; t < l.options.slidesPerRow; t++) {
              var c = i * r + (e * l.options.slidesPerRow + t)
              n.get(c) && a.appendChild(n.get(c))
            }
            d.appendChild(a)
          }
          o.appendChild(d)
        }
        l.$slider.empty().append(o),
          l.$slider
            .children()
            .children()
            .children()
            .css({ width: 100 / l.options.slidesPerRow + '%', display: 'inline-block' })
      }
    }),
    (r.prototype.checkResponsive = function (i, e) {
      var t,
        o,
        s,
        n = this,
        r = !1,
        l = n.$slider.width(),
        d = window.innerWidth || a(window).width()
      if (
        ('window' === n.respondTo
          ? (s = d)
          : 'slider' === n.respondTo
          ? (s = l)
          : 'min' === n.respondTo && (s = Math.min(d, l)),
        n.options.responsive && n.options.responsive.length && null !== n.options.responsive)
      ) {
        for (t in ((o = null), n.breakpoints))
          n.breakpoints.hasOwnProperty(t) &&
            (!1 === n.originalSettings.mobileFirst
              ? s < n.breakpoints[t] && (o = n.breakpoints[t])
              : s > n.breakpoints[t] && (o = n.breakpoints[t]))
        null !== o
          ? null !== n.activeBreakpoint
            ? (o !== n.activeBreakpoint || e) &&
              ((n.activeBreakpoint = o),
              'unslick' === n.breakpointSettings[o]
                ? n.unslick(o)
                : ((n.options = a.extend({}, n.originalSettings, n.breakpointSettings[o])),
                  !0 === i && (n.currentSlide = n.options.initialSlide),
                  n.refresh(i)),
              (r = o))
            : ((n.activeBreakpoint = o),
              'unslick' === n.breakpointSettings[o]
                ? n.unslick(o)
                : ((n.options = a.extend({}, n.originalSettings, n.breakpointSettings[o])),
                  !0 === i && (n.currentSlide = n.options.initialSlide),
                  n.refresh(i)),
              (r = o))
          : null !== n.activeBreakpoint &&
            ((n.activeBreakpoint = null),
            (n.options = n.originalSettings),
            !0 === i && (n.currentSlide = n.options.initialSlide),
            n.refresh(i),
            (r = o)),
          i || !1 === r || n.$slider.trigger('breakpoint', [n, r])
      }
    }),
    (r.prototype.changeSlide = function (i, e) {
      var t,
        o,
        s = this,
        n = a(i.currentTarget)
      switch (
        (n.is('a') && i.preventDefault(),
        n.is('li') || (n = n.closest('li')),
        (t =
          s.slideCount % s.options.slidesToScroll != 0
            ? 0
            : (s.slideCount - s.currentSlide) % s.options.slidesToScroll),
        i.data.message)
      ) {
        case 'previous':
          ;(o = 0 === t ? s.options.slidesToScroll : s.options.slidesToShow - t),
            s.slideCount > s.options.slidesToShow && s.slideHandler(s.currentSlide - o, !1, e)
          break
        case 'next':
          ;(o = 0 === t ? s.options.slidesToScroll : t),
            s.slideCount > s.options.slidesToShow && s.slideHandler(s.currentSlide + o, !1, e)
          break
        case 'index':
          var r = 0 === i.data.index ? 0 : i.data.index || n.index() * s.options.slidesToScroll
          s.slideHandler(s.checkNavigable(r), !1, e), n.children().trigger('focus')
          break
        default:
          return
      }
    }),
    (r.prototype.checkNavigable = function (i) {
      var e, t
      if (((t = 0), i > (e = this.getNavigableIndexes())[e.length - 1])) i = e[e.length - 1]
      else
        for (var o in e) {
          if (i < e[o]) {
            i = t
            break
          }
          t = e[o]
        }
      return i
    }),
    (r.prototype.cleanUpEvents = function () {
      var i = this
      i.options.dots &&
        null !== i.$dots &&
        (a('li', i.$dots)
          .off('click.slick', i.changeSlide)
          .off('mouseenter.slick', a.proxy(i.interrupt, i, !0))
          .off('mouseleave.slick', a.proxy(i.interrupt, i, !1)),
        !0 === i.options.accessibility && i.$dots.off('keydown.slick', i.keyHandler)),
        i.$slider.off('focus.slick blur.slick'),
        !0 === i.options.arrows &&
          i.slideCount > i.options.slidesToShow &&
          (i.$prevArrow && i.$prevArrow.off('click.slick', i.changeSlide),
          i.$nextArrow && i.$nextArrow.off('click.slick', i.changeSlide),
          !0 === i.options.accessibility &&
            (i.$prevArrow && i.$prevArrow.off('keydown.slick', i.keyHandler),
            i.$nextArrow && i.$nextArrow.off('keydown.slick', i.keyHandler))),
        i.$list.off('touchstart.slick mousedown.slick', i.swipeHandler),
        i.$list.off('touchmove.slick mousemove.slick', i.swipeHandler),
        i.$list.off('touchend.slick mouseup.slick', i.swipeHandler),
        i.$list.off('touchcancel.slick mouseleave.slick', i.swipeHandler),
        i.$list.off('click.slick', i.clickHandler),
        a(document).off(i.visibilityChange, i.visibility),
        i.cleanUpSlideEvents(),
        !0 === i.options.accessibility && i.$list.off('keydown.slick', i.keyHandler),
        !0 === i.options.focusOnSelect && a(i.$slideTrack).children().off('click.slick', i.selectHandler),
        a(window).off('orientationchange.slick.slick-' + i.instanceUid, i.orientationChange),
        a(window).off('resize.slick.slick-' + i.instanceUid, i.resize),
        a('[draggable!=true]', i.$slideTrack).off('dragstart', i.preventDefault),
        a(window).off('load.slick.slick-' + i.instanceUid, i.setPosition)
    }),
    (r.prototype.cleanUpSlideEvents = function () {
      var i = this
      i.$list.off('mouseenter.slick', a.proxy(i.interrupt, i, !0)),
        i.$list.off('mouseleave.slick', a.proxy(i.interrupt, i, !1))
    }),
    (r.prototype.cleanUpRows = function () {
      var i
      0 < this.options.rows &&
        ((i = this.$slides.children().children()).removeAttr('style'), this.$slider.empty().append(i))
    }),
    (r.prototype.clickHandler = function (i) {
      !1 === this.shouldClick && (i.stopImmediatePropagation(), i.stopPropagation(), i.preventDefault())
    }),
    (r.prototype.destroy = function (i) {
      var e = this
      e.autoPlayClear(),
        (e.touchObject = {}),
        e.cleanUpEvents(),
        a('.slick-cloned', e.$slider).detach(),
        e.$dots && e.$dots.remove(),
        e.$prevArrow &&
          e.$prevArrow.length &&
          (e.$prevArrow
            .removeClass('slick-disabled slick-arrow slick-hidden')
            .removeAttr('aria-hidden aria-disabled tabindex')
            .css('display', ''),
          e.htmlExpr.test(e.options.prevArrow) && e.$prevArrow.remove()),
        e.$nextArrow &&
          e.$nextArrow.length &&
          (e.$nextArrow
            .removeClass('slick-disabled slick-arrow slick-hidden')
            .removeAttr('aria-hidden aria-disabled tabindex')
            .css('display', ''),
          e.htmlExpr.test(e.options.nextArrow) && e.$nextArrow.remove()),
        e.$slides &&
          (e.$slides
            .removeClass('slick-slide slick-active slick-center slick-visible slick-current')
            .removeAttr('aria-hidden')
            .removeAttr('data-slick-index')
            .each(function () {
              a(this).attr('style', a(this).data('originalStyling'))
            }),
          e.$slideTrack.children(this.options.slide).detach(),
          e.$slideTrack.detach(),
          e.$list.detach(),
          e.$slider.append(e.$slides)),
        e.cleanUpRows(),
        e.$slider.removeClass('slick-slider'),
        e.$slider.removeClass('slick-initialized'),
        e.$slider.removeClass('slick-dotted'),
        (e.unslicked = !0),
        i || e.$slider.trigger('destroy', [e])
    }),
    (r.prototype.disableTransition = function (i) {
      var e = {}
      ;(e[this.transitionType] = ''), !1 === this.options.fade ? this.$slideTrack.css(e) : this.$slides.eq(i).css(e)
    }),
    (r.prototype.fadeSlide = function (i, e) {
      var t = this
      !1 === t.cssTransitions
        ? (t.$slides.eq(i).css({ zIndex: t.options.zIndex }),
          t.$slides.eq(i).animate({ opacity: 1 }, t.options.speed, t.options.easing, e))
        : (t.applyTransition(i),
          t.$slides.eq(i).css({ opacity: 1, zIndex: t.options.zIndex }),
          e &&
            setTimeout(function () {
              t.disableTransition(i), e.call()
            }, t.options.speed))
    }),
    (r.prototype.fadeSlideOut = function (i) {
      var e = this
      !1 === e.cssTransitions
        ? e.$slides.eq(i).animate({ opacity: 0, zIndex: e.options.zIndex - 2 }, e.options.speed, e.options.easing)
        : (e.applyTransition(i), e.$slides.eq(i).css({ opacity: 0, zIndex: e.options.zIndex - 2 }))
    }),
    (r.prototype.filterSlides = r.prototype.slickFilter =
      function (i) {
        var e = this
        null !== i &&
          ((e.$slidesCache = e.$slides),
          e.unload(),
          e.$slideTrack.children(this.options.slide).detach(),
          e.$slidesCache.filter(i).appendTo(e.$slideTrack),
          e.reinit())
      }),
    (r.prototype.focusHandler = function () {
      var t = this
      t.$slider.off('focus.slick blur.slick').on('focus.slick blur.slick', '*', function (i) {
        i.stopImmediatePropagation()
        var e = a(this)
        setTimeout(function () {
          t.options.pauseOnFocus && ((t.focussed = e.is(':focus')), t.autoPlay())
        }, 0)
      })
    }),
    (r.prototype.getCurrent = r.prototype.slickCurrentSlide =
      function () {
        return this.currentSlide
      }),
    (r.prototype.getDotCount = function () {
      var i = this,
        e = 0,
        t = 0,
        o = 0
      if (!0 === i.options.infinite)
        if (i.slideCount <= i.options.slidesToShow) ++o
        else
          for (; e < i.slideCount; )
            ++o,
              (e = t + i.options.slidesToScroll),
              (t +=
                i.options.slidesToScroll <= i.options.slidesToShow ? i.options.slidesToScroll : i.options.slidesToShow)
      else if (!0 === i.options.centerMode) o = i.slideCount
      else if (i.options.asNavFor)
        for (; e < i.slideCount; )
          ++o,
            (e = t + i.options.slidesToScroll),
            (t +=
              i.options.slidesToScroll <= i.options.slidesToShow ? i.options.slidesToScroll : i.options.slidesToShow)
      else o = 1 + Math.ceil((i.slideCount - i.options.slidesToShow) / i.options.slidesToScroll)
      return o - 1
    }),
    (r.prototype.getLeft = function (i) {
      var e,
        t,
        o,
        s,
        n = this,
        r = 0
      return (
        (n.slideOffset = 0),
        (t = n.$slides.first().outerHeight(!0)),
        !0 === n.options.infinite
          ? (n.slideCount > n.options.slidesToShow &&
              ((n.slideOffset = n.slideWidth * n.options.slidesToShow * -1),
              (s = -1),
              !0 === n.options.vertical &&
                !0 === n.options.centerMode &&
                (2 === n.options.slidesToShow ? (s = -1.5) : 1 === n.options.slidesToShow && (s = -2)),
              (r = t * n.options.slidesToShow * s)),
            n.slideCount % n.options.slidesToScroll != 0 &&
              i + n.options.slidesToScroll > n.slideCount &&
              n.slideCount > n.options.slidesToShow &&
              (i > n.slideCount
                ? ((n.slideOffset = (n.options.slidesToShow - (i - n.slideCount)) * n.slideWidth * -1),
                  (r = (n.options.slidesToShow - (i - n.slideCount)) * t * -1))
                : ((n.slideOffset = (n.slideCount % n.options.slidesToScroll) * n.slideWidth * -1),
                  (r = (n.slideCount % n.options.slidesToScroll) * t * -1))))
          : i + n.options.slidesToShow > n.slideCount &&
            ((n.slideOffset = (i + n.options.slidesToShow - n.slideCount) * n.slideWidth),
            (r = (i + n.options.slidesToShow - n.slideCount) * t)),
        n.slideCount <= n.options.slidesToShow && (r = n.slideOffset = 0),
        !0 === n.options.centerMode && n.slideCount <= n.options.slidesToShow
          ? (n.slideOffset =
              (n.slideWidth * Math.floor(n.options.slidesToShow)) / 2 - (n.slideWidth * n.slideCount) / 2)
          : !0 === n.options.centerMode && !0 === n.options.infinite
          ? (n.slideOffset += n.slideWidth * Math.floor(n.options.slidesToShow / 2) - n.slideWidth)
          : !0 === n.options.centerMode &&
            ((n.slideOffset = 0), (n.slideOffset += n.slideWidth * Math.floor(n.options.slidesToShow / 2))),
        (e = !1 === n.options.vertical ? i * n.slideWidth * -1 + n.slideOffset : i * t * -1 + r),
        !0 === n.options.variableWidth &&
          ((o =
            n.slideCount <= n.options.slidesToShow || !1 === n.options.infinite
              ? n.$slideTrack.children('.slick-slide').eq(i)
              : n.$slideTrack.children('.slick-slide').eq(i + n.options.slidesToShow)),
          (e =
            !0 === n.options.rtl
              ? o[0]
                ? -1 * (n.$slideTrack.width() - o[0].offsetLeft - o.width())
                : 0
              : o[0]
              ? -1 * o[0].offsetLeft
              : 0),
          !0 === n.options.centerMode &&
            ((o =
              n.slideCount <= n.options.slidesToShow || !1 === n.options.infinite
                ? n.$slideTrack.children('.slick-slide').eq(i)
                : n.$slideTrack.children('.slick-slide').eq(i + n.options.slidesToShow + 1)),
            (e =
              !0 === n.options.rtl
                ? o[0]
                  ? -1 * (n.$slideTrack.width() - o[0].offsetLeft - o.width())
                  : 0
                : o[0]
                ? -1 * o[0].offsetLeft
                : 0),
            (e += (n.$list.width() - o.outerWidth()) / 2))),
        e
      )
    }),
    (r.prototype.getOption = r.prototype.slickGetOption =
      function (i) {
        return this.options[i]
      }),
    (r.prototype.getNavigableIndexes = function () {
      var i,
        e = this,
        t = 0,
        o = 0,
        s = []
      for (
        !1 === e.options.infinite
          ? (i = e.slideCount)
          : ((t = -1 * e.options.slidesToScroll), (o = -1 * e.options.slidesToScroll), (i = 2 * e.slideCount));
        t < i;

      )
        s.push(t),
          (t = o + e.options.slidesToScroll),
          (o += e.options.slidesToScroll <= e.options.slidesToShow ? e.options.slidesToScroll : e.options.slidesToShow)
      return s
    }),
    (r.prototype.getSlick = function () {
      return this
    }),
    (r.prototype.getSlideCount = function () {
      var t,
        o,
        s = this
      return (
        (o = !0 === s.options.centerMode ? s.slideWidth * Math.floor(s.options.slidesToShow / 2) : 0),
        !0 === s.options.swipeToSlide
          ? (s.$slideTrack.find('.slick-slide').each(function (i, e) {
              if (e.offsetLeft - o + a(e).outerWidth() / 2 > -1 * s.swipeLeft) return (t = e), !1
            }),
            Math.abs(a(t).attr('data-slick-index') - s.currentSlide) || 1)
          : s.options.slidesToScroll
      )
    }),
    (r.prototype.goTo = r.prototype.slickGoTo =
      function (i, e) {
        this.changeSlide({ data: { message: 'index', index: parseInt(i) } }, e)
      }),
    (r.prototype.init = function (i) {
      var e = this
      a(e.$slider).hasClass('slick-initialized') ||
        (a(e.$slider).addClass('slick-initialized'),
        e.buildRows(),
        e.buildOut(),
        e.setProps(),
        e.startLoad(),
        e.loadSlider(),
        e.initializeEvents(),
        e.updateArrows(),
        e.updateDots(),
        e.checkResponsive(!0),
        e.focusHandler()),
        i && e.$slider.trigger('init', [e]),
        !0 === e.options.accessibility && e.initADA(),
        e.options.autoplay && ((e.paused = !1), e.autoPlay())
    }),
    (r.prototype.initADA = function () {
      var o = this,
        t = Math.ceil(o.slideCount / o.options.slidesToShow),
        s = o.getNavigableIndexes().filter(function (i) {
          return 0 <= i && i < o.slideCount
        })
      o.$slides
        .add(o.$slideTrack.find('.slick-cloned'))
        .attr({ 'aria-hidden': 'true', tabindex: '-1' })
        .find('a, input, button, select')
        .attr({ tabindex: '-1' }),
        null !== o.$dots &&
          (o.$slides.not(o.$slideTrack.find('.slick-cloned')).each(function (i) {
            var e = s.indexOf(i)
            if ((a(this).attr({ role: 'tabpanel', id: 'slick-slide' + o.instanceUid + i, tabindex: -1 }), -1 !== e)) {
              var t = 'slick-slide-control' + o.instanceUid + e
              a('#' + t).length && a(this).attr({ 'aria-describedby': t })
            }
          }),
          o.$dots
            .attr('role', 'tablist')
            .find('li')
            .each(function (i) {
              var e = s[i]
              a(this).attr({ role: 'presentation' }),
                a(this)
                  .find('button')
                  .first()
                  .attr({
                    role: 'tab',
                    id: 'slick-slide-control' + o.instanceUid + i,
                    'aria-controls': 'slick-slide' + o.instanceUid + e,
                    'aria-label': i + 1 + ' of ' + t,
                    'aria-selected': null,
                    tabindex: '-1'
                  })
            })
            .eq(o.currentSlide)
            .find('button')
            .attr({ 'aria-selected': 'true', tabindex: '0' })
            .end())
      for (var i = o.currentSlide, e = i + o.options.slidesToShow; i < e; i++)
        o.options.focusOnChange ? o.$slides.eq(i).attr({ tabindex: '0' }) : o.$slides.eq(i).removeAttr('tabindex')
      o.activateADA()
    }),
    (r.prototype.initArrowEvents = function () {
      var i = this
      !0 === i.options.arrows &&
        i.slideCount > i.options.slidesToShow &&
        (i.$prevArrow.off('click.slick').on('click.slick', { message: 'previous' }, i.changeSlide),
        i.$nextArrow.off('click.slick').on('click.slick', { message: 'next' }, i.changeSlide),
        !0 === i.options.accessibility &&
          (i.$prevArrow.on('keydown.slick', i.keyHandler), i.$nextArrow.on('keydown.slick', i.keyHandler)))
    }),
    (r.prototype.initDotEvents = function () {
      var i = this
      !0 === i.options.dots &&
        i.slideCount > i.options.slidesToShow &&
        (a('li', i.$dots).on('click.slick', { message: 'index' }, i.changeSlide),
        !0 === i.options.accessibility && i.$dots.on('keydown.slick', i.keyHandler)),
        !0 === i.options.dots &&
          !0 === i.options.pauseOnDotsHover &&
          i.slideCount > i.options.slidesToShow &&
          a('li', i.$dots)
            .on('mouseenter.slick', a.proxy(i.interrupt, i, !0))
            .on('mouseleave.slick', a.proxy(i.interrupt, i, !1))
    }),
    (r.prototype.initSlideEvents = function () {
      var i = this
      i.options.pauseOnHover &&
        (i.$list.on('mouseenter.slick', a.proxy(i.interrupt, i, !0)),
        i.$list.on('mouseleave.slick', a.proxy(i.interrupt, i, !1)))
    }),
    (r.prototype.initializeEvents = function () {
      var i = this
      i.initArrowEvents(),
        i.initDotEvents(),
        i.initSlideEvents(),
        i.$list.on('touchstart.slick mousedown.slick', { action: 'start' }, i.swipeHandler),
        i.$list.on('touchmove.slick mousemove.slick', { action: 'move' }, i.swipeHandler),
        i.$list.on('touchend.slick mouseup.slick', { action: 'end' }, i.swipeHandler),
        i.$list.on('touchcancel.slick mouseleave.slick', { action: 'end' }, i.swipeHandler),
        i.$list.on('click.slick', i.clickHandler),
        a(document).on(i.visibilityChange, a.proxy(i.visibility, i)),
        !0 === i.options.accessibility && i.$list.on('keydown.slick', i.keyHandler),
        !0 === i.options.focusOnSelect && a(i.$slideTrack).children().on('click.slick', i.selectHandler),
        a(window).on('orientationchange.slick.slick-' + i.instanceUid, a.proxy(i.orientationChange, i)),
        a(window).on('resize.slick.slick-' + i.instanceUid, a.proxy(i.resize, i)),
        a('[draggable!=true]', i.$slideTrack).on('dragstart', i.preventDefault),
        a(window).on('load.slick.slick-' + i.instanceUid, i.setPosition),
        a(i.setPosition)
    }),
    (r.prototype.initUI = function () {
      var i = this
      !0 === i.options.arrows && i.slideCount > i.options.slidesToShow && (i.$prevArrow.show(), i.$nextArrow.show()),
        !0 === i.options.dots && i.slideCount > i.options.slidesToShow && i.$dots.show()
    }),
    (r.prototype.keyHandler = function (i) {
      var e = this
      i.target.tagName.match('TEXTAREA|INPUT|SELECT') ||
        (37 === i.keyCode && !0 === e.options.accessibility
          ? e.changeSlide({ data: { message: !0 === e.options.rtl ? 'next' : 'previous' } })
          : 39 === i.keyCode &&
            !0 === e.options.accessibility &&
            e.changeSlide({ data: { message: !0 === e.options.rtl ? 'previous' : 'next' } }))
    }),
    (r.prototype.lazyLoad = function () {
      var i,
        e,
        t,
        n = this
      function o(i) {
        a('img[data-lazy]', i).each(function () {
          var i = a(this),
            e = a(this).attr('data-lazy'),
            t = a(this).attr('data-srcset'),
            o = a(this).attr('data-sizes') || n.$slider.attr('data-sizes'),
            s = document.createElement('img')
          ;(s.onload = function () {
            i.animate({ opacity: 0 }, 100, function () {
              t && (i.attr('srcset', t), o && i.attr('sizes', o)),
                i.attr('src', e).animate({ opacity: 1 }, 200, function () {
                  i.removeAttr('data-lazy data-srcset data-sizes').removeClass('slick-loading')
                }),
                n.$slider.trigger('lazyLoaded', [n, i, e])
            })
          }),
            (s.onerror = function () {
              i.removeAttr('data-lazy').removeClass('slick-loading').addClass('slick-lazyload-error'),
                n.$slider.trigger('lazyLoadError', [n, i, e])
            }),
            t && (s.srcset = t),
            o && (s.sizes = o),
            (s.src = e)
        })
      }
      if (
        (!0 === n.options.centerMode
          ? !0 === n.options.infinite
            ? (t = (e = n.currentSlide + (n.options.slidesToShow / 2 + 1)) + n.options.slidesToShow + 2)
            : ((e = Math.max(0, n.currentSlide - (n.options.slidesToShow / 2 + 1))),
              (t = n.options.slidesToShow / 2 + 1 + 2 + n.currentSlide))
          : ((e = n.options.infinite ? n.options.slidesToShow + n.currentSlide : n.currentSlide),
            (t = Math.ceil(e + n.options.slidesToShow)),
            !0 === n.options.fade && (0 < e && e--, t <= n.slideCount && t++)),
        (i = n.$slider.find('.slick-slide').slice(e, t)),
        'anticipated' === n.options.lazyLoad)
      )
        for (var s = e - 1, r = t, l = n.$slider.find('.slick-slide'), d = 0; d < n.options.slidesToScroll; d++)
          s < 0 && (s = n.slideCount - 1), (i = (i = i.add(l.eq(s))).add(l.eq(r))), s--, r++
      o(i),
        n.slideCount <= n.options.slidesToShow
          ? o(n.$slider.find('.slick-slide'))
          : n.currentSlide >= n.slideCount - n.options.slidesToShow
          ? o(n.$slider.find('.slick-cloned').slice(0, n.options.slidesToShow))
          : 0 === n.currentSlide && o(n.$slider.find('.slick-cloned').slice(-1 * n.options.slidesToShow))
    }),
    (r.prototype.loadSlider = function () {
      var i = this
      i.setPosition(),
        i.$slideTrack.css({ opacity: 1 }),
        i.$slider.removeClass('slick-loading'),
        i.initUI(),
        'progressive' === i.options.lazyLoad && i.progressiveLazyLoad()
    }),
    (r.prototype.next = r.prototype.slickNext =
      function () {
        this.changeSlide({ data: { message: 'next' } })
      }),
    (r.prototype.orientationChange = function () {
      this.checkResponsive(), this.setPosition()
    }),
    (r.prototype.pause = r.prototype.slickPause =
      function () {
        this.autoPlayClear(), (this.paused = !0)
      }),
    (r.prototype.play = r.prototype.slickPlay =
      function () {
        var i = this
        i.autoPlay(), (i.options.autoplay = !0), (i.paused = !1), (i.focussed = !1), (i.interrupted = !1)
      }),
    (r.prototype.postSlide = function (i) {
      var e = this
      e.unslicked ||
        (e.$slider.trigger('afterChange', [e, i]),
        (e.animating = !1),
        e.slideCount > e.options.slidesToShow && e.setPosition(),
        (e.swipeLeft = null),
        e.options.autoplay && e.autoPlay(),
        !0 === e.options.accessibility &&
          (e.initADA(), e.options.focusOnChange && a(e.$slides.get(e.currentSlide)).attr('tabindex', 0).focus()))
    }),
    (r.prototype.prev = r.prototype.slickPrev =
      function () {
        this.changeSlide({ data: { message: 'previous' } })
      }),
    (r.prototype.preventDefault = function (i) {
      i.preventDefault()
    }),
    (r.prototype.progressiveLazyLoad = function (i) {
      i = i || 1
      var e,
        t,
        o,
        s,
        n,
        r = this,
        l = a('img[data-lazy]', r.$slider)
      l.length
        ? ((e = l.first()),
          (t = e.attr('data-lazy')),
          (o = e.attr('data-srcset')),
          (s = e.attr('data-sizes') || r.$slider.attr('data-sizes')),
          ((n = document.createElement('img')).onload = function () {
            o && (e.attr('srcset', o), s && e.attr('sizes', s)),
              e.attr('src', t).removeAttr('data-lazy data-srcset data-sizes').removeClass('slick-loading'),
              !0 === r.options.adaptiveHeight && r.setPosition(),
              r.$slider.trigger('lazyLoaded', [r, e, t]),
              r.progressiveLazyLoad()
          }),
          (n.onerror = function () {
            i < 3
              ? setTimeout(function () {
                  r.progressiveLazyLoad(i + 1)
                }, 500)
              : (e.removeAttr('data-lazy').removeClass('slick-loading').addClass('slick-lazyload-error'),
                r.$slider.trigger('lazyLoadError', [r, e, t]),
                r.progressiveLazyLoad())
          }),
          o && (n.srcset = o),
          s && (n.sizes = s),
          (n.src = t))
        : r.$slider.trigger('allImagesLoaded', [r])
    }),
    (r.prototype.refresh = function (i) {
      var e,
        t,
        o = this
      ;(t = o.slideCount - o.options.slidesToShow),
        !o.options.infinite && o.currentSlide > t && (o.currentSlide = t),
        o.slideCount <= o.options.slidesToShow && (o.currentSlide = 0),
        (e = o.currentSlide),
        o.destroy(!0),
        a.extend(o, o.initials, { currentSlide: e }),
        o.init(),
        i || o.changeSlide({ data: { message: 'index', index: e } }, !1)
    }),
    (r.prototype.registerBreakpoints = function () {
      var i,
        e,
        t,
        o = this,
        s = o.options.responsive || null
      if ('array' === a.type(s) && s.length) {
        for (i in ((o.respondTo = o.options.respondTo || 'window'), s))
          if (((t = o.breakpoints.length - 1), s.hasOwnProperty(i))) {
            for (e = s[i].breakpoint; 0 <= t; )
              o.breakpoints[t] && o.breakpoints[t] === e && o.breakpoints.splice(t, 1), t--
            o.breakpoints.push(e), (o.breakpointSettings[e] = s[i].settings)
          }
        o.breakpoints.sort(function (i, e) {
          return o.options.mobileFirst ? i - e : e - i
        })
      }
    }),
    (r.prototype.reinit = function () {
      var i = this
      ;(i.$slides = i.$slideTrack.children(i.options.slide).addClass('slick-slide')),
        (i.slideCount = i.$slides.length),
        i.currentSlide >= i.slideCount &&
          0 !== i.currentSlide &&
          (i.currentSlide = i.currentSlide - i.options.slidesToScroll),
        i.slideCount <= i.options.slidesToShow && (i.currentSlide = 0),
        i.registerBreakpoints(),
        i.setProps(),
        i.setupInfinite(),
        i.buildArrows(),
        i.updateArrows(),
        i.initArrowEvents(),
        i.buildDots(),
        i.updateDots(),
        i.initDotEvents(),
        i.cleanUpSlideEvents(),
        i.initSlideEvents(),
        i.checkResponsive(!1, !0),
        !0 === i.options.focusOnSelect && a(i.$slideTrack).children().on('click.slick', i.selectHandler),
        i.setSlideClasses('number' == typeof i.currentSlide ? i.currentSlide : 0),
        i.setPosition(),
        i.focusHandler(),
        (i.paused = !i.options.autoplay),
        i.autoPlay(),
        i.$slider.trigger('reInit', [i])
    }),
    (r.prototype.resize = function () {
      var i = this
      a(window).width() !== i.windowWidth &&
        (clearTimeout(i.windowDelay),
        (i.windowDelay = window.setTimeout(function () {
          ;(i.windowWidth = a(window).width()), i.checkResponsive(), i.unslicked || i.setPosition()
        }, 50)))
    }),
    (r.prototype.removeSlide = r.prototype.slickRemove =
      function (i, e, t) {
        var o = this
        if (
          ((i = 'boolean' == typeof i ? (!0 === (e = i) ? 0 : o.slideCount - 1) : !0 === e ? --i : i),
          o.slideCount < 1 || i < 0 || i > o.slideCount - 1)
        )
          return !1
        o.unload(),
          !0 === t ? o.$slideTrack.children().remove() : o.$slideTrack.children(this.options.slide).eq(i).remove(),
          (o.$slides = o.$slideTrack.children(this.options.slide)),
          o.$slideTrack.children(this.options.slide).detach(),
          o.$slideTrack.append(o.$slides),
          (o.$slidesCache = o.$slides),
          o.reinit()
      }),
    (r.prototype.setCSS = function (i) {
      var e,
        t,
        o = this,
        s = {}
      !0 === o.options.rtl && (i = -i),
        (e = 'left' == o.positionProp ? Math.ceil(i) + 'px' : '0px'),
        (t = 'top' == o.positionProp ? Math.ceil(i) + 'px' : '0px'),
        (s[o.positionProp] = i),
        !1 === o.transformsEnabled ||
          (!(s = {}) === o.cssTransitions
            ? (s[o.animType] = 'translate(' + e + ', ' + t + ')')
            : (s[o.animType] = 'translate3d(' + e + ', ' + t + ', 0px)')),
        o.$slideTrack.css(s)
    }),
    (r.prototype.setDimensions = function () {
      var i = this
      !1 === i.options.vertical
        ? !0 === i.options.centerMode && i.$list.css({ padding: '0px ' + i.options.centerPadding })
        : (i.$list.height(i.$slides.first().outerHeight(!0) * i.options.slidesToShow),
          !0 === i.options.centerMode && i.$list.css({ padding: i.options.centerPadding + ' 0px' })),
        (i.listWidth = i.$list.width()),
        (i.listHeight = i.$list.height()),
        !1 === i.options.vertical && !1 === i.options.variableWidth
          ? ((i.slideWidth = Math.ceil(i.listWidth / i.options.slidesToShow)),
            i.$slideTrack.width(Math.ceil(i.slideWidth * i.$slideTrack.children('.slick-slide').length)))
          : !0 === i.options.variableWidth
          ? i.$slideTrack.width(5e3 * i.slideCount)
          : ((i.slideWidth = Math.ceil(i.listWidth)),
            i.$slideTrack.height(
              Math.ceil(i.$slides.first().outerHeight(!0) * i.$slideTrack.children('.slick-slide').length)
            ))
      var e = i.$slides.first().outerWidth(!0) - i.$slides.first().width()
      !1 === i.options.variableWidth && i.$slideTrack.children('.slick-slide').width(i.slideWidth - e)
    }),
    (r.prototype.setFade = function () {
      var t,
        o = this
      o.$slides.each(function (i, e) {
        ;(t = o.slideWidth * i * -1),
          !0 === o.options.rtl
            ? a(e).css({ position: 'relative', right: t, top: 0, zIndex: o.options.zIndex - 2, opacity: 0 })
            : a(e).css({ position: 'relative', left: t, top: 0, zIndex: o.options.zIndex - 2, opacity: 0 })
      }),
        o.$slides.eq(o.currentSlide).css({ zIndex: o.options.zIndex - 1, opacity: 1 })
    }),
    (r.prototype.setHeight = function () {
      var i = this
      if (1 === i.options.slidesToShow && !0 === i.options.adaptiveHeight && !1 === i.options.vertical) {
        var e = i.$slides.eq(i.currentSlide).outerHeight(!0)
        i.$list.css('height', e)
      }
    }),
    (r.prototype.setOption = r.prototype.slickSetOption =
      function () {
        var i,
          e,
          t,
          o,
          s,
          n = this,
          r = !1
        if (
          ('object' === a.type(arguments[0])
            ? ((t = arguments[0]), (r = arguments[1]), (s = 'multiple'))
            : 'string' === a.type(arguments[0]) &&
              ((t = arguments[0]),
              (o = arguments[1]),
              (r = arguments[2]),
              'responsive' === arguments[0] && 'array' === a.type(arguments[1])
                ? (s = 'responsive')
                : void 0 !== arguments[1] && (s = 'single')),
          'single' === s)
        )
          n.options[t] = o
        else if ('multiple' === s)
          a.each(t, function (i, e) {
            n.options[i] = e
          })
        else if ('responsive' === s)
          for (e in o)
            if ('array' !== a.type(n.options.responsive)) n.options.responsive = [o[e]]
            else {
              for (i = n.options.responsive.length - 1; 0 <= i; )
                n.options.responsive[i].breakpoint === o[e].breakpoint && n.options.responsive.splice(i, 1), i--
              n.options.responsive.push(o[e])
            }
        r && (n.unload(), n.reinit())
      }),
    (r.prototype.setPosition = function () {
      var i = this
      i.setDimensions(),
        i.setHeight(),
        !1 === i.options.fade ? i.setCSS(i.getLeft(i.currentSlide)) : i.setFade(),
        i.$slider.trigger('setPosition', [i])
    }),
    (r.prototype.setProps = function () {
      var i = this,
        e = document.body.style
      ;(i.positionProp = !0 === i.options.vertical ? 'top' : 'left'),
        'top' === i.positionProp ? i.$slider.addClass('slick-vertical') : i.$slider.removeClass('slick-vertical'),
        (void 0 === e.WebkitTransition && void 0 === e.MozTransition && void 0 === e.msTransition) ||
          (!0 === i.options.useCSS && (i.cssTransitions = !0)),
        i.options.fade &&
          ('number' == typeof i.options.zIndex
            ? i.options.zIndex < 3 && (i.options.zIndex = 3)
            : (i.options.zIndex = i.defaults.zIndex)),
        void 0 !== e.OTransform &&
          ((i.animType = 'OTransform'),
          (i.transformType = '-o-transform'),
          (i.transitionType = 'OTransition'),
          void 0 === e.perspectiveProperty && void 0 === e.webkitPerspective && (i.animType = !1)),
        void 0 !== e.MozTransform &&
          ((i.animType = 'MozTransform'),
          (i.transformType = '-moz-transform'),
          (i.transitionType = 'MozTransition'),
          void 0 === e.perspectiveProperty && void 0 === e.MozPerspective && (i.animType = !1)),
        void 0 !== e.webkitTransform &&
          ((i.animType = 'webkitTransform'),
          (i.transformType = '-webkit-transform'),
          (i.transitionType = 'webkitTransition'),
          void 0 === e.perspectiveProperty && void 0 === e.webkitPerspective && (i.animType = !1)),
        void 0 !== e.msTransform &&
          ((i.animType = 'msTransform'),
          (i.transformType = '-ms-transform'),
          (i.transitionType = 'msTransition'),
          void 0 === e.msTransform && (i.animType = !1)),
        void 0 !== e.transform &&
          !1 !== i.animType &&
          ((i.animType = 'transform'), (i.transformType = 'transform'), (i.transitionType = 'transition')),
        (i.transformsEnabled = i.options.useTransform && null !== i.animType && !1 !== i.animType)
    }),
    (r.prototype.setSlideClasses = function (i) {
      var e,
        t,
        o,
        s,
        n = this
      if (
        ((t = n.$slider
          .find('.slick-slide')
          .removeClass('slick-active slick-center slick-current')
          .attr('aria-hidden', 'true')),
        n.$slides.eq(i).addClass('slick-current'),
        !0 === n.options.centerMode)
      ) {
        var r = n.options.slidesToShow % 2 == 0 ? 1 : 0
        ;(e = Math.floor(n.options.slidesToShow / 2)),
          !0 === n.options.infinite &&
            (e <= i && i <= n.slideCount - 1 - e
              ? n.$slides
                  .slice(i - e + r, i + e + 1)
                  .addClass('slick-active')
                  .attr('aria-hidden', 'false')
              : ((o = n.options.slidesToShow + i),
                t
                  .slice(o - e + 1 + r, o + e + 2)
                  .addClass('slick-active')
                  .attr('aria-hidden', 'false')),
            0 === i
              ? t.eq(t.length - 1 - n.options.slidesToShow).addClass('slick-center')
              : i === n.slideCount - 1 && t.eq(n.options.slidesToShow).addClass('slick-center')),
          n.$slides.eq(i).addClass('slick-center')
      } else
        0 <= i && i <= n.slideCount - n.options.slidesToShow
          ? n.$slides
              .slice(i, i + n.options.slidesToShow)
              .addClass('slick-active')
              .attr('aria-hidden', 'false')
          : t.length <= n.options.slidesToShow
          ? t.addClass('slick-active').attr('aria-hidden', 'false')
          : ((s = n.slideCount % n.options.slidesToShow),
            (o = !0 === n.options.infinite ? n.options.slidesToShow + i : i),
            n.options.slidesToShow == n.options.slidesToScroll && n.slideCount - i < n.options.slidesToShow
              ? t
                  .slice(o - (n.options.slidesToShow - s), o + s)
                  .addClass('slick-active')
                  .attr('aria-hidden', 'false')
              : t
                  .slice(o, o + n.options.slidesToShow)
                  .addClass('slick-active')
                  .attr('aria-hidden', 'false'))
      ;('ondemand' !== n.options.lazyLoad && 'anticipated' !== n.options.lazyLoad) || n.lazyLoad()
    }),
    (r.prototype.setupInfinite = function () {
      var i,
        e,
        t,
        o = this
      if (
        (!0 === o.options.fade && (o.options.centerMode = !1),
        !0 === o.options.infinite && !1 === o.options.fade && ((e = null), o.slideCount > o.options.slidesToShow))
      ) {
        for (
          t = !0 === o.options.centerMode ? o.options.slidesToShow + 1 : o.options.slidesToShow, i = o.slideCount;
          i > o.slideCount - t;
          i -= 1
        )
          (e = i - 1),
            a(o.$slides[e])
              .clone(!0)
              .attr('id', '')
              .attr('data-slick-index', e - o.slideCount)
              .prependTo(o.$slideTrack)
              .addClass('slick-cloned')
        for (i = 0; i < t + o.slideCount; i += 1)
          (e = i),
            a(o.$slides[e])
              .clone(!0)
              .attr('id', '')
              .attr('data-slick-index', e + o.slideCount)
              .appendTo(o.$slideTrack)
              .addClass('slick-cloned')
        o.$slideTrack
          .find('.slick-cloned')
          .find('[id]')
          .each(function () {
            a(this).attr('id', '')
          })
      }
    }),
    (r.prototype.interrupt = function (i) {
      i || this.autoPlay(), (this.interrupted = i)
    }),
    (r.prototype.selectHandler = function (i) {
      var e = a(i.target).is('.slick-slide') ? a(i.target) : a(i.target).parents('.slick-slide'),
        t = parseInt(e.attr('data-slick-index'))
      t || (t = 0), this.slideCount <= this.options.slidesToShow ? this.slideHandler(t, !1, !0) : this.slideHandler(t)
    }),
    (r.prototype.slideHandler = function (i, e, t) {
      var o,
        s,
        n,
        r,
        l,
        d,
        a = this
      if (
        ((e = e || !1),
        !((!0 === a.animating && !0 === a.options.waitForAnimate) || (!0 === a.options.fade && a.currentSlide === i)))
      )
        if (
          (!1 === e && a.asNavFor(i),
          (o = i),
          (l = a.getLeft(o)),
          (r = a.getLeft(a.currentSlide)),
          (a.currentLeft = null === a.swipeLeft ? r : a.swipeLeft),
          !1 === a.options.infinite &&
            !1 === a.options.centerMode &&
            (i < 0 || i > a.getDotCount() * a.options.slidesToScroll))
        )
          !1 === a.options.fade &&
            ((o = a.currentSlide),
            !0 !== t && a.slideCount > a.options.slidesToShow
              ? a.animateSlide(r, function () {
                  a.postSlide(o)
                })
              : a.postSlide(o))
        else if (
          !1 === a.options.infinite &&
          !0 === a.options.centerMode &&
          (i < 0 || i > a.slideCount - a.options.slidesToScroll)
        )
          !1 === a.options.fade &&
            ((o = a.currentSlide),
            !0 !== t && a.slideCount > a.options.slidesToShow
              ? a.animateSlide(r, function () {
                  a.postSlide(o)
                })
              : a.postSlide(o))
        else {
          if (
            (a.options.autoplay && clearInterval(a.autoPlayTimer),
            (s =
              o < 0
                ? a.slideCount % a.options.slidesToScroll != 0
                  ? a.slideCount - (a.slideCount % a.options.slidesToScroll)
                  : a.slideCount + o
                : o >= a.slideCount
                ? a.slideCount % a.options.slidesToScroll != 0
                  ? 0
                  : o - a.slideCount
                : o),
            (a.animating = !0),
            a.$slider.trigger('beforeChange', [a, a.currentSlide, s]),
            (n = a.currentSlide),
            (a.currentSlide = s),
            a.setSlideClasses(a.currentSlide),
            a.options.asNavFor &&
              (d = (d = a.getNavTarget()).slick('getSlick')).slideCount <= d.options.slidesToShow &&
              d.setSlideClasses(a.currentSlide),
            a.updateDots(),
            a.updateArrows(),
            !0 === a.options.fade)
          )
            return (
              !0 !== t
                ? (a.fadeSlideOut(n),
                  a.fadeSlide(s, function () {
                    a.postSlide(s)
                  }))
                : a.postSlide(s),
              void a.animateHeight()
            )
          !0 !== t && a.slideCount > a.options.slidesToShow
            ? a.animateSlide(l, function () {
                a.postSlide(s)
              })
            : a.postSlide(s)
        }
    }),
    (r.prototype.startLoad = function () {
      var i = this
      !0 === i.options.arrows && i.slideCount > i.options.slidesToShow && (i.$prevArrow.hide(), i.$nextArrow.hide()),
        !0 === i.options.dots && i.slideCount > i.options.slidesToShow && i.$dots.hide(),
        i.$slider.addClass('slick-loading')
    }),
    (r.prototype.swipeDirection = function () {
      var i,
        e,
        t,
        o,
        s = this
      return (
        (i = s.touchObject.startX - s.touchObject.curX),
        (e = s.touchObject.startY - s.touchObject.curY),
        (t = Math.atan2(e, i)),
        (o = Math.round((180 * t) / Math.PI)) < 0 && (o = 360 - Math.abs(o)),
        o <= 45 && 0 <= o
          ? !1 === s.options.rtl
            ? 'left'
            : 'right'
          : o <= 360 && 315 <= o
          ? !1 === s.options.rtl
            ? 'left'
            : 'right'
          : 135 <= o && o <= 225
          ? !1 === s.options.rtl
            ? 'right'
            : 'left'
          : !0 === s.options.verticalSwiping
          ? 35 <= o && o <= 135
            ? 'down'
            : 'up'
          : 'vertical'
      )
    }),
    (r.prototype.swipeEnd = function (i) {
      var e,
        t,
        o = this
      if (((o.dragging = !1), (o.swiping = !1), o.scrolling)) return (o.scrolling = !1)
      if (((o.interrupted = !1), (o.shouldClick = !(10 < o.touchObject.swipeLength)), void 0 === o.touchObject.curX))
        return !1
      if (
        (!0 === o.touchObject.edgeHit && o.$slider.trigger('edge', [o, o.swipeDirection()]),
        o.touchObject.swipeLength >= o.touchObject.minSwipe)
      ) {
        switch ((t = o.swipeDirection())) {
          case 'left':
          case 'down':
            ;(e = o.options.swipeToSlide
              ? o.checkNavigable(o.currentSlide + o.getSlideCount())
              : o.currentSlide + o.getSlideCount()),
              (o.currentDirection = 0)
            break
          case 'right':
          case 'up':
            ;(e = o.options.swipeToSlide
              ? o.checkNavigable(o.currentSlide - o.getSlideCount())
              : o.currentSlide - o.getSlideCount()),
              (o.currentDirection = 1)
        }
        'vertical' != t && (o.slideHandler(e), (o.touchObject = {}), o.$slider.trigger('swipe', [o, t]))
      } else o.touchObject.startX !== o.touchObject.curX && (o.slideHandler(o.currentSlide), (o.touchObject = {}))
    }),
    (r.prototype.swipeHandler = function (i) {
      var e = this
      if (
        !(
          !1 === e.options.swipe ||
          ('ontouchend' in document && !1 === e.options.swipe) ||
          (!1 === e.options.draggable && -1 !== i.type.indexOf('mouse'))
        )
      )
        switch (
          ((e.touchObject.fingerCount =
            i.originalEvent && void 0 !== i.originalEvent.touches ? i.originalEvent.touches.length : 1),
          (e.touchObject.minSwipe = e.listWidth / e.options.touchThreshold),
          !0 === e.options.verticalSwiping && (e.touchObject.minSwipe = e.listHeight / e.options.touchThreshold),
          i.data.action)
        ) {
          case 'start':
            e.swipeStart(i)
            break
          case 'move':
            e.swipeMove(i)
            break
          case 'end':
            e.swipeEnd(i)
        }
    }),
    (r.prototype.swipeMove = function (i) {
      var e,
        t,
        o,
        s,
        n,
        r,
        l = this
      return (
        (n = void 0 !== i.originalEvent ? i.originalEvent.touches : null),
        !(!l.dragging || l.scrolling || (n && 1 !== n.length)) &&
          ((e = l.getLeft(l.currentSlide)),
          (l.touchObject.curX = void 0 !== n ? n[0].pageX : i.clientX),
          (l.touchObject.curY = void 0 !== n ? n[0].pageY : i.clientY),
          (l.touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(l.touchObject.curX - l.touchObject.startX, 2)))),
          (r = Math.round(Math.sqrt(Math.pow(l.touchObject.curY - l.touchObject.startY, 2)))),
          !l.options.verticalSwiping && !l.swiping && 4 < r
            ? !(l.scrolling = !0)
            : (!0 === l.options.verticalSwiping && (l.touchObject.swipeLength = r),
              (t = l.swipeDirection()),
              void 0 !== i.originalEvent && 4 < l.touchObject.swipeLength && ((l.swiping = !0), i.preventDefault()),
              (s = (!1 === l.options.rtl ? 1 : -1) * (l.touchObject.curX > l.touchObject.startX ? 1 : -1)),
              !0 === l.options.verticalSwiping && (s = l.touchObject.curY > l.touchObject.startY ? 1 : -1),
              (o = l.touchObject.swipeLength),
              (l.touchObject.edgeHit = !1) === l.options.infinite &&
                ((0 === l.currentSlide && 'right' === t) || (l.currentSlide >= l.getDotCount() && 'left' === t)) &&
                ((o = l.touchObject.swipeLength * l.options.edgeFriction), (l.touchObject.edgeHit = !0)),
              !1 === l.options.vertical
                ? (l.swipeLeft = e + o * s)
                : (l.swipeLeft = e + o * (l.$list.height() / l.listWidth) * s),
              !0 === l.options.verticalSwiping && (l.swipeLeft = e + o * s),
              !0 !== l.options.fade &&
                !1 !== l.options.touchMove &&
                (!0 === l.animating ? ((l.swipeLeft = null), !1) : void l.setCSS(l.swipeLeft))))
      )
    }),
    (r.prototype.swipeStart = function (i) {
      var e,
        t = this
      if (((t.interrupted = !0), 1 !== t.touchObject.fingerCount || t.slideCount <= t.options.slidesToShow))
        return !(t.touchObject = {})
      void 0 !== i.originalEvent && void 0 !== i.originalEvent.touches && (e = i.originalEvent.touches[0]),
        (t.touchObject.startX = t.touchObject.curX = void 0 !== e ? e.pageX : i.clientX),
        (t.touchObject.startY = t.touchObject.curY = void 0 !== e ? e.pageY : i.clientY),
        (t.dragging = !0)
    }),
    (r.prototype.unfilterSlides = r.prototype.slickUnfilter =
      function () {
        var i = this
        null !== i.$slidesCache &&
          (i.unload(),
          i.$slideTrack.children(this.options.slide).detach(),
          i.$slidesCache.appendTo(i.$slideTrack),
          i.reinit())
      }),
    (r.prototype.unload = function () {
      var i = this
      a('.slick-cloned', i.$slider).remove(),
        i.$dots && i.$dots.remove(),
        i.$prevArrow && i.htmlExpr.test(i.options.prevArrow) && i.$prevArrow.remove(),
        i.$nextArrow && i.htmlExpr.test(i.options.nextArrow) && i.$nextArrow.remove(),
        i.$slides
          .removeClass('slick-slide slick-active slick-visible slick-current')
          .attr('aria-hidden', 'true')
          .css('width', '')
    }),
    (r.prototype.unslick = function (i) {
      this.$slider.trigger('unslick', [this, i]), this.destroy()
    }),
    (r.prototype.updateArrows = function () {
      var i = this
      Math.floor(i.options.slidesToShow / 2),
        !0 === i.options.arrows &&
          i.slideCount > i.options.slidesToShow &&
          !i.options.infinite &&
          (i.$prevArrow.removeClass('slick-disabled').attr('aria-disabled', 'false'),
          i.$nextArrow.removeClass('slick-disabled').attr('aria-disabled', 'false'),
          0 === i.currentSlide
            ? (i.$prevArrow.addClass('slick-disabled').attr('aria-disabled', 'true'),
              i.$nextArrow.removeClass('slick-disabled').attr('aria-disabled', 'false'))
            : i.currentSlide >= i.slideCount - i.options.slidesToShow && !1 === i.options.centerMode
            ? (i.$nextArrow.addClass('slick-disabled').attr('aria-disabled', 'true'),
              i.$prevArrow.removeClass('slick-disabled').attr('aria-disabled', 'false'))
            : i.currentSlide >= i.slideCount - 1 &&
              !0 === i.options.centerMode &&
              (i.$nextArrow.addClass('slick-disabled').attr('aria-disabled', 'true'),
              i.$prevArrow.removeClass('slick-disabled').attr('aria-disabled', 'false')))
    }),
    (r.prototype.updateDots = function () {
      var i = this
      null !== i.$dots &&
        (i.$dots.find('li').removeClass('slick-active').end(),
        i.$dots
          .find('li')
          .eq(Math.floor(i.currentSlide / i.options.slidesToScroll))
          .addClass('slick-active'))
    }),
    (r.prototype.visibility = function () {
      this.options.autoplay && (document[this.hidden] ? (this.interrupted = !0) : (this.interrupted = !1))
    }),
    (a.fn.slick = function () {
      var i,
        e,
        t = this,
        o = arguments[0],
        s = Array.prototype.slice.call(arguments, 1),
        n = t.length
      for (i = 0; i < n; i++)
        if (
          ('object' == typeof o || void 0 === o
            ? (t[i].slick = new r(t[i], o))
            : (e = t[i].slick[o].apply(t[i].slick, s)),
          void 0 !== e)
        )
          return e
      return t
    })
})


/*!
 * scroll-carousel.js
 */
'use strict'

function ScrollCarousel(domNode) {
  this.carousel = domNode
  this.carouselTrack = this.carousel.querySelector('[data-carousel-track]')

  this.isDirectionHorizontal = this.carousel.getAttribute('data-direction') !== 'vertical'
  this.currentPageIndex = 0
  this.paginationPerSlide = this.carousel.getAttribute('data-pagination-per-slide') !== null ? true : false

  this.slideSize = 0
  this.slidesToScroll = 1

  this.resizeTimer

  this.SCROLL_END_SENSITIVITY = 40 // Workaround IE rounding for clientWidth and scrollWidth
  this.EDGE_RESISTANCE = 100
  this.CLICK_RESISTANCE = 20

  this.isFirefox = navigator.userAgent.toLowerCase().indexOf('firefox') > -1

  this.position = { top: 0, left: 0, x: 0, y: 0 }

  this.stylesClass = {
    item: 'carousel-item',
    initialized: 'carousel-initialized',
    noScroll: 'carousel-no-scroll',
    prevVisible: 'carousel-prev-visible',
    nextVisible: 'carousel-next-visible',
    arrow: 'carousel-arrow',
    prevArrow: 'carousel-prev',
    nextArrow: 'carousel-next',
    pagination: 'carousel-pagination',
    page: 'carousel-page',
    current: 'active',
    grabbing: 'carousel-grabbing'
  }

  this.strings = {
    previous: 'Previous',
    next: 'Next'
  }

  this.init = function () {
    this.getOrientation()
    this.initSlides()
    this.setSlideSizes()
    this.initArrows()
    this.initPagination()
    this.addEventListeners()
    this.addPaginationEventListeners()
    this.onScroll()
    this.syncPrevNextButtons()
    this.setActivePagination(this.getCurrentPageIndex())
    this.carousel.classList.add(this.stylesClass.initialized)
  }

  this.initSlides = function () {
    for (var i = 0; i < this.carouselTrack.children.length; i++) {
      this.carouselTrack.children[i].setAttribute('tabindex', 0)
      this.carouselTrack.children[i].classList.add(this.stylesClass.item)
    }
  }

  this.setSlideSizes = function () {
    for (var i = 0; i < this.carouselTrack.children.length; i++) {
      // Find slide size (on second item because it has the correct margin)
      if (i == 1) {
        var slideStyle = getComputedStyle(this.carouselTrack.children[i]),
          slideMargin = 0

        if (this.isDirectionHorizontal) {
          this.slideSize = this.carouselTrack.children[i].offsetWidth
          slideMargin = parseInt(slideStyle.marginLeft)
        } else {
          this.slideSize = this.carouselTrack.children[i].offsetHeight
          slideMargin = parseInt(slideStyle.marginTop)
        }

        this.slideSize = this.slideSize + slideMargin
      }
    }

    if (this.slideSize > 0) {
      if (this.paginationPerSlide) {
        this.slidesToScroll = 1
      } else {
        if (this.isDirectionHorizontal) {
          this.slidesToScroll = Math.round(this.carouselTrack.clientWidth / this.slideSize)
        } else {
          this.slidesToScroll = Math.round(this.carouselTrack.clientHeight / this.slideSize)
        }
      }
    }
  }

  this.getOrientation = function () {
    if (this.carousel.classList.contains('large-up--vertical')) {
      if (slate.browserWidth == 'large' || slate.browserWidth == 'xlarge' || slate.browserWidth == 'xxlarge') {
        this.isDirectionHorizontal = false
      } else {
        this.isDirectionHorizontal = true
      }
    }
  }

  this.addEventListeners = function () {
    this.onWindowResize = this.onWindowResize.bind(this)
    this.onResize = this.onResize.bind(this)
    this.onScroll = this.onScroll.bind(this)
    this.scrollBackward = this.scrollBackward.bind(this)
    this.scrollForward = this.scrollForward.bind(this)

    window.addEventListener('resize', this.onWindowResize)
    this.carouselTrack.addEventListener('scroll', this.onScroll, { passive: true })
    this.carouselTrack.addEventListener('touchstart', this.onScroll, { passive: true })

    if (this.carousel.hasAttribute('data-arrows')) {
      this.prevArrow.addEventListener('click', this.scrollBackward)
      this.nextArrow.addEventListener('click', this.scrollForward)
    }

    this.addGrabEventListeners()
  }

  this.addPaginationEventListeners = function () {
    this.onPageClick = this.onPageClick.bind(this)

    if (this.pagination) {
      const pages = this.pagination.children
      for (var i = 0; i < pages.length; i++) {
        var pageButton = pages[i]
        pageButton.addEventListener('click', this.onPageClick)
      }
    }
  }

  this.addGrabEventListeners = function () {
    this.onMouseDown = this.onMouseDown.bind(this)
    this.onMouseMove = this.onMouseMove.bind(this)
    this.onMouseUp = this.onMouseUp.bind(this)

    this.carouselTrack.addEventListener('mousedown', this.onMouseDown)
    this.carouselTrack.addEventListener('mouseup', this.onMouseUp)
  }

  this.removeEventListeners = function () {
    this.carouselTrack.removeEventListener('scroll', this.onScroll)
    this.carouselTrack.removeEventListener('touchstart', this.onScroll)

    if (this.carousel.hasAttribute('data-arrows')) {
      this.prevArrow.removeEventListener('click', this.scrollBackward)
      this.nextArrow.removeEventListener('click', this.scrollForward)
    }

    this.removeGrabEventListeners()
  }

  this.removePaginationEventListeners = function () {
    if (this.pagination) {
      const pages = this.pagination.children
      for (var i = 0; i < pages.length; i++) {
        var pageButton = pages[i]
        pageButton.removeEventListener('click', this.onPageClick)
      }
    }
  }

  this.removeGrabEventListeners = function () {
    this.carouselTrack.removeEventListener('mousedown', this.onMouseDown)
    this.carouselTrack.removeEventListener('mouseup', this.onMouseUp)
  }

  this.onWindowResize = function () {
    window.clearTimeout(this.resizeTimer)
    this.resizeTimer = window.setTimeout(this.onResize, 400)
  }

  this.onResize = function () {
    this.getOrientation()
    this.getScrollState()
    this.syncPrevNextButtons()
    this.setSlideSizes()
    this.destroyPagination()
    this.initPagination()
    this.addPaginationEventListeners()
    this.setActivePagination(this.getCurrentPageIndex())
  }

  // Prev next buttons and UI
  this.onScroll = function () {
    this.getScrollState()

    if (!this.isCallInNextFrameRequested) {
      window.requestAnimationFrame(this.scrollHandlers.bind(this))
      this.isCallInNextFrameRequested = true
    }
  }

  this.onPageClick = function (event) {
    const index = parseInt(event.target.getAttribute('data-carousel-page'), 10)
    this.scrollToPage(index)
  }

  this.getScrollState = function () {
    // Possible optimization: Resize Observer that watch carousel width and cache this.carousel.offsetWidth
    if (this.isDirectionHorizontal) {
      const totalScrollWidth = this.carouselTrack.scrollLeft + this.carousel.offsetWidth
      this.isScrollStart = this.carouselTrack.scrollLeft <= 0
      this.isScrollEnd = totalScrollWidth + this.SCROLL_END_SENSITIVITY >= this.carouselTrack.scrollWidth
    } else {
      const totalScrollHeight = this.carouselTrack.scrollTop + this.carousel.offsetHeight
      this.isScrollStart = this.carouselTrack.scrollTop <= 0
      this.isScrollEnd = totalScrollHeight + this.SCROLL_END_SENSITIVITY >= this.carouselTrack.scrollHeight
    }
  }

  this.scrollHandlers = function () {
    this.syncPrevNextButtons()
    this.updateCurrentPageIndex()
    this.isCallInNextFrameRequested = false
  }

  this.updateCurrentPageIndex = function () {
    if (this.isDirectionHorizontal) {
      var requestedPageIndexRaw = this.carouselTrack.scrollLeft / this.carousel.clientWidth

      if (this.paginationPerSlide) {
        requestedPageIndexRaw = this.carouselTrack.scrollLeft / this.slideSize
      }
    } else {
      var requestedPageIndexRaw = this.carouselTrack.scrollTop / this.carousel.clientHeight

      if (this.paginationPerSlide) {
        requestedPageIndexRaw = this.carouselTrack.scrollTop / this.slideSize
      }
    }

    var requestedPageIndex = Math.round(requestedPageIndexRaw)

    // If very close, then round up (stops bug with pagination not selecting dots at certain viewports)
    var diffRounded = Math.abs(requestedPageIndex - requestedPageIndexRaw)

    if (diffRounded > 0.49) {
      var requestedPageIndex = Math.ceil(requestedPageIndexRaw)
    }

    if (this.currentPageIndex === requestedPageIndex) {
      return
    }

    this.onPageChanged(requestedPageIndex)

    this.currentPageIndex = requestedPageIndex
    this.carousel.dispatchEvent(
      new CustomEvent('scrollCarousel:pageChanged', { bubbles: false, detail: this.currentPageIndex })
    )
  }

  this.syncPrevNextButtons = function () {
    if (this.isScrollStart && this.isScrollEnd) {
      // No scroll case
      this.carousel.classList.add(this.stylesClass.noScroll)
      this.hasScroll = false
    } else {
      this.carousel.classList.remove(this.stylesClass.noScroll)
      this.hasScroll = true
    }

    if (!this.carousel.hasAttribute('data-arrows')) {
      return
    }

    if (this.isScrollStart) {
      this.carousel.classList.remove(this.stylesClass.prevVisible)
      this.prevArrow.setAttribute('disabled', '')
    } else {
      this.carousel.classList.add(this.stylesClass.prevVisible)
      this.prevArrow.removeAttribute('disabled')
    }

    if (this.isScrollEnd) {
      this.carousel.classList.remove(this.stylesClass.nextVisible)
      this.nextArrow.setAttribute('disabled', '')
    } else {
      this.carousel.classList.add(this.stylesClass.nextVisible)
      this.nextArrow.removeAttribute('disabled')
    }
  }

  this.onPageChanged = function (requestedPageIndex) {
    this.setActivePagination(requestedPageIndex)
  }

  // Prev next functionality

  // relative scroll - page by page
  this.scrollBackward = function (event) {
    event.preventDefault()
    this.scrollByPage(false)
  }

  this.scrollForward = function (event) {
    event.preventDefault()
    this.scrollByPage(true)
  }

  this.scrollByPage = function (isNext) {
    var currentTop = this.carouselTrack.scrollTop
    var currentLeft = this.carouselTrack.scrollLeft
    var top = this.isDirectionHorizontal ? 0 : this.carouselTrack.clientHeight
    var left = this.isDirectionHorizontal ? this.carouselTrack.clientWidth : 0

    if (this.slideSize > 0) {
      if (this.isDirectionHorizontal) {
        left = this.slidesToScroll * this.slideSize
      } else {
        top = this.slidesToScroll * this.slideSize
      }
    }

    if (isNext) {
      top = currentTop + top
      left = currentLeft + left
    } else {
      top = currentTop - top
      left = currentLeft - left

      if (top < 0) {
        top = 0
      }

      if (left < 0) {
        left = 0
      }
    }

    this.scrollToPoint(top, left)
  }

  // abs scroll - page to page
  this.getCurrentPageIndex = function () {
    var result = 0

    if (this.isDirectionHorizontal) {
      result = Math.round(this.carouselTrack.scrollLeft / this.carouselTrack.clientWidth)

      if (this.paginationPerSlide) {
        if (this.slideSize > 0) {
          result = Math.round(this.carouselTrack.scrollLeft / this.slideSize)
        }
      }
    } else {
      result = Math.round(this.carouselTrack.scrollTop / this.carouselTrack.clientHeight)

      if (this.paginationPerSlide) {
        if (this.slideSize > 0) {
          result = Math.round(this.carouselTrack.scrollTop / this.slideSize)
        }
      }
    }

    return result
  }

  this.scrollToNextPage = function () {
    this.scrollToPage(this.getCurrentPageIndex() + 1)
  }

  this.scrollToPrevPage = function () {
    this.scrollToPage(this.getCurrentPageIndex() - 1)
  }

  this.scrollToPage = function (pageIndex) {
    if (pageIndex < 0) {
      return
    }

    var top = this.isDirectionHorizontal ? 0 : Math.round(this.carousel.clientHeight * pageIndex)
    var left = this.isDirectionHorizontal ? Math.round(this.carousel.clientWidth * pageIndex) : 0

    if (this.slideSize > 0) {
      if (this.isDirectionHorizontal) {
        left = this.slidesToScroll * this.slideSize * pageIndex
      } else {
        top = this.slidesToScroll * this.slideSize * pageIndex
      }
    }

    if (this.isDirectionHorizontal) {
      this.scrollToPoint(top, left)
    } else {
      this.scrollToPoint(top, left)
    }
  }

  this.scrollToPoint = function (top, left) {
    const element = this.carouselTrack
    // Safari and Edge do not have smooth scrolling please use polyfill or just leave it as is
    // If you still using jQuery you could call $.animate()
    if (typeof element.scrollTo === 'function') {
      element.scrollTo({
        top: top,
        left: left,
        behavior: 'smooth'
      })
    } else {
      if (this.isDirectionHorizontal) {
        element.scrollLeft = left
      } else {
        element.scrollTop = top
      }
    }
  }

  // Arrows

  this.initArrows = function () {
    if (!this.carousel.hasAttribute('data-arrows')) {
      return
    }
    this.createArrows()
  }

  this.createArrows = function () {
    this.prevArrow = document.createElement('button')
    this.prevArrow.className = this.stylesClass.arrow + ' ' + this.stylesClass.prevArrow
    this.prevArrow.setAttribute('tabindex', -1)
    this.prevArrow.setAttribute('aria-label', this.strings.previous)
    this.prevArrow.textContent = this.strings.previous

    this.nextArrow = document.createElement('button')
    this.nextArrow.className = this.stylesClass.arrow + ' ' + this.stylesClass.nextArrow
    this.nextArrow.setAttribute('tabindex', -1)
    this.nextArrow.setAttribute('aria-label', this.strings.next)
    this.nextArrow.textContent = this.strings.next

    this.carousel.appendChild(this.prevArrow)
    this.carousel.appendChild(this.nextArrow)
  }

  this.destroyArrows = function () {
    this.carousel.removeChild(this.prevArrow)
    this.carousel.removeChild(this.nextArrow)
    delete this.prevArrow
    delete this.nextArrow
  }

  // Pagination

  this.initPagination = function () {
    if (!(this.carousel.hasAttribute('data-pagination') || this.carousel.hasAttribute('data-pagination-per-slide'))) {
      return
    }
    this.createPagination()
    this.updateCurrentPageIndex()
  }

  this.createPagination = function () {
    const hasPagination = !!this.pagination

    if (this.isDirectionHorizontal) {
      var numberOfPagesRaw = this.carouselTrack.scrollWidth / this.carouselTrack.clientWidth

      if (this.paginationPerSlide) {
        numberOfPagesRaw =
          Math.round(this.carouselTrack.scrollWidth / this.slideSize) -
          Math.round(this.carouselTrack.clientWidth / this.slideSize) +
          1
      }
    } else {
      var numberOfPagesRaw = this.carouselTrack.scrollHeight / this.carouselTrack.clientHeight

      if (this.paginationPerSlide) {
        numberOfPagesRaw =
          Math.round(this.carouselTrack.scrollHeight / this.slideSize) -
          Math.round(this.carouselTrack.clientHeight / this.slideSize) +
          1
      }
    }

    var numberOfPages = Math.round(numberOfPagesRaw)

    // If very close, then round up (stops bug with pagination not showing enough dots at certain viewports)
    var diffRounded = Math.abs(numberOfPages - numberOfPagesRaw)

    if (diffRounded > 0.49) {
      numberOfPages = Math.ceil(numberOfPagesRaw)
    }

    if (!hasPagination) {
      this.pagination = document.createElement('div')
      this.pagination.className = this.stylesClass.pagination
    } else {
      this.carousel.removeChild(this.pagination)
    }

    for (var i = 0; i < numberOfPages; i++) {
      const page = document.createElement('div')
      page.className = this.stylesClass.page
      page.setAttribute('data-carousel-page', i)
      this.pagination.appendChild(page)
    }

    if (!hasPagination) {
      this.carousel.appendChild(this.pagination)
    }
  }

  this.setActivePagination = function (requestedPageIndex) {
    if (!this.pagination) {
      return
    }

    const pages = this.pagination.children
    if (pages[this.currentPageIndex] !== undefined) {
      pages[this.currentPageIndex].classList.remove(this.stylesClass.current)
    }

    if (pages[requestedPageIndex] !== undefined) {
      pages[requestedPageIndex].classList.add(this.stylesClass.current)
    }
  }

  this.destroyPagination = function () {
    if (!this.pagination) {
      return
    }
    this.removePaginationEventListeners()
    this.carousel.removeChild(this.pagination)
    delete this.pagination
  }

  // Grab

  this.onMouseDown = function (event) {
    // On Firefox, stop drag and drop for links etc, only on the track
    if (event.target != this.carouselTrack) {
      event.preventDefault()
    }

    this.position = {
      left: this.carouselTrack.scrollLeft,
      top: this.carouselTrack.scrollTop,
      x: event.clientX,
      y: event.clientY
    }

    this.carouselTrack.addEventListener('mousemove', this.onMouseMove)
    this.carouselTrack.addEventListener('mouseleave', this.onMouseUp)
  }

  this.onMouseMove = function (event) {
    const deltaX = event.clientX - this.position.x
    const deltaY = event.clientY - this.position.y

    this.delta = this.isDirectionHorizontal ? deltaX : deltaY

    // Don't trigger grab on clicks with slight mouse movement
    if (this.delta < -this.CLICK_RESISTANCE || this.delta > this.CLICK_RESISTANCE) {
      this.carouselTrack.classList.add(this.stylesClass.grabbing)
      this.isMouseMoved = true

      this.carouselTrack.scrollTo({
        top: this.position.top - deltaY,
        left: this.position.left - deltaX
      })
    }
  }

  this.onMouseUp = function () {
    this.carouselTrack.removeEventListener('mousemove', this.onMouseMove)
    this.carouselTrack.removeEventListener('mouseleave', this.onMouseUp)

    // FF and Chrome process differently snapping
    if (this.isFirefox) {
      clearTimeout(this.transitionFallbackTimer)
      this.waitForTransitionEnd(
        function () {
          return this.carouselTrack.classList.remove(this.stylesClass.grabbing)
        }.bind(this)
      )
    } else {
      this.carouselTrack.classList.remove(this.stylesClass.grabbing)
    }

    switch (true) {
      case this.delta < -this.EDGE_RESISTANCE:
        this.scrollToNextPage()
        break

      case this.delta > this.EDGE_RESISTANCE:
        this.scrollToPrevPage()
        break

      case this.isMouseMoved:
        // is used drag beyond resistance threshold and this is not click
        this.scrollToPage(this.getCurrentPageIndex())
        break
    }

    this.delta = 0
    this.isMouseMoved = false
  }

  this.waitForTransitionEnd = function (callback) {
    var onEnd = function () {
      clearTimeout(this.transitionFallbackTimer)
      callback()
    }.bind(this)

    this.transitionFallbackTimer = setTimeout(onEnd, 800)
  }

  // Destroy

  this.destroy = function () {
    this.removeEventListeners()
    this.removePaginationEventListeners()
    this.destroyArrows()
    this.destroyPagination()
    clearTimeout(this.transitionFallbackTimer)
  }
}


/*!
 * jquery.zoom.min.js
 */
/*!
	Zoom 1.7.21
	license: MIT
	http://www.jacklmoore.com/zoom

	PS - modifications made, adding zoom.off function
*/
!(function (d) {
  var e = {
    url: !1,
    callback: !1,
    target: !1,
    duration: 120,
    on: 'mouseover',
    touch: !0,
    onZoomIn: !1,
    onZoomOut: !1,
    magnify: 1
  }
  ;(d.zoom = function (o, t, n, e) {
    var i,
      u,
      c,
      a,
      r,
      m,
      l,
      s = d(o),
      f = s.css('position'),
      h = d(t)
    return (
      (o.style.position = /(absolute|fixed)/.test(f) ? f : 'relative'),
      (o.style.overflow = 'hidden'),
      (n.style.width = n.style.height = ''),
      d(n)
        .addClass('zoomImg')
        .css({
          position: 'absolute',
          top: 0,
          left: 0,
          opacity: 0,
          width: n.width * e,
          height: n.height * e,
          border: 'none',
          maxWidth: 'none',
          maxHeight: 'none'
        })
        .appendTo(o),
      {
        init: function () {
          ;(u = s.outerWidth()),
            (i = s.outerHeight()),
            (c = t === o ? ((a = u), i) : ((a = h.outerWidth()), h.outerHeight())),
            (r = (n.width - u) / a),
            (m = (n.height - i) / c),
            (l = h.offset())
        },
        move: function (o) {
          var t = o.pageX - l.left,
            o = o.pageY - l.top,
            o = Math.max(Math.min(o, c), 0),
            t = Math.max(Math.min(t, a), 0)
          ;(n.style.left = t * -r + 'px'), (n.style.top = o * -m + 'px')
        }
      }
    )
  }),
    (d.fn.zoom = function (n) {
      return this.each(function () {
        var i = d.extend({}, e, n || {}),
          u = (i.target && d(i.target)[0]) || this,
          o = this,
          c = d(o),
          a = document.createElement('img'),
          r = d(a),
          m = 'mousemove.zoom',
          l = !1,
          s = !1
        if (!i.url) {
          var t = o.querySelector('img')
          if ((t && (i.url = t.getAttribute('data-src') || t.currentSrc || t.src), !i.url)) return
        }
        c.one(
          'zoom.destroy',
          function (o, t) {
            c.off('.zoom'), (u.style.position = o), (u.style.overflow = t), (a.onload = null), r.remove()
          }.bind(this, u.style.position, u.style.overflow)
        ),
          c.on(
            'zoom.off',
            function () {
              r.stop().fadeTo(i.duration, 0, !!d.isFunction(i.onZoomOut) && i.onZoomOut.call(a))
            }.bind(this)
          ),
          (a.onload = function () {
            var t = d.zoom(u, o, a, i.magnify)
            function n(o) {
              t.init(),
                t.move(o),
                r.stop().fadeTo(d.support.opacity ? i.duration : 0, 1, !!d.isFunction(i.onZoomIn) && i.onZoomIn.call(a))
            }
            function e() {
              r.stop().fadeTo(i.duration, 0, !!d.isFunction(i.onZoomOut) && i.onZoomOut.call(a))
            }
            'grab' === i.on
              ? c.on('mousedown.zoom', function (o) {
                  1 === o.which &&
                    (d(document).one('mouseup.zoom', function () {
                      e(), d(document).off(m, t.move)
                    }),
                    n(o),
                    d(document).on(m, t.move),
                    o.preventDefault())
                })
              : 'click' === i.on
              ? c.on('click.zoom', function (o) {
                  if (!l)
                    return (
                      (l = !0),
                      n(o),
                      d(document).on(m, t.move),
                      d(document).one('click.zoom', function () {
                        e(), (l = !1), d(document).off(m, t.move)
                      }),
                      !1
                    )
                })
              : 'toggle' === i.on
              ? c.on('click.zoom', function (o) {
                  l ? e() : n(o), (l = !l)
                })
              : 'mouseover' === i.on && (t.init(), c.on('mouseenter.zoom', n).on('mouseleave.zoom', e).on(m, t.move)),
              i.touch &&
                c
                  .on('touchstart.zoom', function (o) {
                    o.preventDefault(),
                      s
                        ? ((s = !1), e())
                        : ((s = !0), n(o.originalEvent.touches[0] || o.originalEvent.changedTouches[0]))
                  })
                  .on('touchmove.zoom', function (o) {
                    o.preventDefault(), t.move(o.originalEvent.touches[0] || o.originalEvent.changedTouches[0])
                  })
                  .on('touchend.zoom', function (o) {
                    o.preventDefault(), s && ((s = !1), e())
                  }),
              d.isFunction(i.callback) && i.callback.call(a)
          }),
          a.setAttribute('role', 'presentation'),
          (a.alt = ''),
          (a.src = i.url)
      })
    }),
    (d.fn.zoom.defaults = e)
})(window.jQuery)


// Attempts to preserve comments that likely contain licensing information,
// even if the comment does not have directives such as `@license` or `/*!`.
//
// Implemented via the [`uglify-save-license`](https://github.com/shinnn/uglify-save-license)
// module, this option preserves a comment if one of the following is true:
//
// 1. The comment is in the *first* line of a file
// 2. A regular expression matches the string of the comment.
//    For example: `MIT`, `@license`, or `Copyright`.
// 3. There is a comment at the *previous* line, and it matches 1, 2, or 3.
